(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
}((function () { 'use strict';

    var utils = {
        /**
         * Get parent element matching selector
         * 
         * @param {Element} $el 
         * @param {string} selector
         */
        getParent: function getParent($el, selector) {
            for ( ; $el && $el !== document; $el = $el.parentNode) {
                if ($el.matches(selector)) {
                    return $el;
                }
            }

            return null;
        },

        /**
         * Add leading zero to number
         * 
         * @param {int|string} number 
         * @param {int} length 
         */
        pad: function pad(number, length) {
            var str = '' + number;
            while (str.length < length) {
                str = '0' + str;
            }

            return str;
        },

        /**
         * Replace line break by HTML break
         * 
         * @param {string} str 
         */
        nl2br: function nl2br(str) {
            return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>');
        },

        /**
         * Get the transition duration of element
         * 
         * @param {Element} $el 
         * @param {boolean} inMS default: true
         */
        getElementTransitionDurationEnd: function getElementTransitionDurationEnd($el, inMS) {
            if (typeof inMS === 'undefined') {
                inMS = true;
            }

            var computedStyles = window.getComputedStyle($el);

            var duration = computedStyles.transitionDuration.split(',').map(function (n) { return parseFloat(n); }).filter(function (a, b) { return b > a; }).shift();

            return duration * (inMS ? 1000 : 1);
        },

        /**
         * Execute function at transition end
         * 
         * @param {Element} $el 
         * @param {CallableFunction} fn 
         */
        onTransitionEnd: function onTransitionEnd($el, fn) {
            var computedStyles = window.getComputedStyle($el);

            var duration = 0;

            if (computedStyles.transitionDuration !== '0s') {
                duration = computedStyles.transitionDuration.split(',').map(function (n) { return parseFloat(n); });
                duration = Math.max.apply(Math, duration);
            }

            if (duration) {
                setTimeout(function () {
                    fn($el);
                }, (duration * 1000) + 1);
            } else {
                fn($el);
            }
        },

        /**
         * Convert string to Element
         * 
         * @param {String} html HTML representing a single element
         * 
         * @return {Element}
         */
        htmlToElement: function htmlToElement(html) {
            var template = document.createElement('template');
            html = html.trim();
            template.innerHTML = html;
            return template.content.firstChild;
        },

        /**
         * Get dimensions of non-existent element in the DOM
         * 
         * @param {Element} $el Non-existent element in the DOM
         * @param {Element} $ref The reference after which $el will be added
         * 
         * @return {DOMRect}
         */
        getDimensionsOfFutureElement: function getDimensionsOfFutureElement($el, $ref) {
            var boundingClientRect = $ref.getBoundingClientRect();
            
            $el.setAttribute('aria-hidden', false);
            $el.style.position = 'fixed';
            $el.style.zIndex = '-1';
            $el.style.width = boundingClientRect.width + 'px';
            $el.style.opacity = '0';
            $el.style.visibility = 'hidden';

            $el = $ref.parentNode.insertBefore($el, $ref.nextElementSibling);

            var elementBoudingClientRect = $el.getBoundingClientRect();
            $el.remove();

            return elementBoudingClientRect;
        },

        /**
         * Fetch url
         * 
         * @param {string} url 
         * @param {string} method POST or GET
         * @param {Object} params 
         * 
         * @return {Object} Object with promise and xhr
         */
        sendHTTPRequest: function sendHTTPRequest(obj) {
            var this$1 = this;

            var xhr = new XMLHttpRequest();

            var promise = new Promise(function (resolve, reject) {
                xhr.open(obj.method || 'GET', obj.url);
                if (obj.headers) {
                    Object.keys(obj.headers).forEach(function (key) {
                        xhr.setRequestHeader(key, obj.headers[key]);
                    });
                }
                xhr.onload = function () {
                    if (xhr.status >= 200 && xhr.status < 300) {
                        resolve(JSON.parse(xhr.response));
                    } else {
                        reject(xhr.statusText);
                    }
                };
                xhr.onerror = function () { return reject(xhr.statusText); };

                var params = obj.body || {};
                var formData = new FormData();

                this$1.buildFormData(formData, params);

                xhr.send(formData);
            });

            return {
                promise: promise,
                xhr: xhr,
            };
        },

        /**
         * Convert Object to FormData
         * 
         * @param {FormData} formData 
         * @param {Object} data 
         * @param {string} parentKey 
         */
        buildFormData: function buildFormData(formData, data, parentKey) {
            var this$1 = this;

            if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
                Object.keys(data).forEach(function (key) {
                    this$1.buildFormData(formData, data[key], parentKey ? (parentKey + "[" + key + "]") : key);
                });
            } else {
                var value = data === null ? '' : data;
            
                formData.append(parentKey, value);
            }
        },

        /**
         * Add CSS classes to hide and show element with animation
         * CSS classes: animation-hide, animation-show, hide
         * Options:
         *      hide {boolean} Enable/disable the hidding class (default: false)
         *      show {boolean} Enable/disable the showing class (default: false)
         *      attr {Object} Attribute to pass to callbacks
         *      afterHide {CallableFunction} Function fired after element disappear
         *      afterShow {CallableFunction} Function fired after element appear
         * 
         * @param {Element} $el Element to change
         * @param {Object} options Object of options
         */
        changeWithCSSAnimation: function changeWithCSSAnimation($el, options) {
            options.hide = typeof options.hide === 'undefined' || (typeof options.hide === 'boolean' && options.hide === true);
            options.show = typeof options.show === 'undefined' || (typeof options.show === 'boolean' && options.show === true);
            options.attr = typeof options.attr === 'object' ? options.attr : {};

            if (options.hide) {
                $el.classList.add('animation-hide');
            }

            utils.onTransitionEnd($el, function ($el) {
                if (options.hide) {
                    $el.classList.add('hide');
                    $el.classList.remove('animation-hide');

                    if (typeof options.afterHide === 'function') {
                        options.afterHide($el, options.attr);
                    }
                }

                if (options.show) {
                    $el.classList.add('animation-show');

                    utils.onTransitionEnd($el, function () {
                        $el.classList.remove('hide', 'animation-show');

                        if (typeof options.afterShow === 'function') {
                            options.afterShow($el, options.attr);
                        }
                    });
                }
            });
        }
    };

    var Registration = {
        els: {
            form: {
                $wrapper: null,
                rpps_error: null,
                rpps: null,
                first_name: null,
                last_name: null,
                postal_code: null,
                department: null,
                phone_label: null,
                password: null,
                show_button: null
            },
        },
        view_password_str: 'Voir le mot de passe',
        hide_password_str: 'Masquer le mot de passe',
        init: function init() {
            this.els.form.$wrapper = document.querySelector('#registration_form');
            if (this.els.form.$wrapper) {

                // Add HTML to form
                var target = document.querySelector('.elementor-field-group-password');

                target.insertAdjacentHTML('afterend', this.getPasswordVerificationHtmlContent());
                target.insertAdjacentHTML('afterend', this.getShowPasswordButtonHtmlContent());

                this.els.form.rpps = document.getElementById('form-field-rpps');
                this.els.form.rpps_error = document.getElementById('rpps-error-message').querySelector('p');
                this.els.form.rpps_error.style.display = 'none';
                this.els.form.first_name = document.getElementById('form-field-firstname');
                this.els.form.last_name = document.getElementById('form-field-lastname');

                this.els.form.password = document.getElementById('form-field-password');
                this.els.form.show_button = document.getElementById('togglePW');

                this.els.form.postal_code = document.getElementById('form-field-postal_code');
                this.els.form.department = document.getElementById('form-field-department');

                this.els.form.phone_label = document.querySelector('.elementor-field-group-phone label');

                this.initEvents();
            }
        },
        initEvents: function initEvents() {
            var this$1 = this;

            this.els.form.password.addEventListener("keyup", function (e) {
                this$1.getPassword();
            });
            this.els.form.show_button.addEventListener("click", function (e) {
                this$1.togglePassword();
            });

            // Auto-select department based on postal code input
            this.els.form.postal_code.addEventListener('keyup', function (e) {
                this$1.autoSelectDepartment(e.target.value);
            });

            // Add tooltip on phone label
            var phoneDescription = 'Il peut être nécessaire pour vous envoyer un code de sécurité ou vous contacter personnellement afin de vérifier votre identité à l\'issue de votre inscription';
            var labelPhone = this.els.form.phone_label.innerHTML;
            this.els.form.phone_label.innerHTML = labelPhone + '<div class="gw-tooltip"><i class="fas fa-question-circle"></i><span class="tooltip-text">' + phoneDescription + '</span></div>';

            // RPPS check
            this.els.form.rpps.addEventListener("focusout", function (e) {
                var rpps = e.target.value;
                if(rpps) {
                    this$1.getRPPSData(rpps);
                }
            });
        },
        getPasswordVerificationHtmlContent: function getPasswordVerificationHtmlContent() {
            return '<div class="elementor-field-group elementor-column elementor-col-100 password-verification">\n' +
                '          <h4 class="display-4">Votre mot de passe contient :</h4>\n' +
                '          <ul class="lead list-group" id="requirements">\n' +
                '            <li id="password-length" class="list-group-item">Au moins 8 caractères</li>\n' +
                '            <li id="password-uppercase" class="list-group-item">Au moins une majuscule</li>\n' +
                '            <li id="password-number" class="list-group-item">Au moins un chiffre</li>\n' +
                '            <li id="password-special" class="list-group-item">Au moins un caractère spécial</li>\n' +
                '          </ul>\n' +
                '        </div>';
        },
        getShowPasswordButtonHtmlContent: function getShowPasswordButtonHtmlContent() {
            return '<div class="elementor-field-group elementor-column elementor-col-50">\n' +
                '          <button\n' +
                '            id="togglePW"\n' +
                '            class="show-password btn btn-secondary"\n' +
                '            type="button"\n' +
                '            style="cursor:pointer;"\n' +
                '            ">' + this.view_password_str + '</button>\n' +
                '        </div>';
        },
        getPassword: function getPassword() {
            var text = this.els.form.password.value;
            var length = document.getElementById('password-length');
            var uppercase = document.getElementById('password-uppercase');
            var number = document.getElementById('password-number');
            var special = document.getElementById('password-special');

            this.checkIfEightChar(text) ? length.classList.add('list-group-item-success') : length.classList.remove('list-group-item-success');
            this.checkIfOneUppercase(text) ? uppercase.classList.add('list-group-item-success') : uppercase.classList.remove('list-group-item-success');
            this.checkIfOneDigit(text) ? number.classList.add('list-group-item-success') : number.classList.remove('list-group-item-success');
            this.checkIfOneSpecialChar(text) ? special.classList.add('list-group-item-success') : special.classList.remove('list-group-item-success');
        },
        checkIfEightChar: function checkIfEightChar(text) {
            return text.length >= 8;
        },
        checkIfOneUppercase: function checkIfOneUppercase(text) {
            return /[A-Z]/.test(text);
        },
        checkIfOneDigit: function checkIfOneDigit(text) {
            return /[0-9]/.test(text);
        },
        checkIfOneSpecialChar: function checkIfOneSpecialChar(text) {
            return /[~`!#$%@\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(text);
        },
        togglePassword: function togglePassword() {
            var passInput = this.els.form.password;
            var togglePW = document.getElementById('togglePW');

            passInput.type === "password" ? passInput.type = "text" : passInput.type = "password";
            togglePW.textContent === this.view_password_str ? togglePW.textContent = this.hide_password_str : togglePW.textContent = this.view_password_str;
        },
        autoSelectDepartment: function autoSelectDepartment(postal_code) {
            for(var i = 0, elems = this.els.form.department, l = elems.length; i < l; i++) {
                elems[i].selected = elems[i].value == postal_code.substring(0,2);
            }
        },
        getRPPSData: function getRPPSData(rpps) {
            var this$1 = this;

            var ajaxActionName = 'get_rpps_data';
            this.getRequest = utils.sendHTTPRequest({
                url: ajaxurl + '?action=' + ajaxActionName + '&rpps=' + rpps,
            });

            this.getRequest.promise.then(function (response) {
                if (!response.success) {
                    console.error(response.errorMessage);
                    this$1.els.form.rpps_error.innerHTML = response.errorMessage;
                    this$1.els.form.rpps_error.style.display = 'block';
                    this$1.els.form.rpps.value = ''; // Empty RPPS field
                } else {
                    // Auto fill fields with data
                    this$1.els.form.first_name.value = response.first_name;
                    this$1.els.form.last_name.value = response.last_name;
                    this$1.els.form.postal_code.value = response.postal_code;
                    this$1.autoSelectDepartment(this$1.els.form.postal_code.value);
                    this$1.els.form.rpps_error.style.display = 'none';
                }
                this$1.getRequest = null;
            }).catch(function (error) {
                console.error(error);
                this$1.getRequest = null;
            });
        }
    };

    var Settings = {
        els: {
            $wrapper: null,

            form: {
                $wrapper: null,
                entry_mode_choice: {
                    $daily: null,
                    $weekly: null,
                },
            },

            modale: {
                $validate: null,
            },
        },
        loading: 0,
        userId: null,
        entry_mode: null,
        dashboard_url: null,
        history: {
            entry_mode: null,
        },
        saveRequest: null,

        init: function init() {
            if (typeof settings_options !== 'undefined') {
                this.els.$wrapper = document.querySelector('.js-settings');

                if (this.els.$wrapper) {
                    // Datas
                    this.userId = settings_options.user_id;
                    this.entry_mode = settings_options.entry_mode;
                    this.history.entry_mode = settings_options.entry_mode;
                    this.dashboard_url = settings_options.dashboard_url;

                    // Form
                    this.els.form.$wrapper = this.els.$wrapper.querySelector('#settingsData');

                    // Choice radio
                    this.els.form.entry_mode_choice.$daily = this.els.$wrapper.querySelector('.js-settings-input-entry-mode-choice-daily');
                    this.els.form.entry_mode_choice.$weekly = this.els.$wrapper.querySelector('.js-settings-input-entry-mode-choice-weekly');

                    // Modale
                    this.els.modale.$validate = this.els.$wrapper.querySelector('.js-settings-validation-modale');

                    this.initEvents();
                }
            }
        },

        initEvents: function initEvents() {
            this.inputEvents();
            this.formEvent();
        },

        inputEvents: function inputEvents () {
            var this$1 = this;

            this.els.form.entry_mode_choice.$daily.addEventListener('click', function (e) {
                if (this$1.els.form.entry_mode_choice.$daily.checked) {
                    this$1.entry_mode = 'daily';
                }
            });
            this.els.form.entry_mode_choice.$weekly.addEventListener('click', function (e) {
                if (this$1.els.form.entry_mode_choice.$weekly.checked) {
                    this$1.entry_mode = 'weekly';
                }
            });
        },

        formEvent: function formEvent() {
            var this$1 = this;

            this.els.form.$wrapper.addEventListener('submit', function (e) {
                e.preventDefault();
                if (!this$1.history.entry_mode) { // Registration process : entry mode still empty
                    this$1.saveData();
                } else if (this$1.entry_mode == this$1.history.entry_mode) {
                    this$1.setLoading(true);
                    window.location = this$1.dashboard_url;
                } else { // Entry mode change
                    this$1.displayValidationModale();
                }
            });
        },

        /**
         * Save data with ajax call
         *
         * @param {number} change_mode 0 or 1
         */
        saveData: function saveData(change_mode) {
            var this$1 = this;
            if ( change_mode === void 0 ) change_mode = 0;

            this.setLoading(true);

            if (this.els.form.entry_mode_choice.$daily.checked) {
                this.entry_mode = 'daily';
            } else {
                this.entry_mode = 'weekly';
            }

            this.saveRequest = utils.sendHTTPRequest({
                url: ajaxurl,
                method: 'POST',
                body: {
                    action: 'save_settings_data',
                    params: JSON.stringify({
                        user_id: this.userId,
                        entry_mode: this.entry_mode,
                        change_mode: change_mode
                    }),
                },
            });

            this.saveRequest.promise.then(function (response) {
                if (!response.success) {
                    console.error(response.errorMessage);
                }
                this$1.saveRequest = null;
                window.location = this$1.dashboard_url;
            }).catch(function (error) {
                console.error(error);
                this$1.setLoading(false);
                this$1.saveRequest = null;
            });
        },

        /**
         * Increment or decrement loading
         *
         * @param {boolean} increment
         */
        setLoading: function setLoading(increment) {
            this.loading = increment ? this.loading + 1 : this.loading - 1;

            if (this.loading > 0 && !this.els.$wrapper.classList.contains('loading')) {
                this.els.$wrapper.classList.add('loading');
            } else if (this.loading === 0) {
                this.els.$wrapper.classList.remove('loading');
            }
        },

        /**
         * Display a modale asking if user wants to validate his data
         */
        displayValidationModale: function displayValidationModale() {
            var this$1 = this;

            this.els.modale.$validate.setAttribute('aria-hidden', false);

            utils.changeWithCSSAnimation(this.els.modale.$validate, {
                hide: false,
            });

            var $closeModaleBtns = this.els.modale.$validate.querySelectorAll('.js-modale-close');
            var closeCallback = null;
            Array.prototype.forEach.call($closeModaleBtns, function ($closeModaleBtn) {
                closeCallback = function () {
                    utils.changeWithCSSAnimation(this$1.els.modale.$validate, {
                        show: false,
                        afterHide: function ($el) {
                            $el.setAttribute('aria-hidden', true);

                            $closeModaleBtn.removeEventListener('click', closeCallback);
                        },
                    });
                };

                $closeModaleBtn.addEventListener('click', closeCallback);
            });

            var $validateBtn = this.els.modale.$validate.querySelector('.js-settings-validation-btn');
            var validateCallback = function () {
                closeCallback();
                this$1.saveData(1);
            };
            $validateBtn.addEventListener('click', validateCallback);
        },
    };

    var MissingData = {
        els: {
            $wrapper: null,

            form: {
                $wrapper: null,
                $missing_days: null,
                $message: null
            },

            $suspected_patients_wrappers: [],
            $suspected_patients_inputs: [],
            $patients_wrappers: [],
            $patients_inputs: [],
            $no_consultation_inputs: [],

            $no_consultation_values: [],

            modale: {
                $validate: null,
            },
        },
        loading: 0,
        userId: null,
        saveRequest: null,

        init: function init() {
            if (typeof missing_data_options !== 'undefined') {
                this.els.$wrapper = document.querySelector('.js-missing-data');

                if (this.els.$wrapper) {
                    // Datas
                    this.userId = missing_data_options.user_id;

                    // Form
                    this.els.form.$wrapper = this.els.$wrapper.querySelector('#missingData');
                    this.els.form.$message = this.els.$wrapper.querySelector('.missing-data-center-block-form-message');

                    // Missing days
                    this.els.form.$missing_days = this.els.$wrapper.querySelectorAll('.missing-day');

                    // Modale
                    this.els.modale.$validate = this.els.$wrapper.querySelector('.js-missing-data-validation-modale');

                    this.initEvents();
                }
            }
        },

        initEvents: function initEvents() {
            var this$1 = this;

            this.inputEvents();

            this.els.form.$wrapper.addEventListener('submit', function (e) {
                e.preventDefault();
                this$1.displayValidationModale();
            });
        },

        inputEvents: function inputEvents () {
            var this$1 = this;

            this.els.form.$missing_days.forEach(function ($missingDay) {
                var index = $missingDay.getAttribute('data-missing-day-index');

                this$1.els.$suspected_patients_wrappers[index] = $missingDay.querySelector('.group-suspected-patients');
                this$1.els.$suspected_patients_inputs[index] = $missingDay.querySelector('.suspected-patients');
                this$1.els.$patients_wrappers[index] = $missingDay.querySelector('.group-patients');
                this$1.els.$patients_inputs[index] = $missingDay.querySelector('.patients');
                this$1.els.$no_consultation_inputs[index] = $missingDay.querySelector('.js-missing-data-input-no-consultation');
                this$1.els.$no_consultation_values[index] = this$1.els.$no_consultation_inputs[index].checked ? 1 : 0;

                this$1.els.$suspected_patients_inputs[index].addEventListener('change', function (e) {
                    this$1.changeInput(index);
                });
                this$1.els.$patients_inputs[index].addEventListener('change', function (e) {
                    this$1.changeInput(index);
                });

                this$1.els.$no_consultation_inputs[index].addEventListener('click', function (e) {
                    if (this$1.els.$no_consultation_inputs[index].checked && !this$1.els.$no_consultation_values[index]) {
                        this$1.els.$suspected_patients_inputs[index].value = 0;
                        this$1.els.$patients_inputs[index].value = 0;
                        this$1.els.$suspected_patients_inputs[index].readOnly = true;
                        this$1.els.$patients_inputs[index].readOnly = true;
                        this$1.els.$suspected_patients_wrappers[index].classList.add('disabled');
                        this$1.els.$patients_wrappers[index].classList.add('disabled');
                        this$1.els.$no_consultation_values[index] = true;
                    } else if (this$1.els.$no_consultation_values[index]) {
                        this$1.els.$suspected_patients_inputs[index].readOnly = false;
                        this$1.els.$patients_inputs[index].readOnly = false;
                        this$1.els.$suspected_patients_wrappers[index].classList.remove('disabled');
                        this$1.els.$patients_wrappers[index].classList.remove('disabled');
                        this$1.els.$no_consultation_values[index] = false;
                    }
                });
            });
        },

        changeInput: function changeInput(index) {
            if(this.els.$patients_inputs[index].value == "") {
                this.els.$patients_inputs[index].value = 0;
            }
            if(this.els.$suspected_patients_inputs[index].value == "") {
                this.els.$suspected_patients_inputs[index].value = 0;
            }
            // If suspected patients > patients : update patient number
            if(parseInt(this.els.$suspected_patients_inputs[index].value) > parseInt(this.els.$patients_inputs[index].value)) {
                this.els.$patients_inputs[index].value = this.els.$suspected_patients_inputs[index].value;
            }
        },

        validateForm: function validateForm() {

        },

        /**
         * Save data with ajax call
         *
         */
        saveData: function saveData() {
            var this$1 = this;

            this.setLoading(true);

            var missing_days_data = [];

            this.els.form.$missing_days.forEach(function ($missingDay) {
                var index = $missingDay.getAttribute('data-missing-day-index');
                var date_str = $missingDay.getAttribute('data-missing-day-date');

                var missing_days_item = {
                    number_of_suspected_patients: parseInt(this$1.els.$suspected_patients_inputs[index].value),
                    number_of_patients: parseInt(this$1.els.$patients_inputs[index].value),
                    entry_date: date_str
                };

                missing_days_data.push(missing_days_item);
            });

            this.saveRequest = utils.sendHTTPRequest({
                url: ajaxurl,
                method: 'POST',
                body: {
                    action: 'save_missing_days_data',
                    params: JSON.stringify({
                        user_id: this.userId,
                        missing_days_data: missing_days_data
                    }),
                },
            });

            this.saveRequest.promise.then(function (response) {
                if (!response.success) {
                    console.error(response.errorMessage);
                    this$1.els.form.$message.classList.add('error');
                    this$1.els.form.$message.innerHTML = response.errorMessage;
                } else {
                    this$1.els.form.$message.classList.add('success');
                    this$1.els.form.$message.innerHTML = response.successMessage;
                    this$1.els.form.$missing_days.forEach(function ($missingDay) {
                        $missingDay.style.display = 'none';
                    });
                    this$1.els.$wrapper.querySelector('button').style.display = 'none';
                }

                this$1.setLoading(false);
                this$1.saveRequest = null;
            }).catch(function (error) {
                console.error(error);
                this$1.setLoading(false);
                this$1.saveRequest = null;
            });
        },

        /**
         * Increment or decrement loading
         *
         * @param {boolean} increment
         */
        setLoading: function setLoading(increment) {
            this.loading = increment ? this.loading + 1 : this.loading - 1;

            if (this.loading > 0 && !this.els.$wrapper.classList.contains('loading')) {
                this.els.$wrapper.classList.add('loading');
            } else if (this.loading === 0) {
                this.els.$wrapper.classList.remove('loading');
            }
        },

        /**
         * Display a modale asking if user wants to validate his data
         */
        displayValidationModale: function displayValidationModale() {
            var this$1 = this;

            this.els.modale.$validate.setAttribute('aria-hidden', false);

            utils.changeWithCSSAnimation(this.els.modale.$validate, {
                hide: false,
            });

            var $closeModaleBtns = this.els.modale.$validate.querySelectorAll('.js-modale-close');
            var closeCallback = null;
            Array.prototype.forEach.call($closeModaleBtns, function ($closeModaleBtn) {
                closeCallback = function () {
                    utils.changeWithCSSAnimation(this$1.els.modale.$validate, {
                        show: false,
                        afterHide: function ($el) {
                            $el.setAttribute('aria-hidden', true);

                            $closeModaleBtn.removeEventListener('click', closeCallback);
                        },
                    });
                };

                $closeModaleBtn.addEventListener('click', closeCallback);
            });

            var $validateBtn = this.els.modale.$validate.querySelector('.js-missing-data-validation-btn');
            var validateCallback = function () {
                closeCallback();
                this$1.saveData(1);
            };
            $validateBtn.addEventListener('click', validateCallback);
        },
    };

    var Charts = {
        els: {
            $wrapper: null,
            $container_indicators: null,
            $chart_ira_fra: null,
            $chart_gastro_fra: null,
            $chart_varicelle_fra: null,
            $chart_bronchio_fra: null,
            $chart_ira_naq: null,
            $chart_gastro_naq: null,
            $chart_varicelle_naq: null,
            $chart_bronchio_naq: null,
        },

        dataUrls: {
            'ira-fra': 'https://www.sentiweb.fr/upload/medvigie/hist-ira-fra.json',
            'gastro-fra': 'https://www.sentiweb.fr/upload/medvigie/hist-gastro-fra.json',
            'varicelle-fra': 'https://www.sentiweb.fr/upload/medvigie/hist-varicelle-fra.json',
            'bronchio-fra': 'https://www.sentiweb.fr/upload/medvigie/hist-bronchio-fra.json',
            'ira-naq': 'https://www.sentiweb.fr/upload/medvigie/hist-ira-naq.json',
            'gastro-naq': 'https://www.sentiweb.fr/upload/medvigie/hist-gastro-naq.json',
            'varicelle-naq': 'https://www.sentiweb.fr/upload/medvigie/hist-varicelle-naq.json',
        },

        init: function init() {
            this.els.$wrapper = document.querySelector('#container-indicators');
            this.els.$container_indicators = this.els.$wrapper;

            this.els.$chart_ira_fra = document.getElementById('chart-ira-fra');
            this.els.$chart_gastro_fra = document.getElementById('chart-gastro-fra');
            this.els.$chart_varicelle_fra = document.getElementById('chart-varicelle-fra');
            this.els.$chart_bronchio_fra = document.getElementById('chart-bronchio-fra');
            this.els.$chart_ira_naq = document.getElementById('chart-ira-naq');
            this.els.$chart_gastro_naq = document.getElementById('chart-gastro-naq');
            this.els.$chart_varicelle_naq = document.getElementById('chart-varicelle-naq');

            this.initCharts();
        },

        initCharts: function initCharts() {
            if (this.els.$container_indicators) {
                this.initChartIndicators();
            }


            this.initMultipleCharts([
                {key: 'ira-fra', container: this.els.$chart_ira_fra},
                {key: 'gastro-fra', container: this.els.$chart_gastro_fra},
                {key: 'varicelle-fra', container: this.els.$chart_varicelle_fra},
                {key: 'bronchio-fra', container: this.els.$chart_bronchio_fra},
                {key: 'ira-naq', container: this.els.$chart_ira_naq},
                {key: 'gastro-naq', container: this.els.$chart_gastro_naq},
                {key: 'varicelle-naq', container: this.els.$chart_varicelle_naq},
                {key: 'bronchio-naq', container: this.els.$chart_bronchio_naq} ]);
        },

        initMultipleCharts: function initMultipleCharts(charts) {
            var this$1 = this;

            charts.forEach(function (chart) {
                if (chart.container) {
                    this$1.initChartFromUrl(chart.key, chart.container);
                }
            });
        },

        initChartFromUrl: function initChartFromUrl(key, container) {
            var this$1 = this;

            var url = this.dataUrls[key];
            if (!url) {
                console.error(("URL non définie pour la clé: " + key));
                return;
            }

            fetch(url)
                .then(function (response) {
                    if (!response.ok) {
                        throw new Error(("Erreur de chargement des données pour " + key));
                    }
                    return response.json();
                })
                .then(function (data) {
                    var title = this$1.getChartTitle(key);
                    var subtitle = this$1.getChartSubtitle(key);
                    this$1.createHighcharts(container.id, title, subtitle, data);
                })
                .catch(function (error) {
                    console.error(error);
                    if (container) {
                        container.innerHTML = "<p style=\"color:red;\">Erreur de chargement des données pour " + key + ".</p>";
                    }
                });
        },

        getChartTitle: function getChartTitle(key) {
            var ref = key.split('-');
            var type = ref[0];
            var typeLabel = "";
            switch (type) {
                case 'ira':
                    typeLabel = "Infection respiratoire aiguë (IRA)";
                    break;
                case 'gastro':
                    typeLabel = "Gastro";
                    break;
                case 'varicelle':
                    typeLabel = "Varicelle";
                    break;
                case 'bronchio':
                    typeLabel = "Bronchiolite, chez les enfants de moins de 2 ans";
                    break;
                default:
                    typeLabel = "Taux d'incidence";
            }

            return typeLabel;
        },

        getChartSubtitle: function getChartSubtitle(key) {
            var ref = key.split('-');
            var type = ref[0];
            var subtitleLabel = "";
            switch (type) {
                case 'ira':
                    subtitleLabel = 'Source : <a href="https://www.sentiweb.fr" target="_blank" rel="noopener noreferrer" style="color:#1267a8;">Sentinelles</a> et IQVIA (EMR)';
                    break;
                case 'gastro':
                    subtitleLabel = 'Source : <a href="https://www.sentiweb.fr" target="_blank" rel="noopener noreferrer" style="color:#1267a8;">Sentinelles</a> et IQVIA (EMR)';
                    break;
                case 'varicelle':
                    subtitleLabel = 'Source : <a href="https://www.sentiweb.fr" target="_blank" rel="noopener noreferrer" style="color:#1267a8;">Sentinelles</a> et IQVIA (EMR)';
                    break;
                case 'bronchio':
                    subtitleLabel = "Source : IQVIA (EMR)";
                    break;
                default:
                    subtitleLabel = "";
            }

            return subtitleLabel;
        },

        createHighcharts: function createHighcharts(containerId, titleText, subtitleText, data) {
            Highcharts.chart(containerId, {
                exporting: {
                    buttons: {
                        contextButton: {
                            symbolStroke: '#343434',
                            menuItems: [
                                'downloadPNG',
                                'downloadJPEG',
                                'downloadPDF',
                                'downloadSVG',
                                'separator',
                                'printChart'
                            ],
                            symbol: 'menu',
                            theme: {
                                fill: 'transparent',
                            }
                        }
                    },
                },
                title: {
                    text: titleText,
                    align: 'left',
                    style: {color: '#343434', fontWeight: '600', fontSize: '21px'},
                    margin: 20
                },
                subtitle: {
                    text: subtitleText,
                    style: {color: 'red st', fontWeight: '300', fontSize: '12px'},
                    align: 'left',
                    margin: 40
                },
                chart: {
                    backgroundColor: 'transparent',
                    height: 400
                },
                xAxis: {
                    title: {
                        text: "Semaine de l'année",
                        style: {color: '#343434'},
                    },
                    crosshair: true,
                    type: 'category',
                    labels: {
                        style: {color: '#343434'},
                    }
                },
                yAxis: {
                    title: {
                        text: "Cas pour 100 000 habitants",
                        style: {color: '#343434'},
                    },
                    labels: {
                        style: {color: '#343434'},
                    }
                },
                tooltip: {
                    crosshairs: true,
                    shared: true,
                },
                data: {
                    rows: data,
                    seriesMapping: [
                        {x: 0, low: 2, high: 3},
                        {x: 0, low: 4, high: 5},
                        {x: 0, y: 1}
                    ],
                    complete: function (options) {
                        options.series[0].name = 'Min/MAX';
                        options.series[1].name = 'Q1/Q3';
                        options.series[2].name = 'Saison en cours';
                    }
                },
                plotOptions: {
                    series: {
                        label: {
                            connectorAllowed: false
                        },
                        marker: {
                            enabled: false
                        }
                    }
                },
                series: [
                    {
                        type: 'arearange',
                        color: '#FF0000',
                        fillOpacity: 0.3
                    },
                    {
                        type: 'arearange',
                        color: '#FFA500',
                        fillOpacity: 0.3
                    },
                    {
                        type: 'spline',
                        lineWidth: 3,
                        color: 'steelblue'
                    }
                ],
                responsive: {
                    rules: [{
                        condition: {
                            maxWidth: 800
                        },
                        chartOptions: {
                            legend: {
                                enabled: true
                            }
                        }
                    }]
                }
            });
        },

        initChartIndicators: function initChartIndicators() {
            var this$1 = this;

            fetch(ajaxurl, {
                method: "POST",
                body: new URLSearchParams({action: "get_indicators_graph"})
            })
                .then(function (response) { return response.json(); })
                .then(function (jsonData) {

                    Highcharts.chart(this$1.els.$container_indicators.id, {
                        exporting: {
                            buttons: {
                                contextButton: {
                                    symbolStroke: '#FFFFFF',
                                    menuItems: [
                                        'downloadPNG',
                                        'downloadJPEG',
                                        'downloadPDF',
                                        'downloadSVG',
                                        'separator',
                                        'printChart'
                                    ],
                                    symbol: 'menu',
                                    theme: {
                                        fill: 'transparent',
                                    }
                                }
                            },
                        },
                        chart: {
                            height: 350,
                            type: 'areaspline',
                            backgroundColor: 'transparent'
                        },
                        title: {
                            text: 'Suivi des contributions médecins vigies à la surveillance épidémiologique',
                            align: 'left',
                            style: {color: '#FFFFFF', fontWeight: '600', fontSize: '21px'},
                            margin: 50
                        },
                        subtitle: {
                            text: ''
                        },
                        xAxis: {
                            title: {
                                text: "Semaines",
                                style: {color: '#FFFFFF'},
                            },
                            categories: jsonData.weeks,
                            labels: {
                                style: {color: '#FFFFFF'},
                            },
                            crosshair: true
                        },
                        yAxis: {
                            title: {
                                text: 'Pourcentage (%)',
                                style: {color: '#FFFFFF'},
                            },
                            labels: {
                                format: '{value} %',
                                style: {color: '#FFFFFF'},
                            },
                            max: 100
                        },
                        tooltip: {
                            shared: true,
                            valueSuffix: ' %'
                        },
                        series: jsonData.series,
                        colors: ['#e65f10', '#1167a8', '#16b8be', '#F24F13'],
                        legend: {
                            itemStyle: {
                                color: '#FFFFFF',
                                fontSize: '12px',
                                fontWeight: '300',
                            }
                        },
                    });

                })
                .catch(function (error) {
                    console.error('Erreur AJAX get_indicators_graph:', error);
                });
        }
    };

    var Login = {
        els: {
            $wrapper: null,
            login_container: null,
            password_container: null,
            cms_container: null,
            login_form: {
                $wrapper: null,
                rpps: null,
                rpps_error: null,
            },
            password_form: {
                $wrapper: null,
                password: null,
                password_error: null,
            },
            user_email: null
        },
        init: function init() {
            this.els.$wrapper = document.querySelector('.js-login');
            if (this.els.$wrapper) {
                this.els.login_container = this.els.$wrapper.querySelector('.container-login');
                this.els.password_container = this.els.$wrapper.querySelector('.container-password');
                this.els.cms_container = this.els.$wrapper.querySelector('.container-cms');
                this.els.previous_step = this.els.$wrapper.querySelector('.previous-step');
                this.els.login_form.$wrapper = this.els.$wrapper.querySelector('#loginForm');
                this.els.login_form.rpps = this.els.login_form.$wrapper.querySelector('[name="login"]');
                this.els.login_form.rpps_error = document.getElementById('rpps-error-message').querySelector('p');
                this.els.login_form.rpps_error.style.display = 'none';

                this.els.password_form.$wrapper = this.els.$wrapper.querySelector('#passwordForm');
                this.els.password_form.password = this.els.password_form.$wrapper.querySelector('[name="password"]');
                this.els.password_form.password_error = document.getElementById('password-error-message').querySelector('p');
                this.els.password_form.password_error.style.display = 'none';

                this.initEvents();
            }
        },
        initEvents: function initEvents() {
            var this$1 = this;

            this.els.login_form.$wrapper.addEventListener('submit', function (e) {
                e.preventDefault();
                this$1.loginRPPS();
            });

            this.els.previous_step.addEventListener('click', function (e) {
                this$1.els.login_container.classList.remove('hidden');
                this$1.els.cms_container.classList.remove('hidden');
                this$1.els.password_container.classList.add('hidden');
                this$1.els.previous_step.classList.add('hidden');
            });

            this.els.password_form.$wrapper.addEventListener('submit', function (e) {
                e.preventDefault();
                this$1.loginPassword();
            });

            document.getElementById('toggle-password').addEventListener('click', function () {
                var passwordField = document.getElementById('password');
                var passwordToggleIcon = this.querySelector('img');

                var openEyeIcon = passwordToggleIcon.getAttribute('data-open');
                var closeEyeIcon = passwordToggleIcon.getAttribute('data-close');

                if (passwordField.type === 'password') {
                    passwordField.type = 'text';
                    passwordToggleIcon.src = closeEyeIcon;
                    passwordToggleIcon.alt = "Hide Password";
                } else {
                    passwordField.type = 'password';
                    passwordToggleIcon.src = openEyeIcon;
                    passwordToggleIcon.alt = "Show Password";
                }
            });

            this.els.password_form.password.addEventListener('input', function () {
                var password = this$1.els.password_form.password.value;
                var strength = this$1.getPasswordStrength(password);
                this$1.updatePasswordFeedback(strength);
            });
        },

        /**
         * Increment or decrement loading
         *
         * @param {boolean} increment
         */
        setLoading: function setLoading(increment) {
            this.loading = increment ? this.loading + 1 : this.loading - 1;

            if (this.loading > 0 && !this.els.$wrapper.classList.contains('loading')) {
                this.els.$wrapper.classList.add('loading');
            } else if (this.loading === 0) {
                this.els.$wrapper.classList.remove('loading');
            }
        },

        loginRPPS: function loginRPPS() {
            var this$1 = this;

            this.setLoading(true);

            var rppsValue = this.els.login_form.rpps.value;
            var hasError = false;
            var errorMessage = "";
            if (!rppsValue) {
                hasError = true;
                errorMessage = "Veuillez saisir votre identifiant RPPS";
            } else if (!Number.isInteger(parseInt(rppsValue))) {
                hasError = true;
                errorMessage = "Identifiant RPPS invalide";
            }
            if (hasError) {
                this.displayLoginError(errorMessage);
            } else {
                // Try login
                this.els.login_form.rpps_error.style.display = 'none';
                this.els.login_form.rpps_error.innerHTML = "";
                this.els.login_form.rpps.classList.remove('error');

                this.saveRequest = utils.sendHTTPRequest({
                    url: ajaxurl,
                    method: 'POST',
                    body: {
                        action: 'login_with_rpps',
                        params: JSON.stringify({
                            rpps: rppsValue
                        }),
                    },
                });

                this.saveRequest.promise.then(function (data) {
                    if (!data.response.success) {
                        this$1.displayLoginError(data.response.errorMessage);
                    } else {
                        // Get use case
                        var useCase = data.response.use_case;
                        if (useCase === 'password') {
                            this$1.els.login_container.classList.add('hidden');
                            this$1.els.cms_container.classList.add('hidden');
                            this$1.els.password_container.classList.remove('hidden');
                            this$1.els.previous_step.classList.remove('hidden');
                            this$1.els.user_email = data.response.user_email;
                        } else if (useCase === 'inscription') {
                            window.localStorage.setItem("userData", JSON.stringify(data.response.user_data));
                            window.location.href = "/inscription/";
                        }
                    }
                    this$1.setLoading(false);
                    this$1.saveRequest = null;
                }).catch(function (error) {
                    this$1.displayLoginError(error);
                    this$1.setLoading(false);
                    this$1.saveRequest = null;
                });
            }
        },

        loginPassword: function loginPassword() {
            var this$1 = this;

            this.setLoading(true);

            var passwordValue = this.els.password_form.password.value;
            if (!passwordValue) {
                this.displayPasswordError("Veuillez saisir votre mot de pasee");
            } else {
                // Try login with RPPS and password
                this.saveRequest = utils.sendHTTPRequest({
                    url: ajaxurl,
                    method: 'POST',
                    body: {
                        action: 'login_with_email_and_password',
                        params: JSON.stringify({
                            email: this.els.user_email,
                            password: passwordValue,
                        }),
                    },
                });

                this.saveRequest.promise.then(function (response) {
                    if (!response.success) {
                        this$1.displayPasswordError(response.errorMessage);
                    } else {
                        window.location.href = "/dashboard";
                    }
                    this$1.setLoading(false);
                    this$1.saveRequest = null;
                }).catch(function (error) {
                    this$1.displayPasswordError(error);
                    this$1.setLoading(false);
                    this$1.saveRequest = null;
                });
            }
        },

        displayLoginError: function displayLoginError(message) {
            this.els.login_form.rpps_error.innerHTML = message;
            this.els.login_form.rpps_error.style.display = 'block';
            this.els.login_form.rpps.classList.add('error');
            this.setLoading(false);
        },

        displayPasswordError: function displayPasswordError(message) {
            this.els.password_form.password_error.innerHTML = message;
            this.els.password_form.password_error.style.display = 'block';
            this.els.password_form.password.classList.add('error');
            this.setLoading(false);
        },

        getPasswordStrength: function getPasswordStrength(password) {
            var strength = 0;

            if (password.length < 8) {
                return strength;
            }

            if (/[A-Z]/.test(password)) { strength++; }
            if (/\d/.test(password)) { strength++; }
            if (/[@$!%*?&#]/.test(password)) { strength++; }

            return strength;
        },
        updatePasswordFeedback: function updatePasswordFeedback(strength) {
            // Réinitialisation du message et des classes
            this.els.password_form.password_error.classList.remove('error', 'success');
            this.els.password_form.password_error.textContent = '';
            this.els.password_form.password.classList.remove('input-error', 'input-success'); // Réinitialisation des bordures
            this.els.passwordStrengthBar.className = 'password-strength-bar'; // Réinitialiser la barre de progression
            this.els.passwordStrengthBar.style.width = '0%'; // Réinitialiser la largeur de la barre

            // Sélection des icônes d'erreur et de succès
            var errorIcon = this.els.passwordValidationIcon.querySelector('img[alt="Error"]');
            var successIcon = this.els.passwordValidationIcon.querySelector('img[alt="Success"]');

            // Cache les icônes par défaut
            errorIcon.style.display = 'none';
            successIcon.style.display = 'none';

            // Mot de passe trop court ou Aucun critère validé
            if (this.els.password_form.password.value.length < 8 || strength === 0) {
                this.els.password_form.password_error.textContent = "Le mot de passe doit comporter au moins 8 caractères, une majuscule, un chiffre, et un caractère spécial.";
                this.els.password_form.password_error.classList.add('error');
                this.els.passwordStrengthBar.style.width = '0%'; // Barre vide
                this.els.password_form.password.classList.add('input-error'); // Ajouter la bordure rouge
                errorIcon.style.display = 'block'; // Afficher l'icône rouge
            }

            // Mot de passe valide mais niveau faible
            if (strength === 1) {
                this.els.password_form.password_error.innerHTML = "Niveau de sécurité : <span class=\"password-strength-level\">FAIBLE</span>";
                this.els.password_form.password_error.classList.add('error');
                this.els.passwordStrengthBar.classList.add('low'); // Ajouter la classe "low"
                this.els.passwordStrengthBar.style.width = '33%'; // Remplir la barre à 33%
                this.els.password_form.password.classList.add('input-error'); // Ajouter la bordure rouge
                errorIcon.style.display = 'block'; // Afficher l'icône rouge
            } else if (strength === 2) {
                // Niveau moyen
                this.els.password_form.password_error.innerHTML = "Niveau de sécurité : <span class=\"password-strength-level\">BIEN</span>";
                this.els.password_form.password_error.classList.add('success');
                this.els.passwordStrengthBar.classList.add('medium'); // Ajouter la classe "medium"
                this.els.passwordStrengthBar.style.width = '66%'; // Remplir la barre à 66%
                this.els.password_form.password.classList.add('input-success'); // Ajouter la bordure verte
                successIcon.style.display = 'block'; // Afficher l'icône verte
            } else if (strength >= 3) {
                // Niveau fort
                this.els.password_form.password_error.innerHTML = "Niveau de sécurité : <span class=\"password-strength-level\">TRÈS BIEN</span>";
                this.els.password_form.password_error.classList.add('success');
                this.els.passwordStrengthBar.classList.add('high'); // Ajouter la classe "high"
                this.els.passwordStrengthBar.style.width = '100%'; // Remplir la barre à 100%
                this.els.password_form.password.classList.add('input-success'); // Ajouter la bordure verte
                successIcon.style.display = 'block'; // Afficher l'icône verte
            }
        }
    };

    var modal = {
        modalTitle: '',
        modalText: '',
        modalConfirmText: '',
        modalCancelText: '',
        modalType: '',
        onConfirm: null,
        onCancel: null,

        showModal: function (modalText, modalConfirmText, modalCancelText, onConfirm, onCancel) {
            this.modalText = modalText;
            this.modalConfirmText = modalConfirmText;
            this.modalCancelText = modalCancelText;
            this.onConfirm = onConfirm;
            this.onCancel = onCancel;
            this.renderModal();
        },
        renderModal: function () {
            var this$1 = this;

            var modal = document.createElement('div');
            modal.classList.add('modale');
            modal.innerHTML = "\n            <div class=\"modale-container\">\n                <svg class=\"modale-close\" xmlns=\"http://www.w3.org/2000/svg\" width=\"12.805\" height=\"12.805\" viewBox=\"0 0 12.805 12.805\">\n                  <g id=\"croix\" transform=\"translate(-8.098 -8.098)\">\n                    <line id=\"Ligne_7\" data-name=\"Ligne 7\" x2=\"14.109\" transform=\"translate(9.512 9.512) rotate(45)\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-width=\"2\"/>\n                    <line id=\"Ligne_8\" data-name=\"Ligne 8\" x2=\"14.109\" transform=\"translate(19.488 9.512) rotate(135)\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-width=\"2\"/>\n                  </g>\n                </svg>\n                <div class=\"modale-body\">\n                    <p class=\"modale--title\">" + (this.modalText) + "</p>\n                     <div class=\"modale--buttons\">\n                        <button class=\"modale--buttons-cancel button-main button-big button-stroke-cancel\">" + (this.modalCancelText) + "</button>\n                        <button class=\"modale--buttons-confirm button-main button-big button-fill-primary\">" + (this.modalConfirmText) + "</button>\n                    </div>\n                </div>\n            </div>\n        ";
            document.body.appendChild(modal);

            modal.querySelector('.modale--buttons-confirm').addEventListener('click', function () {
                this$1.closeModal();
                if (this$1.onConfirm) { this$1.onConfirm(); }
            });
            modal.querySelector('.modale--buttons-cancel').addEventListener('click', function () {
                this$1.closeModal();
                if (this$1.onCancel) { this$1.onCancel(); }
            });
            modal.querySelector('.modale-close').addEventListener('click', function () {
                this$1.closeModal();
            });
        },
        showInformationModal: function (modalTitle, modalText, modalConfirmText, modalType, onConfirm) {
            this.modalTitle = modalTitle;
            this.modalText = modalText;
            this.modalConfirmText = modalConfirmText;
            this.onConfirm = onConfirm;
            this.modalType = modalType;
            this.renderInformationModal();
        },
        renderInformationModal: function () {
            var this$1 = this;

            var modal = document.createElement('div');
            modal.classList.add('modale');
            modal.innerHTML = "\n            <div class=\"modale-container information-modale " + (this.modalType) + "\">\n                <svg class=\"modale-close\" xmlns=\"http://www.w3.org/2000/svg\" width=\"12.805\" height=\"12.805\" viewBox=\"0 0 12.805 12.805\">\n                  <g id=\"croix\" transform=\"translate(-8.098 -8.098)\">\n                    <line id=\"Ligne_7\" data-name=\"Ligne 7\" x2=\"14.109\" transform=\"translate(9.512 9.512) rotate(45)\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-width=\"2\"/>\n                    <line id=\"Ligne_8\" data-name=\"Ligne 8\" x2=\"14.109\" transform=\"translate(19.488 9.512) rotate(135)\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-width=\"2\"/>\n                  </g>\n                </svg>\n                <div class=\"modale-body\">\n                    <div class=\"information-title\">\n                        <div class=\"information-icon-container\">\n                            <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"21.362\" height=\"19.009\" viewBox=\"0 0 21.362 19.009\">\n                              <path id=\"Tracé_1711\" data-name=\"Tracé 1711\" d=\"M-.223-.3A1.883,1.883,0,0,1-.037.909,1.78,1.78,0,0,1-.631,1.948a1.678,1.678,0,0,1-1.15.427H-19.594a1.678,1.678,0,0,1-1.15-.427A1.78,1.78,0,0,1-21.338.909,1.883,1.883,0,0,1-21.152-.3l8.906-15.437a1.664,1.664,0,0,1,.946-.8,1.888,1.888,0,0,1,1.225,0,1.664,1.664,0,0,1,.946.8ZM-10.687-3.488a1.644,1.644,0,0,0-1.206.5,1.644,1.644,0,0,0-.5,1.206,1.644,1.644,0,0,0,.5,1.206,1.644,1.644,0,0,0,1.206.5,1.644,1.644,0,0,0,1.206-.5,1.644,1.644,0,0,0,.5-1.206,1.644,1.644,0,0,0-.5-1.206A1.644,1.644,0,0,0-10.687-3.488ZM-12.32-9.611l.3,5.047a.39.39,0,0,0,.13.278.429.429,0,0,0,.315.13H-9.8a.429.429,0,0,0,.315-.13.39.39,0,0,0,.13-.278l.3-5.047a.476.476,0,0,0-.13-.353.429.429,0,0,0-.315-.13h-2.375a.429.429,0,0,0-.315.13A.476.476,0,0,0-12.32-9.611Z\" transform=\"translate(21.368 16.634)\" fill=\"#b2cb02\"/>\n                            </svg>\n                        </div>\n                        <p class=\"modale--title\">" + (this.modalTitle) + "</p>\n                    </div>\n                      <p class=\"modale--text\">" + (this.modalText) + "</p>\n                     <div class=\"modale--buttons\">\n                        <button class=\"modale--buttons-confirm button-main button-big button-fill-secondary-blue\">" + (this.modalConfirmText) + "</button>\n                    </div>\n                </div>\n            </div>\n        ";
            document.body.appendChild(modal);

            modal.querySelector('.modale--buttons-confirm').addEventListener('click', function () {
                this$1.closeModal();
                if (this$1.onConfirm) { this$1.onConfirm(); }
            });
            modal.querySelector('.modale-close').addEventListener('click', function () {
                this$1.closeModal();
            });
        },
        closeModal: function () {
            var modale = document.querySelector('.modale');
            if (modale) {
                modale.remove();
            }
        }
    };

    var Register = {
        els: {
            $wrapper: null,
            inscription_form: {
                $wrapper: null,
                error: null,
            },
            addAddressButton: null,
            addAddressForm: null,
            cancelAddressButton: null,
            confirmAddressButton: null,
            addressesList: null,
            allFormElements: null,
            inputFields: null,
            rppsNumber: null,
            cptsNative: null,
            lastnameInput: null,
            firstnameInput: null,
            emailInput: null,
            phoneInput: null,
            passwordInput: null,
            passwordError: null,
            addressError: null,
            indexSaver: null,
            passwordStrengthBar: null,
            userSpecialty: null
        },
        addresses: [],
        allCpts: [],
        init: function init() {
            var this$1 = this;

            this.els.$wrapper = document.querySelector(".js-register");
            if (this.els.$wrapper) {
                this.setupElements();
                this.bindEvents();

                Promise.all([this.getAllCpts()])
                    .then(function () {
                        this$1.fillFormData();
                        this$1.calculatePercentage();
                    })
                    .catch(function (error) {
                        console.error("Erreur lors de l'initialisation :", error);
                    });

                this.updateProgress(0);
            }
        },
        setupElements: function setupElements() {
            var this$1 = this;

            this.els.addAddressButton = document.querySelector(".add__address__btn");
            this.els.addAddressForm = document.querySelector(".add__address__form");
            this.els.addAddressContainer = document.querySelector(
                ".add__address__container"
            );
            this.els.addressListButton = document.querySelector(
                ".address__list__button"
            );
            this.els.confirmAddressButton = document.querySelector(".confirm-address");
            this.els.addressesList = document.getElementById("addresses-list");
            this.els.allFormElements = document.querySelectorAll(
                "#password, #register button, .register__header, .label__container input, .label__container select, #terms, .label, .rgpd__title, .terms__label, .progress-container"
            );
            this.els.inputFields = document.querySelectorAll(".label__container input, .label__container select, .label__container textarea");
            this.els.terms = document.querySelector("#terms");
            this.els.rppsNumber = document.getElementById("rpps-number");
            this.els.lastnameInput = document.querySelector('[name="lastname"]');
            this.els.firstnameInput = document.querySelector('[name="firstname"]');
            this.els.emailInput = document.querySelector('[name="email"]');
            this.els.passwordInput = document.querySelector('[name="password"]');
            this.els.passwordError = document
                .getElementById("password-error")
                .querySelector("p");
            this.els.passwordValidationIcon = document.getElementById(
                "password-validation-icon"
            );
            this.els.passwordStrengthBar = document.getElementById(
                "password-strength-bar"
            );
            this.els.togglePasswordButton = document.getElementById("toggle-password");
            this.els.cancelAddressButton = document.querySelector(".cancel-button");
            this.els.phoneInput = document.querySelector('[name="phone"]');
            this.els.inscription_form.$wrapper =
                document.getElementById("registerForm");
            this.els.addressError = document
                .getElementById("address-error")
                .querySelector("p");
            this.els.addressError.style.display = "none";
            this.els.inscription_form_error = document
                .getElementById("register-error");
            this.els.inscription_form_error.style.display = "none";
            this.els.passwordError.style.display = "none";
            this.els.addAddressButton = document.querySelector(".add__address__btn");
            document.addEventListener("click", function (event) {
                if (event.target.closest(".address__list__button")) {
                    this$1.showAddAddressForm();
                }
            });
            this.els.cptsInput = document.querySelector("#cptsInput");
            this.els.userSpecialty = document.querySelector("#user__specialty");
        },
        bindEvents: function bindEvents() {
            var this$1 = this;

            this.els.addAddressButton.addEventListener(
                "click",
                this.showAddAddressForm.bind(this)
            );
            this.els.terms.addEventListener("change", function () {
                this$1.calculatePercentage();
            });
            if (this.els.cancelAddressButton) {
                this.els.cancelAddressButton.addEventListener(
                    "click", function (event) {
                        event.preventDefault();
                        this$1.handleAddressChange(event);
                    }
                );
            }
            this.els.confirmAddressButton.addEventListener("click", function (event) {
                event.preventDefault();
                var addressInput =
                    this$1.els.addAddressForm.querySelector("#addressInput").value;
                var postalCodeInput =
                    this$1.els.addAddressForm.querySelector("#postalCodeInput").value;
                var cityInput =
                    this$1.els.addAddressForm.querySelector("#cityInput").value;

                if (addressInput && postalCodeInput && cityInput) {
                    this$1.confirmAddress(event);
                } else {
                    var buttonEffect = this$1.els.$wrapper.querySelector(".confirm-address");
                    buttonEffect.classList.add("vibrate");
                    setTimeout(function () {
                        buttonEffect.classList.remove("vibrate");
                    }, 500);
                    console.error("Address, postal code, and city are required.");
                }
            });

            this.els.inscription_form.$wrapper.addEventListener("submit", function (e) {
                e.preventDefault();
                this$1.inscription();
            });

            this.els.emailInput.addEventListener("change", function () {
                this$1.calculatePercentage();
            });
            this.els.firstnameInput.addEventListener("change", function () {
                this$1.calculatePercentage();
            });
            this.els.lastnameInput.addEventListener("change", function () {
                this$1.calculatePercentage();
            });
            this.els.phoneInput.addEventListener("change", function () {
                this$1.calculatePercentage();
            });
            this.els.passwordInput.addEventListener("change", function () {
                this$1.calculatePercentage();
            });

            if (this.els.togglePasswordButton) {
                this.els.togglePasswordButton.addEventListener("click", function () {
                    var passwordField = this$1.els.passwordInput;
                    var passwordToggleIcon =
                        this$1.els.togglePasswordButton.querySelector("img");

                    var openEyeIcon = passwordToggleIcon.getAttribute("data-open");
                    var closeEyeIcon = passwordToggleIcon.getAttribute("data-close");

                    if (passwordField.type === "password") {
                        passwordField.type = "text";
                        passwordToggleIcon.src = closeEyeIcon;
                        passwordToggleIcon.alt = "Hide Password";
                    } else {
                        passwordField.type = "password";
                        passwordToggleIcon.src = openEyeIcon;
                        passwordToggleIcon.alt = "Show Password";
                    }
                });
            }

            this.els.passwordInput.addEventListener("input", function () {
                var password = this$1.els.passwordInput.value;
                var strength = this$1.getPasswordStrength(password);
                this$1.updatePasswordFeedback(strength);
            });
            this.els.inputFields.forEach(function (input) {
                input.addEventListener("input", function () { return this$1.checkInputContent(input); });
                input.addEventListener("focus", function () { return this$1.checkInputContent(input); });
                input.addEventListener("blur", function () { return this$1.checkInputContent(input); });
            });
        },
        showAddAddressForm: function showAddAddressForm(isNew) {
            var this$1 = this;
            if ( isNew === void 0 ) isNew = true;

            var inputs = [
                this.els.addAddressForm.querySelector("#addressInput"),
                this.els.addAddressForm.querySelector("#postalCodeInput"),
                this.els.addAddressForm.querySelector("#cityInput"),
                this.els.addAddressForm.querySelector("#cptsInput") ];
            this.els.addAddressForm.querySelector("#cptsInput").classList.add("has-content");

            if (isNew) {
                inputs.forEach(function (input) {
                    input.value = "";
                });
            }

            inputs.forEach(function (input) {
                this$1.checkInputContent(input);
            });

            this.els.addAddressContainer.style.display = "none";
            this.els.addAddressForm.style.display = "flex";
            this.disableFormElements();
        },
        handleAddressChange: function handleAddressChange(e) {
            e.preventDefault();
            this.els.addAddressForm.style.display = "none";
            this.els.addAddressButton.style.display = "flex";
            this.els.addAddressContainer.style.display = "flex";
            this.enableFormElements();
            this.currentEditingIndex = undefined;
        },
        confirmAddress: function confirmAddress(e) {
            e.preventDefault();
            var updatedAddress = {
                address: this.els.addAddressForm.querySelector("#addressInput").value,
                postalCode: this.els.addAddressForm.querySelector("#postalCodeInput").value,
                city: this.els.addAddressForm.querySelector("#cityInput").value,
                cpts: this.els.addAddressForm.querySelector("#cptsInput").value,
                main: false,
            };

            if (this.currentEditingIndex !== undefined) {
                this.addresses[this.currentEditingIndex] = updatedAddress;
            } else {
                this.addresses.push(updatedAddress);
                this.els.addAddressButton.style.display = "flex";
            }
            this.updateAddressesList();
            this.handleAddressChange(e);
            this.primaryAddress(this.els.indexSaver);
        },
        updateAddressesList: function updateAddressesList() {
            var this$1 = this;

            if (this.addresses.length === 1) {
                this.addresses[0].main = true;
                this.els.indexSaver = 0;
            }

            this.els.addressesList.innerHTML = "";
            this.addresses.forEach(function (address, index) {
                var addressHTML = this$1.addAddressToList(address, index);
                this$1.els.addressesList.insertAdjacentHTML("beforeend", addressHTML);
            });

            this.attachButtonEvents();
            this.attachRadioEvents();

            this.els.addressesList.insertAdjacentHTML(
                "beforeend",
                this.els.addAddressButton.outerHTML
            );
            this.els.addressListButton = document.querySelector(".add__address__btn");
            this.els.addressListButton.addEventListener("click", function () {
                this$1.showAddAddressForm();
            });

            if (this.els.indexSaver === null) {
                this.els.indexSaver = 0;
            }

            this.primaryAddress(this.els.indexSaver);
            this.updateSelectedClass();
        },
        attachButtonEvents: function attachButtonEvents() {
            var this$1 = this;

            var deleteButtons = document.querySelectorAll(".delete-button");
            deleteButtons.forEach(function (button, index) {
                button.addEventListener("click", function (event) {
                    event.preventDefault();
                    this$1.showConfirmationModal(index);
                });
            });
            var editButtons = document.querySelectorAll(".edit-button");
            editButtons.forEach(function (button, index) {
                button.addEventListener("click", function (event) {
                    event.preventDefault();
                    this$1.editAddress(index);
                });
            });
            var primaryRadioButtons = document.querySelectorAll(
                ".primary-address-button"
            );
            primaryRadioButtons.forEach(function (button, index) {
                button.addEventListener("click", function () {
                    this$1.primaryAddress(index);
                });
            });
        },
        addAddressToList: function addAddressToList(address, index) {
            // Trouver le nom du cpts à partir de l'ID
            var cptsName = '';
            if (this.allCpts && address.cpts) {
                var matchingCpt = this.allCpts.find(function (cpt) { return cpt.id == address.cpts; });
                if (matchingCpt) {
                    cptsName = matchingCpt.title;
                } else {
                    cptsName = 'CPTS non trouvé'; // Ou gérez cela comme vous le souhaitez
                }
            }

            return ("\n    <div class=\"address-item\">\n        <div>\n            <label for=\"addressRadio-" + index + "\" class=\"address-label\">\n                <div class=\"d-flex\">\n                    <input type=\"radio\" id=\"addressRadio-" + index + "\" name=\"primaryAddress\" class=\"primary-address-button\">\n                    <div class=\"address-text\">\n                        <p>" + (address.city) + " (" + (address.postalCode) + ")</p>\n                        <span class=\"address-detail\">" + (address.address) + "</span>\n                        <span class=\"address-cpts-name\">" + cptsName + "</span>\n                    </div>\n                </div>\n                <div class=\"btn__container\">\n                    <button type=\"button\" class=\"delete-button\">\n                        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"16\" viewBox=\"0 0 14 16\">\n                            <path id=\"Icon_awesome-trash-alt\" data-name=\"Icon awesome-trash-alt\" d=\"M1,14.5A1.5,1.5,0,0,0,2.5,16h9A1.5,1.5,0,0,0,13,14.5V4H1Zm8.5-8a.5.5,0,1,1,1,0v7a.5.5,0,1,1-1,0Zm-3,0a.5.5,0,0,1,1,0v7a.5.5,0,0,1-1,0Zm-3,0a.5.5,0,0,1,1,0v7a.5.5,0,0,1-1,0ZM13.5,1H9.75L9.456.416A.75.75,0,0,0,8.784,0H5.213a.741.741,0,0,0-.669.416L4.25,1H.5a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,.5,3h13a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,13.5,1Z\" transform=\"translate(0 0)\" fill=\"#1267a8\"/>\n                        </svg>\n                    </button>\n                    <button type=\"button\" class=\"edit-button\">Modifier l'adresse</button>\n                </div>\n            </label>\n        </div>\n    </div>\n");
        },
        disableFormElements: function disableFormElements() {
            var this$1 = this;

            this.els.allFormElements.forEach(function (element) {
                if (!this$1.els.addAddressForm.contains(element)) {
                    element.disabled = true;
                    element.style.filter = "grayscale(1)";
                    element.style.opacity = ".2";
                }
            });
        },
        enableFormElements: function enableFormElements() {
            this.els.allFormElements.forEach(function (element) {
                element.disabled = false;
                element.style.filter = "grayscale(0)";
                element.style.opacity = "1";
            });
        },
        checkInputContent: function checkInputContent(input) {
            if (input.value.trim() !== "") {
                input.classList.add("has-content");
            } else if (!input.classList.contains("cpts__field")) {
                input.classList.remove("has-content");
            }
        },
        deleteAddress: function deleteAddress(index) {
            if (this.els.indexSaver > index && this.els.indexSaver !== 0) {
                this.els.indexSaver -= 1;
            }
            if (this.els.indexSaver === index) {
                this.els.indexSaver = null;
            }
            this.addresses.splice(index, 1);
            this.updateAddressesList();
        },
        primaryAddress: function primaryAddress(index) {
            var this$1 = this;

            this.addresses.forEach(function (item, loopIndex) {
                item.main = loopIndex === index;
                if (loopIndex === index) {
                    document.getElementById(("addressRadio-" + loopIndex)).checked = true;
                    this$1.els.addressError.innerHTML = "";
                }
            });

            this.els.indexSaver = index;
            this.calculatePercentage();
            this.updateSelectedClass();
        },
        editAddress: function editAddress(index) {
            var address = this.addresses[index];
            if (this.els.addAddressForm.querySelector("#addressInput")) {
                this.els.addAddressForm.querySelector("#addressInput").value =
                    address.address;
            }
            if (this.els.addAddressForm.querySelector("#postalCodeInput")) {
                this.els.addAddressForm.querySelector("#postalCodeInput").value =
                    address.postalCode;
            }
            if (this.els.addAddressForm.querySelector("#cityInput")) {
                this.els.addAddressForm.querySelector("#cityInput").value = address.city;
            }
            if (this.els.addAddressForm.querySelector("#cptsInput")) {
                this.els.addAddressForm.querySelector("#cptsInput").value = address.cpts;
            }
            this.currentEditingIndex = index;
            this.showAddAddressForm(false);
        },
        attachRadioEvents: function attachRadioEvents() {
            var this$1 = this;

            var radios = this.els.addressesList.querySelectorAll(".primary-address-button");
            radios.forEach(function (radio, index) {
                radio.addEventListener("change", function () {
                    this$1.primaryAddress(index);
                    this$1.updateSelectedClass();
                });
            });
        },
        fillFormData: function fillFormData() {
            var this$1 = this;

            var userData = JSON.parse(window.localStorage.getItem("userData"));

            if (!userData) {
                return;
            }

            var rpps,
                lastname,
                cptsTitle,
                cptsId,
                specialty,
                firstname = "";

            userData.forEach(function (item) {
                rpps = item["rpps"];
                lastname = item["lastname"];
                firstname = item["firstname"];
                cptsTitle = this$1.normalizeQuotes(item["cpts"]);

                var matchingCpt = this$1.allCpts.find(function (cpt) { return cpt.title === cptsTitle; });
                if (matchingCpt) {
                    cptsId = matchingCpt.id;
                } else {
                    console.warn(("La valeur \"" + cptsTitle + "\" n'existe pas dans les cpts disponibles."));
                    cptsId = "";
                }

                specialty = item["specialty"];

                var updatedAddress = {
                    address: item["street"],
                    postalCode: item["postal_code"],
                    city: item["city"],
                    cpts: cptsId,
                };

                this$1.addresses.push(updatedAddress);
            });

            this.updateAddressesList();

            var firstInput = this.els.addressesList.querySelector('input');
            var firstItem = this.els.addressesList.querySelector('.address-item');

            if (firstInput) {
                firstInput.checked = true;
                firstItem.classList.add("address-item--selected");
            }

            this.els.rppsNumber.innerHTML = rpps;
            this.els.lastnameInput.value = lastname;
            this.els.lastnameInput.focus();
            this.els.firstnameInput.value = firstname;
            this.els.firstnameInput.focus();
            this.els.cptsInput.value = cptsId;

            this.els.userSpecialty.innerHTML = specialty;

            this.checkInputContent(this.els.lastnameInput);
            this.checkInputContent(this.els.firstnameInput);
        },
        inscription: function inscription() {
            var this$1 = this;

            var registerButton = this.els.$wrapper.querySelector(".js-register-btn");
            var loader = registerButton.querySelector(".loader");
            loader.style.display = "inline-block";

            var password = this.els.passwordInput.value;
            if (this.getPasswordStrength(password) < 1) {
                loader.style.display = "none";
                return;
            }

            var addressError = false;
            var addressErrorMessage = "";
            if (this.addresses.length === 0) {
                addressError = true;
                addressErrorMessage = "Veuillez indiquer un lieu d'exercice.";
            } else {
                var radios = this.els.addressesList.querySelectorAll(".primary-address-button");
                var primarySelected = Array.from(radios).some(function (radio) { return radio.checked; });

                if (!primarySelected) {
                    addressError = true;
                    addressErrorMessage = "Veuillez choisir un lieu d'exercice principal.";
                }
            }

            if (addressError) {
                this.els.addressError.innerHTML = addressErrorMessage;
                this.els.addressError.style.display = "block";
                loader.style.display = "none";
                return;
            }

            var formData = {
                email: this.els.emailInput.value,
                password: this.els.passwordInput.value,
                firstname: this.els.firstnameInput.value,
                lastname: this.els.lastnameInput.value,
                phone: this.els.phoneInput.value,
                rpps: this.els.rppsNumber.innerHTML,
                specialty: this.els.userSpecialty.innerHTML,
                addresses: this.addresses,
            };

            this.saveRequest = utils.sendHTTPRequest({
                url: ajaxurl,
                method: "POST",
                body: {
                    action: "inscription",
                    params: JSON.stringify({
                        userData: formData,
                    }),
                },
            });

            this.saveRequest.promise
                .then(function (response) {
                    if (!response.success) {
                        this$1.displayError(response.errorMessage);
                        loader.style.display = "none";
                    } else {
                        window.location.href = "/dashboard";
                    }
                })
                .catch(function (error) {
                    this$1.displayError(error);
                    loader.style.display = "none";
                });

            this.calculatePercentage();
        },
        displayError: function displayError(message) {
            this.els.inscription_form_error.innerHTML = message;
            this.els.inscription_form_error.style.display = "block";
        },
        showConfirmationModal: function showConfirmationModal(index) {
            var this$1 = this;

            var message = "Êtes-vous sûr de vouloir supprimer cette adresse ?";
            var confirmText = "Confirmer";
            var cancelText = "Annuler";
            modal.showModal(
                message,
                confirmText,
                cancelText,
                function () {
                    this$1.deleteAddress(index);
                },
                function () {
                }
            );
        },
        getPasswordStrength: function getPasswordStrength(password) {
            var strength = 0;

            if (password.length < 8) {
                return strength;
            }

            if (/[A-Z]/.test(password)) { strength++; }
            if (/\d/.test(password)) { strength++; }
            if (/[@$!%*?&#]/.test(password)) { strength++; }

            return strength;
        },
        updatePasswordFeedback: function updatePasswordFeedback(strength) {
            this.els.passwordError.classList.remove("error", "success");
            this.els.passwordError.textContent = "";
            this.els.passwordInput.classList.remove("input-error", "input-success");
            this.els.passwordStrengthBar.className = "password-strength-bar";
            this.els.passwordStrengthBar.style.width = "0%";

            var errorIcon =
                this.els.passwordValidationIcon.querySelector('img[alt="Error"]');
            var successIcon =
                this.els.passwordValidationIcon.querySelector('img[alt="Success"]');

            errorIcon.style.display = "none";
            successIcon.style.display = "none";

            var passwordError = this.els.passwordError;

            if (this.els.passwordInput.value.length < 8 || strength === 0) {
                this.els.passwordError.textContent =
                    "Le mot de passe doit comporter au moins 8 caractères, une majuscule, un chiffre, et un caractère spécial.";
                this.els.passwordError.classList.add("error");
                this.els.passwordStrengthBar.style.width = "0%";
                this.els.passwordInput.classList.add("input-error");
                errorIcon.style.display = "block";
                passwordError.style.display = "block";
            }

            if (strength === 1) {
                this.els.passwordError.innerHTML = "Niveau de sécurité : <span class=\"password-strength-level\">FAIBLE</span>";
                this.els.passwordError.classList.add("error");
                this.els.passwordStrengthBar.classList.add("low");
                this.els.passwordStrengthBar.style.width = "33%";
                this.els.passwordInput.classList.add("input-error");
                errorIcon.style.display = "block";
                passwordError.style.display = "block";
            } else if (strength === 2) {
                this.els.passwordError.innerHTML = "Niveau de sécurité : <span class=\"password-strength-level\">BIEN</span>";
                this.els.passwordError.classList.add("success");
                this.els.passwordStrengthBar.classList.add("medium");
                this.els.passwordStrengthBar.style.width = "66%";
                this.els.passwordInput.classList.add("input-success");
                successIcon.style.display = "block";
                passwordError.style.display = "block";
            } else if (strength >= 3) {
                this.els.passwordError.innerHTML = "Niveau de sécurité : <span class=\"password-strength-level\">TRÈS BIEN</span>";
                this.els.passwordError.classList.add("success");
                this.els.passwordStrengthBar.classList.add("high");
                this.els.passwordStrengthBar.style.width = "100%";
                this.els.passwordInput.classList.add("input-success");
                successIcon.style.display = "block";
                passwordError.style.display = "block";
            }
        },
        updateProgress: function updateProgress(percentage) {
            var progressElement = document.querySelector(".progress");
            var percentageDisplay = document.querySelector(".percentage-display");

            progressElement.style.width = percentage + "%";
            percentageDisplay.textContent = percentage + "%";
            percentageDisplay.style.width = percentage + "%";
        },
        calculatePercentage: function calculatePercentage() {
            var addressSelect = false;
            var a = Array.from(
                this.els.$wrapper.querySelectorAll(".primary-address-button")
            );
            if (a.length === 0) {
                addressSelect = false;
            } else {
                for (var i = 0; i < a.length; i++) {
                    if (a[i].checked) {
                        addressSelect = true;
                    }
                }
            }
            var termsChecked = this.els.$wrapper.querySelector("#terms").checked;
            var percentage = 0;
            var formData = {
                email: this.els.emailInput.value,
                password: this.els.passwordInput.value,
                firstname: this.els.firstnameInput.value,
                lastname: this.els.lastnameInput.value,
                phone: this.els.phoneInput.value,
                address: addressSelect,
                cgu: termsChecked,
            };
            var part = 50 / Object.keys(formData).length;
            for (var key in formData) {
                if (formData[key]) {
                    if (key === "password") {
                        var strength = this.getPasswordStrength(formData[key]);
                        if (strength >= 1) {
                            percentage += part;
                        }
                    } else {
                        percentage += part;
                    }
                }
            }
            percentage = Math.round(percentage, 1);
            this.updateProgress(percentage);
        },
        getAllCpts: function getAllCpts() {
            var this$1 = this;

            this.saveRequest = utils.sendHTTPRequest({
                url: ajaxurl,
                method: "POST",
                body: {
                    action: "get_all_cpts",
                },
            });
            return this.saveRequest.promise
                .then(function (response) {
                    if (response.success) {
                        var cptsInput = this$1.els.$wrapper.querySelector("#cptsInput");

                        var defaultOption = document.createElement("option");
                        defaultOption.value = "";
                        defaultOption.text = "Sélectionner une CPTS";
                        defaultOption.selected = true;
                        defaultOption.disabled = false;
                        cptsInput.appendChild(defaultOption);

                        this$1.allCpts = response.data;
                        this$1.allCpts.forEach(function (cpt) {
                            var option = document.createElement("option");
                            var decodedTitle = this$1.decodeHTMLEntities(cpt.title);
                            option.value = cpt.id;
                            option.text = decodedTitle;
                            cptsInput.appendChild(option);
                        });
                    } else {
                        console.error("Erreur lors de la récupération des CPTs :", response.data);
                    }
                })
                .catch(function (error) {
                    console.error("Erreur lors de la récupération des CPTs :", error);
                });
        },
        decodeHTMLEntities: function decodeHTMLEntities(text) {
            var textarea = document.createElement("textarea");
            textarea.innerHTML = text;
            return textarea.value;
        },
        normalizeQuotes: function normalizeQuotes(str) {
            return str.replace(/'/g, '’').replace(/`/g, '’').replace(/“/g, '”').replace(/”/g, '”').trimEnd();
        },
        updateSelectedClass: function updateSelectedClass() {
            var radios = this.els.addressesList.querySelectorAll(".primary-address-button");
            radios.forEach(function (radio) {
                var item = radio.closest(".address-item");
                if (radio.checked) {
                    item.classList.add("address-item--selected");
                } else {
                    item.classList.remove("address-item--selected");
                }
            });
        }
    };

    var MissingPassword = {
        els: {
            $wrapper: null,
            form: {
                $wrapper: null,
                rpps: null,
                rpps_error: null,
            },
            email_sent_message: null,
        },
        init: function init() {
            this.els.$wrapper = document.querySelector('.js-missing-pwd');
            if (this.els.$wrapper) {
                this.els.form.$wrapper = this.els.$wrapper.querySelector('#missingPwdForm');
                this.els.form.rpps = this.els.form.$wrapper.querySelector('[name="rpps"]');
                this.els.form.rpps_error = document.getElementById('rpps-error-message').querySelector('p');
                this.els.email_sent_message = document.getElementById('email-sent-message');
                this.els.previous_step = this.els.$wrapper.querySelector('.previous-step');
                this.els.form.rpps_error.style.display = 'none';
                if (this.els.email_sent_message) {
                    this.els.email_sent_message.style.display = 'none';
                }

                this.initEvents();
            }
        },
        initEvents: function initEvents() {
            var this$1 = this;

            this.els.previous_step.addEventListener('click', function (e) {
                window.location.href = '/login';
            });
            this.els.form.$wrapper.addEventListener('submit', function (e) {

                e.preventDefault();
                this$1.checkRPPS();
            });
        },

        /**
         * Validation et envoi du RPPS
         */
        checkRPPS: function checkRPPS() {
            var rppsValue = this.els.form.rpps.value;
            var hasError = false;
            var errorMessage = "";


            if (!rppsValue) {
                hasError = true;
                errorMessage = "Veuillez saisir votre identifiant RPPS";
            } else if (!Number.isInteger(parseInt(rppsValue))) {
                hasError = true;
                errorMessage = "Identifiant RPPS invalide";
            } else if (rppsValue.length !== 11) {
                hasError = true;
                errorMessage = "Le numéro RPPS doit contenir exactement 11 caractères";
            }

            if (hasError) {
                this.displayRPPSValidationError(errorMessage);
            } else {
                this.els.form.rpps_error.style.display = 'none';
                this.sendRPPSRequest(rppsValue);
            }
        },


        sendRPPSRequest: function sendRPPSRequest(rppsValue) {
            var this$1 = this;

            this.saveRequest = utils.sendHTTPRequest({
                url: ajaxurl,
                method: 'POST',
                body: {
                    action: 'check_rpps_and_send_email',
                    params: JSON.stringify({
                        rpps: rppsValue
                    })
                },
            });

            this.saveRequest.promise.then(function (response) {
                if (!response.success) {
                    this$1.displayRPPSValidationError(response.data || response.errorMessage || 'Aucun RPPS trouvé.');
                } else {
                    this$1.displaySuccessMessage();
                }
                this$1.saveRequest = null;
            }).catch(function (error) {
                var messageError = __('An error has occurred, please try again.', 'medvigie');
                this$1.displayRPPSValidationError(messageError);
                console.error(error);
                this$1.saveRequest = null;
            });
        },

        /**
         * Afficher un message d'erreur de validation pour le RPPS
         */
        displayRPPSValidationError: function displayRPPSValidationError(message) {
            this.els.form.rpps_error.innerHTML = message;
            this.els.form.rpps_error.style.display = 'block';
            this.els.form.rpps.classList.add('error');
        },

        /**
         * Afficher un message de succès après l'envoi de l'email
         */
        displaySuccessMessage: function displaySuccessMessage() {
            this.els.form.rpps_error.style.display = 'none';
            this.els.form.rpps.classList.remove('error');

            if (this.els.email_sent_message) {
                this.els.email_sent_message.style.display = 'block';
            } else {
                this.displayPopupMessage();
            }
        },

        displayPopupMessage: function displayPopupMessage() {
            var title = "Mail envoyé";
            var message = "Un email a été envoyé à l'adresse associée à ce RPPS.";
            var confirmText = "Ok";
            modal.showInformationModal(title, message, confirmText, function () {});
        },
    };

    var ProfileCompletion = {
        percentage: 0,
        els: {
            progressBar: null,
            progressText: null,
            actionsProfile: null,
            userActions: null,
            userPolygon: null,
        },
        init: function init() {
            var this$1 = this;

            var isProfileComplete = localStorage.getItem('profileComplete') === 'true';
            this.setupElements();
            if (!isProfileComplete) {
                this.showProgressBar();
            }

            this.updateProgressBar(0);

            return this.fetchProfileCompletionPercentage()
                .then(function (percentage) {
                    this$1.percentage = percentage;
                    this$1.updateProgressBar();
                    if (this$1.percentage === 100) {
                        localStorage.setItem('profileComplete', 'true');
                        if (!localStorage.getItem('profileFireworks')) {
                            var page = document.querySelector('#page');
                            page.classList.add('fireworks');
                            var interval = setInterval(this$1.createFirework, 200);
                            setTimeout(function () {
                                clearInterval(interval);
                                document.querySelectorAll('.particle').forEach(function (particle) { return particle.remove(); });
                            }, 5000);
                        }
                        localStorage.setItem('profileFireworks', 'true');
                        this$1.hideProgressBar();
                    } else {
                        localStorage.removeItem('profileComplete');
                        localStorage.removeItem('profileFireworks');
                        this$1.showProgressBar();
                    }
                    this$1.bindEvents();
                })
                .catch(function (error) {
                    console.error('Erreur lors de la récupération du pourcentage de complétion du profil:', error);
                    throw error;
                });
        },
        setupElements: function setupElements() {
            this.els.progressBar = document.querySelector('.progress__bar');
            this.els.progressText = document.querySelector('.progress__text');
            this.els.actionsProfile = document.querySelector('.actions__profile');
            this.els.userActions = document.querySelector('.user__actions');
            this.els.userPolygon = document.querySelector('.user__polygon');
        },
        fetchProfileCompletionPercentage: function fetchProfileCompletionPercentage() {
            return utils.sendHTTPRequest({
                url: ajaxurl,
                method: 'POST',
                body: {
                    action: 'get_profile_completion_percentage',
                },
            }).promise.then(function (response) {
                if (response.success) {
                    return response.data.percentage;
                } else {
                    console.error('Erreur lors de la récupération du pourcentage de complétion.');
                    return 0;
                }
            });
        },
        updateProgressBar: function updateProgressBar() {
            if (this.els.progressBar) {
                this.els.progressBar.style.width = (this.percentage) + "%";
            }
            if (this.els.progressText) {
                this.els.progressText.textContent = (this.percentage) + "%";
            }
        },
        showProgressBar: function showProgressBar() {
            var progressBarContainer = document.querySelector('.actions__progress');
            if (progressBarContainer) {
                progressBarContainer.style.display = 'flex';
            }
        },
        hideProgressBar: function hideProgressBar() {
            var progressBarContainer = document.querySelector('.actions__progress');
            if (progressBarContainer) {
                progressBarContainer.style.display = 'none';
            }
            this.els.userActions.style.top = '3.5rem';
            this.els.userPolygon.style.top = '2.5rem';
        },
        bindEvents: function bindEvents() {
            var this$1 = this;

            var profileFields = document.querySelectorAll('.profile-field');
            profileFields.forEach(function (field) {
                field.addEventListener('input', function () {
                    this$1.onFieldChange();
                });
            });
        },
        updateProgressInElement: function updateProgressInElement(element) {
            this.fetchProfileCompletionPercentage().then(function (percentage) {
                var progressBar = element.querySelector('.progress__bar');
                var progressText = element.querySelector('.progress__text');
                if (progressBar) {
                    progressBar.style.width = percentage + "%";
                }
                if (progressText) {
                    progressText.textContent = percentage + "%";
                }
            });
        },
        onFieldChange: function onFieldChange() {
            var this$1 = this;

            this.fetchProfileCompletionPercentage().then(function (percentage) {
                this$1.percentage = percentage;
                this$1.updateProgressBar();

                if (this$1.percentage === 100) {
                    localStorage.setItem('profileComplete', 'true');
                    this$1.hideProgressBar();
                    if (!localStorage.getItem('profileFireworks')) {
                        var page = document.querySelector('#page');
                        page.classList.add('fireworks');
                        var interval = setInterval(this$1.createFirework, 200);
                        setTimeout(function () {
                            clearInterval(interval);
                            document.querySelectorAll('.particle').forEach(function (particle) { return particle.remove(); });
                        }, 5000);
                    }
                    localStorage.setItem('profileFireworks', 'true');
                } else {
                    localStorage.removeItem('profileComplete');
                    var progressBarContainer = document.querySelector('.progress__bar__container');
                    if (progressBarContainer) {
                        progressBarContainer.style.display = 'flex';
                    }
                }
            });
        },
        createFirework: function createFirework() {
            var fireworksContainer = document.querySelector('.fireworks');
            var firework = document.createElement('div');
            firework.classList.add('firework');

            for (var i = 0; i < 8; i++) {
                var explosion = document.createElement('div');
                explosion.classList.add('explosion');

                var spark = document.createElement('div');
                var colors = ['green', 'blue', 'red', 'yellow', 'purple'];
                var randomColor = colors[Math.floor(Math.random() * colors.length)];
                spark.classList.add('spark', randomColor);

                explosion.appendChild(spark);
                firework.appendChild(explosion);
            }

            firework.style.left = (Math.random() * 100) + "vw";
            firework.style.top = (Math.random() * 100) + "vh";

            fireworksContainer.appendChild(firework);

            setTimeout(function () {
                firework.remove();
            }, 2000);
        }
    };

    var EntryModeModal = {
        els: {
            modal: null,
            indicatorValidateBtn: null,
            skipStepLink: null,
            radioButtons: null,
            selectionLabels: null,
            entryModeEmpty: null,
        },
        entryMode: null,
        onModalClose: null,

        init: function init() {
            this.showEntryModeModal();
        },

        setupElements: function setupElements() {
            this.els.modal = document.querySelector('.indicator-modal');
            this.els.indicatorValidateBtn = this.els.modal.querySelector('#indicator-validate-btn');
            this.els.skipStepLink = this.els.modal.querySelector('.skip-step');
            this.els.radioButtons = this.els.modal.querySelectorAll('input[name="frequency"]');
            this.els.selectionLabels = this.els.modal.querySelectorAll('.selection-btn');
            this.els.entryModeEmpty = this.els.modal.querySelector('.indicator-modal-required');
        },

        bindEvents: function bindEvents() {
            var this$1 = this;

            this.els.indicatorValidateBtn.addEventListener('click', function () {
                if (!this$1.entryMode) {
                    this$1.els.entryModeEmpty.style.display = 'flex';
                    return;
                }
                this$1.saveEntryMode();
                this$1.closeEntryModeModal();
            });

            this.els.skipStepLink.addEventListener('click', function (event) {
                event.preventDefault();
                this$1.closeEntryModeModal();
            });

            this.els.radioButtons.forEach(function (radio) {
                radio.addEventListener('change', function () {
                    this$1.els.selectionLabels.forEach(function (label) {
                        label.classList.remove('selected');
                    });
                    radio.closest('label').classList.add('selected');

                    this$1.entryMode = radio.value;

                    this$1.els.entryModeEmpty.style.display = 'none';
                });
            });
        },

        showEntryModeModal: function showEntryModeModal() {
            var this$1 = this;

            this.loadUserEntryMode(function () {
                var modalHtml = "\n            <div class=\"indicator-modal\">\n                <div class=\"indicator-modal-container\">\n                    <div class=\"indicator-modal-body\">\n                        <h3>À quelle fréquence souhaitez-vous renseigner vos saisies ?</h3>\n                        <div class=\"indicator-options\">\n                            <label class=\"selection-btn " + (this$1.entryMode === 'daily' ? 'selected' : '') + "\">\n                                <input type=\"radio\" name=\"frequency\" value=\"daily\" " + (this$1.entryMode === 'daily' ? 'checked' : '') + ">\n                                <span>Une fois par jour</span>\n                            </label>\n                            <label class=\"selection-btn " + (this$1.entryMode === 'weekly' ? 'selected' : '') + "\">\n                                <input type=\"radio\" name=\"frequency\" value=\"weekly\" " + (this$1.entryMode === 'weekly' ? 'checked' : '') + ">\n                                <span>Une fois par semaine</span>\n                            </label>\n                        </div>\n                        <div class=\"indicator-modal-required\" style=\"display: none;\">\n                            <p>Vous devez choisir une fréquence</p>\n                        </div>\n                        <div class=\"indicator-actions\">\n                            <button id=\"indicator-validate-btn\" class=\"button-main button-big button-fill-primary\">Je valide</button>\n                            <a href=\"#\" class=\"skip-step\">Passer cette étape</a>\n                        </div>\n                        <span class=\"progress__text\">0%</span>\n                        <div class=\"progress__bar__container\">\n                            <div class=\"progress__bar\"></div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            ";
                document.body.insertAdjacentHTML('beforeend', modalHtml);
                this$1.setupElements();
                this$1.bindEvents();
                this$1.updateProgressInModal();
            });
        },

        loadUserEntryMode: function loadUserEntryMode(callback) {
            var this$1 = this;

            fetch(ajaxurl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({ 'action': 'get_entry_mode' })
            })
                .then(function (response) { return response.json(); })
                .then(function (data) {
                    this$1.entryMode = data.data.entryMode;
                    callback();
                })
                .catch(function (error) {
                    console.error("Erreur lors de la récupération du mode de saisie :", error);
                    callback();
                });
        },

        saveEntryMode: function saveEntryMode() {
            utils.sendHTTPRequest({
                url: ajaxurl,
                method: 'POST',
                body: {
                    action: 'save_entry_mode',
                    params: JSON.stringify({ entryMode: this.entryMode }),
                },
            }).promise.then(function (response) {
                if (response.success) {
                    setTimeout(function () {
                        ProfileCompletion.hideProgressBar();
                        ProfileCompletion.init();
                        ProfileCompletion.els.actionsProfile.style.margin = '21px 0 20px 0';
                    }, 500);

                } else {
                    console.error("Erreur lors de l'enregistrement du mode de saisie.");
                }
            }).catch(function (error) {
                console.error("Erreur AJAX :", error);
            });
        },

        closeEntryModeModal: function closeEntryModeModal() {
            this.els.modal.remove();
            if (typeof this.onModalClose === 'function') {
                this.onModalClose();
            }
        },

        updateProgressInModal: function updateProgressInModal() {
            if (this.els.modal) {
                ProfileCompletion.updateProgressInElement(this.els.modal);
            }
        },
    };

    var indicatorModal = {
        els: {
            indicatorModal: null,
            selectAllBtn: null,
            selectCustomBtn: null,
            indicatorBtns: null,
            indicatorValidateBtn: null,
            skipStepLink: null,
            indicatorEmpty: null,
            confirmEmpty: null,
            cancelEmpty: null,
        },
        isSelectAllActive: false,
        selectedDiseases: [],
        userIndicators: [],
        onModalClose: null,

        init: function init() {
            this.showIndicatorModal();
        },

        setupElements: function setupElements() {
            this.els.indicatorModal = document.querySelector(".indicator-modal");
            this.els.selectAllBtn =
                this.els.indicatorModal.querySelector(".select-all");
            this.els.selectCustomBtn =
                this.els.indicatorModal.querySelector(".select-custom");
            this.els.indicatorBtns =
                this.els.indicatorModal.querySelectorAll(".indicator-btn");
            this.els.indicatorValidateBtn = this.els.indicatorModal.querySelector(
                "#indicator-validate-btn"
            );
            this.els.skipStepLink =
                this.els.indicatorModal.querySelector(".skip-step");
            this.els.indicatorEmpty = this.els.indicatorModal.querySelector(
                ".indicator-modal-empty"
            );
            this.els.confirmEmpty =
                this.els.indicatorModal.querySelector("#confirmEmpty");
            this.els.cancelEmpty =
                this.els.indicatorModal.querySelector("#cancelEmpty");
        },

        bindEvents: function bindEvents() {
            var this$1 = this;

            this.els.selectAllBtn.addEventListener(
                "click",
                this.selectAllDiseases.bind(this)
            );
            this.els.selectCustomBtn.addEventListener(
                "click",
                this.deselectAllDiseases.bind(this)
            );
            this.els.indicatorBtns.forEach(function (button) {
                button.addEventListener(
                    "click",
                    this$1.toggleDiseaseSelection.bind(this$1)
                );
            });
            this.els.indicatorValidateBtn.addEventListener("click", function () {
                this$1.saveIndicatorSelection();
                if (this$1.selectedDiseases.length === 0) {
                    this$1.els.indicatorEmpty.style.display = "flex";
                    return;
                }
                this$1.closeIndicatorModal();
                if (typeof this$1.onModalClose === "function") {
                    this$1.onModalClose();
                }
                EntryModeModal.showEntryModeModal();
            });
            this.els.skipStepLink.addEventListener("click", function () {
                this$1.updateUserModalMeta();
                this$1.closeIndicatorModal();
                if (typeof this$1.onModalClose === "function") {
                    this$1.onModalClose();
                }
            });
            this.els.confirmEmpty.addEventListener("click", function () {
                fetch(ajaxurl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: 'action=set_user_indicator_empty',
                    credentials: 'same-origin',
                })
                    .then(function (response) { return response.json(); })
                    .catch(function (error) {
                        console.error('Erreur réseau ou de serveur :', error);
                    });
                this$1.updateUserModalMeta();
                this$1.closeIndicatorModal();

                setTimeout(function () {
                    ProfileCompletion.init();
                }, 500);

                if (typeof this$1.onModalClose === "function") {
                    this$1.onModalClose();
                }
            });
            this.els.cancelEmpty.addEventListener("click", function () {
                this$1.els.indicatorEmpty.style.display = "none";
            });
        },

        showIndicatorModal: function showIndicatorModal() {
            var this$1 = this;

            this.loadUserIndicators()
                .then(function () {
                    this$1.selectedDiseases = [];
                    var indicatorButtons = "";
                    var activeIndicators = indicatorsFromCPT.filter(
                        function (indicator) { return indicator.state === "1"; }
                    );

                    if (activeIndicators.length === 0) {
                        indicatorButtons += "<p>Il n'existe aucun indicateur de renseigné.</p>";
                    } else {
                        activeIndicators.forEach(function (indicator) {
                            var isSelected = this$1.userIndicators.some(
                                function (userIndicator) { return userIndicator.id &&
                                    parseInt(userIndicator.id) ===
                                    parseInt(indicator.id); }
                            );
                            var selectedClass = isSelected ? "selected" : "";
                            indicatorButtons += "<button class=\"indicator-btn " + selectedClass + "\" data-indicator-id=\"" + (indicator.id) + "\" data-indicator-title=\"" + (indicator.title) + "\">" + (indicator.title) + "</button>";

                            if (isSelected) {
                                this$1.selectedDiseases.push(parseInt(indicator.id));
                            }
                        });
                    }

                    var isAllSelected =
                        this$1.selectedDiseases.length === activeIndicators.length;

                    var modalHtml = "\n            <div class=\"indicator-modal\">\n                <div class=\"indicator-modal-container\">\n                    <div class=\"indicator-modal-body\">\n                        <h3>À quels indicateurs souhaitez-vous vous abonner ? \n                            <span class=\"info-tooltip\">?</span>\n                            <div class=\"tooltip-content\">Via MedVigie, participez en deux clics à la surveillance épidémiologique autour de votre lieu d'exercice.</div>\n                        </h3>\n                        <div class=\"indicator-options\">\n                            <label class=\"selection-btn " + (isAllSelected ? "selected" : "") + "\">\n                                <input type=\"radio\" name=\"selection\" class=\"select-all\" " + (isAllSelected ? "checked" : "") + ">\n                                <span>Toutes</span>\n                            </label>\n                            <label class=\"selection-btn " + (!isAllSelected ? "selected" : "") + "\">\n                                <input type=\"radio\" name=\"selection\" class=\"select-custom\" " + (!isAllSelected ? "checked" : "") + ">\n                                <span>Sélection personnalisée</span>\n                            </label>\n                        </div>\n                        <div class=\"indicator-list\">\n                            " + indicatorButtons + "\n                        </div>\n                        <div class=\"indicator-actions\">\n                            <button id=\"indicator-validate-btn\" class=\"button-main button-big button-fill-primary\">Je valide</button>\n                            <a href=\"#\" class=\"skip-step\">Passer cette étape</a>\n                        </div>\n                        <span class=\"progress__text\">0%</span>\n                        <div class=\"progress__bar__container\">\n                            <div class=\"progress__bar\"></div>\n                        </div>\n                    </div>\n                    <div class=\"indicator-modal-empty\">\n                        <h3>Vous n’avez sélectionné aucun indicateur, êtes-vous sûr de ne pas vouloir contribuer ?</h3>\n                        <div class=\"d-flex justify-content-center gap-16\">\n                            <button id=\"cancelEmpty\" class=\"button-main button-big button-stroke-cancel\">Non</button>\n                            <button id=\"confirmEmpty\" class=\"button-main button-big button-fill-primary\">Oui</button>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            ";
                    document.body.insertAdjacentHTML("beforeend", modalHtml);
                    this$1.setupElements();
                    this$1.bindEvents();
                    this$1.updateProgressInModal();
                })
                .catch(function (error) {
                    console.error(
                        "Erreur lors de la configuration du modal :",
                        error
                    );
                });
        },

        loadUserIndicators: function loadUserIndicators() {
            var this$1 = this;

            return fetch(ajaxurl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                body: new URLSearchParams({
                    action: "get_user_indicators",
                }),
            })
                .then(function (response) { return response.json(); })
                .then(function (response) {
                    if (response.success) {
                        this$1.userIndicators = response.data;
                    }
                })
                .catch(function (error) {
                    console.error(
                        "Erreur AJAX lors de la récupération des abonnements :",
                        error
                    );
                });
        },

        selectAllDiseases: function selectAllDiseases() {
            if (this.isSelectAllActive) {
                this.selectedDiseases = [];
                this.els.indicatorBtns.forEach(function (button) {
                    button.classList.remove("selected");
                });

                this.els.selectAllBtn.checked = false;
                this.els.selectAllBtn.parentElement.classList.remove("selected");
                this.els.selectCustomBtn.parentElement.classList.remove("selected");

                this.isSelectAllActive = false;
            } else {
                this.selectedDiseases = indicatorsFromCPT.map(function (indicator) { return parseInt(indicator.id); }
                );
                this.els.indicatorBtns.forEach(function (button) {
                    button.classList.add("selected");
                });

                this.els.selectAllBtn.checked = true;
                this.els.selectAllBtn.parentElement.classList.add("selected");
                this.els.selectCustomBtn.parentElement.classList.remove("selected");

                this.isSelectAllActive = true;
            }
        },

        deselectAllDiseases: function deselectAllDiseases() {
            this.selectedDiseases = [];
            this.els.indicatorBtns.forEach(function (button) {
                button.classList.remove("selected");
            });

            this.els.selectCustomBtn.checked = true;
            this.els.selectCustomBtn.parentElement.classList.add("selected");
            this.els.selectAllBtn.parentElement.classList.remove("selected");
        },

        toggleDiseaseSelection: function toggleDiseaseSelection(event) {
            var indicatorId = parseInt(
                event.target.getAttribute("data-indicator-id"),
                10
            );
            var isSelected = this.selectedDiseases.includes(indicatorId);

            if (isSelected) {
                this.selectedDiseases = this.selectedDiseases.filter(
                    function (id) { return id !== indicatorId; }
                );
                event.target.classList.remove("selected");
            } else {
                this.selectedDiseases.push(indicatorId);
                event.target.classList.add("selected");
            }

            if (this.selectedDiseases.length === indicatorsFromCPT.length) {
                this.els.selectAllBtn.checked = true;
                this.els.selectAllBtn.parentElement.classList.add("selected");
                this.els.selectCustomBtn.parentElement.classList.remove("selected");
            } else {
                this.els.selectCustomBtn.checked = true;
                this.els.selectCustomBtn.parentElement.classList.add("selected");
                this.els.selectAllBtn.parentElement.classList.remove("selected");
            }
        },

        saveIndicatorSelection: function saveIndicatorSelection() {
            var this$1 = this;

            var uniqueSelectedIndicators = Array.from(
                new Set(this.selectedDiseases)
            );

            var formData = new FormData();
            formData.append("action", "save_user_indicator_selection");

            uniqueSelectedIndicators.forEach(function (indicatorId) {
                formData.append(
                    "indicator_subscription_0_indicator[]",
                    indicatorId
                );
            });

            fetch(ajaxurl, {
                method: "POST",
                body: formData,
            })
                .then(function (response) { return response.json(); })
                .then(function (response) {
                    if (response.success) {
                        this$1.loadUserIndicators();
                    } else {
                        console.error(
                            "Erreur lors de la sauvegarde :",
                            response.data
                        );
                    }
                })
                .catch(function (error) {
                    console.error("Erreur AJAX :", error);
                });
        },

        closeIndicatorModal: function closeIndicatorModal() {
            this.els.indicatorModal.remove();
        },

        updateProgressInModal: function updateProgressInModal() {
            if (this.els.indicatorModal) {
                ProfileCompletion.updateProgressInElement(this.els.indicatorModal);
            }
        },

        updateUserModalMeta: function updateUserModalMeta() {
            utils
                .sendHTTPRequest({
                    url: ajaxurl,
                    method: "POST",
                    body: {
                        action: "update_user_modal_meta",
                        _wpnonce: modalNonce,
                    },
                })
                .promise.then(function (response) {
                if (!response.success) {
                    console.error(
                        "Erreur lors de la mise à jour de la métadonnée."
                    );
                }
            })
                .catch(function (error) {
                    console.error("Erreur AJAX :", error);
                });
        },
    };

    var IndicatorCalendar = {
        els: {},
        currentMonth: null,
        currentYear: null,
        missingDay: null,
        threeWeeksAgo: null,
        registrationDate: null,

        init: function init() {
            if (document.body.classList.contains('page-template-page-login') ||
                document.body.classList.contains('page-template-page-inscription')
            ) {
                return;
            }
            this.els.$wrapper = document.querySelector('.indicator__calendar');
            if (this.els.$wrapper) {
                this.setupInitialDate();
                this.setupElements();
                this.getUserRegistrationDate();
            }
        },

        setupInitialDate: function setupInitialDate() {
            var today = new Date();
            this.currentMonth = today.getMonth();
            this.currentYear = today.getFullYear();
        },

        getStartMonthYear: function getStartMonthYear(monthsToShow) {
            var month = this.currentMonth;
            var year = this.currentYear;

            var startMonth = month - (monthsToShow - 1);
            var startYear = year;
            while (startMonth < 0) {
                startMonth += 12;
                startYear -= 1;
            }

            return {startMonth: startMonth, startYear: startYear};
        },

        setupElements: function setupElements() {
            var this$1 = this;

            var monthNames = [
                'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
                'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
            ];

            var monthsToShow = 3;
            var ref = this.getStartMonthYear(monthsToShow);
            var startMonth = ref.startMonth;
            var startYear = ref.startYear;

            var endMonth = this.currentMonth;
            var endYear = this.currentYear;

            var todayDate = new Date();
            this.threeWeeksAgo = new Date();
            this.threeWeeksAgo.setDate(todayDate.getDate() - 21);

            var startDate = new Date(startYear, startMonth, 1);
            var endDateObj = new Date(endYear, endMonth + 1, 0);
            var endDate = new Date(endDateObj.getFullYear(), endDateObj.getMonth(), endDateObj.getDate());

            var startDateStr = this.formatDate(startDate);
            var endDateStr = this.formatDate(endDate);

            EntryModeModal.loadUserEntryMode(function () {
                Promise.all([
                    this$1.getUserIndicatorData(startYear, startMonth, endYear, endMonth),
                    this$1.fetchMissingCount(EntryModeModal.entryMode, startDateStr, endDateStr)
                ])
                    .then(function (ref) {
                        var validatedDates = ref[0];
                        var missingCount = ref[1];

                        this$1.generateMonths(monthNames, todayDate, validatedDates);

                        if (missingCount === 0) {
                            this$1.els.missingDay.style.display = 'none';
                        } else {
                            this$1.els.missingDay.textContent = "" + missingCount;
                        }
                    })
                    .catch(function (error) {
                        console.error('Error when fetching data:', error);
                        this$1.generateMonths(monthNames, todayDate, []);
                    });
            });

            this.els.missingDay = document.querySelector('.date__missing');
        },

        /**
         * AJAX call to your PHP endpoint to retrieve the number of missing days/weeks.
         *
         * @param {String} entryMode   'daily' or 'weekly'
         * @param {String} startDate   in 'YYYY-mm-dd' format
         * @param {String} endDate     in 'YYYY-mm-dd' format
         * @returns {Promise<number>}  The number of missing days/weeks
         */
        fetchMissingCount: function fetchMissingCount(entryMode, startDate, endDate) {
            var userId = 0;
            return fetch(ajaxurl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                },
                body: new URLSearchParams({
                    'action': 'get_missing_count',
                    'user_id': userId,
                    'entry_mode': entryMode,
                    'start_date': startDate,
                    'end_date': endDate
                })
            })
                .then(function (response) { return response.json(); })
                .then(function (data) {
                    if (data.success) {
                        return data.data.missing_count;
                    } else {
                        throw new Error(data.data);
                    }
                });
        },

        /**
         * Fetches (via AJAX) the daily data indicating if a day is validated, pending, etc.
         * This is used to color the calendar cells.
         */
        getUserIndicatorData: function getUserIndicatorData(startYear, startMonth, endYear, endMonth) {
            var startDate = new Date(startYear, startMonth, 1);
            var endDateObj = new Date(endYear, endMonth + 1, 0);
            var endDate = new Date(endDateObj.getFullYear(), endDateObj.getMonth(), endDateObj.getDate());

            var startDateStr = this.formatDate(startDate);
            var endDateStr = this.formatDate(endDate);

            return fetch(ajaxurl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                },
                body: new URLSearchParams({
                    'action': 'user_indicator_data_range',
                    'start_date': startDateStr,
                    'end_date': endDateStr
                })
            })
                .then(function (response) { return response.json(); })
                .then(function (data) {
                    if (data.success) {
                        return data.data;
                    } else {
                        console.error('Error :', data.data);
                        return [];
                    }
                });
        },

        generateMonths: function generateMonths(monthNames, today, indicatorData) {
            if ( indicatorData === void 0 ) indicatorData = [];

            var $monthsContainer = this.els.$wrapper.querySelector('.months-container');

            var monthsToShow = 3;
            var ref = this.getStartMonthYear(monthsToShow);
            var startMonth = ref.startMonth;
            var startYear = ref.startYear;

            var month = startMonth;
            var year = startYear;

            $monthsContainer.innerHTML = '';

            for (var i = 0; i < monthsToShow; i++) {
                this.createMonthElement(monthNames, month, year, indicatorData, $monthsContainer);
                month++;
                if (month > 11) {
                    month = 0;
                    year++;
                }
            }
        },

        createMonthElement: function createMonthElement(monthNames, month, year, indicatorData, container) {
            var monthWrapper = document.createElement('div');
            monthWrapper.classList.add('month-wrapper');

            var monthTitle = document.createElement('h3');
            monthTitle.classList.add('month');
            monthTitle.textContent = (monthNames[month]) + " " + year;
            monthWrapper.appendChild(monthTitle);

            var calendar = document.createElement('div');
            calendar.classList.add('calendar');
            monthWrapper.appendChild(calendar);

            this.generateCalendar(monthNames, month, year, calendar, indicatorData);

            container.appendChild(monthWrapper);
        },

        generateCalendar: function generateCalendar(monthNames, month, year, $calendar, indicatorData) {
            var this$1 = this;
            if ( indicatorData === void 0 ) indicatorData = [];

            this.clearCalendar($calendar);
            this.addEmptyCells($calendar, year, month);

            var today = new Date();
            var todayDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            var daysInMonth = new Date(year, month + 1, 0).getDate();

            var loop = function ( day ) {
                var dateObj = new Date(year, month, day);
                var dayOfWeek = dateObj.getDay();
                var dateStr = this$1.formatDate(dateObj);
                var indicator = indicatorData.find(function (item) { return item.entry_date === dateStr; });
                var dayCell = this$1.createDayCell(day, dateObj, dayOfWeek, indicator, todayDate);
                $calendar.appendChild(dayCell);
            };

            for (var day = 1; day <= daysInMonth; day++) loop( day );
        },

        clearCalendar: function clearCalendar($calendar) {
            while ($calendar.firstChild) {
                $calendar.removeChild($calendar.firstChild);
            }
        },

        addEmptyCells: function addEmptyCells($calendar, year, month) {
            var firstDay = new Date(year, month, 1).getDay();
            for (var i = 0; i < firstDay; i++) {
                var emptyCell = document.createElement('div');
                emptyCell.classList.add('empty');
                $calendar.appendChild(emptyCell);
            }
        },

        createDayCell: function createDayCell(day, dateObj, dayOfWeek, indicator, todayDate) {
            var dayCell = document.createElement('div');
            dayCell.classList.add('day');
            dayCell.textContent = day < 10 ? ("0" + day) : day;

            this.assignClasses(dayCell, dateObj, dayOfWeek, indicator, todayDate);
            this.addClickListener(dayCell, dateObj);

            return dayCell;
        },

        assignClasses: function assignClasses(dayCell, dateObj, dayOfWeek, indicator, todayDate) {
            if (EntryModeModal.entryMode === 'weekly' && dayOfWeek !== 1) {
                dayCell.classList.add('disabled');
            }

            if (this.isSameDate(dateObj, todayDate)) {
                dayCell.classList.add('today');
            }

            if (indicator && dateObj <= todayDate) {
                if (indicator.is_validated === 1) {
                    dayCell.classList.add('completed');
                } else if (indicator.is_validated === 0) {
                    dayCell.classList.add('pending');
                }
            } else if (
                dateObj <= todayDate &&
                dateObj >= this.threeWeeksAgo &&
                dayOfWeek !== 0 &&
                dayOfWeek !== 6 &&
                (!this.registrationDate || dateObj >= this.registrationDate)
            ) {
                dayCell.classList.add('missing');
            }

            if (dayOfWeek === 0 || dayOfWeek === 6) {
                dayCell.classList.add('weekend');
            }
        },

        addClickListener: function addClickListener(dayCell, dateObj) {
            var this$1 = this;

            if (!dayCell.classList.contains('empty') && !dayCell.classList.contains('disabled')) {
                dayCell.addEventListener('click', function () {
                    DataForm.currentDate = dateObj;
                    DataForm.updateDateDisplay(EntryModeModal.entryMode);
                    DataForm.getUserData();
                    this$1.els.$wrapper.style.display = 'none';
                });
            }
        },

        navigateMonth: function navigateMonth(delta) {
            var newMonth = this.currentMonth + delta;
            var newYear = this.currentYear;

            var today = new Date();

            if (newMonth < 0) {
                newMonth = 11;
                newYear -= 1;
            } else if (newMonth > 11) {
                newMonth = 0;
                newYear += 1;
            }

            if (newYear > today.getFullYear() || (newYear === today.getFullYear() && newMonth > today.getMonth())) {
                return;
            }

            this.currentMonth = newMonth;
            this.currentYear = newYear;

            this.refreshMonths();
            this.updateNavButtons();
        },

        refreshMonths: function refreshMonths() {
            var this$1 = this;

            var monthNames = [
                'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
                'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
            ];

            var $monthsContainer = this.els.$wrapper.querySelector('.months-container');
            $monthsContainer.innerHTML = '';

            var monthsToShow = 3;
            var ref = this.getStartMonthYear(monthsToShow);
            var startMonth = ref.startMonth;
            var startYear = ref.startYear;
            var endMonth = this.currentMonth;
            var endYear = this.currentYear;

            var today = new Date();
            this.threeWeeksAgo = new Date();
            this.threeWeeksAgo.setDate(today.getDate() - 21);

            var startDate = new Date(startYear, startMonth, 1);
            var endDateObj = new Date(endYear, endMonth + 1, 0);
            var endDate = new Date(endDateObj.getFullYear(), endDateObj.getMonth(), endDateObj.getDate());
            var startDateStr = this.formatDate(startDate);
            var endDateStr = this.formatDate(endDate);

            EntryModeModal.loadUserEntryMode(function () {
                Promise.all([
                    this$1.getUserIndicatorData(startYear, startMonth, endYear, endMonth),
                    this$1.fetchMissingCount(EntryModeModal.entryMode, startDateStr, endDateStr)
                ])
                    .then(function (ref) {
                        var validatedDates = ref[0];
                        var missingCount = ref[1];

                        this$1.generateMonths(monthNames, today, validatedDates);

                        if (missingCount === 0) {
                            this$1.els.missingDay.style.display = 'none';
                        } else {
                            this$1.els.missingDay.textContent = "" + missingCount;
                        }
                    })
                    .catch(function (error) {
                        console.error('Error when fetching data:', error);
                        this$1.generateMonths(monthNames, today, []);
                    });
            });
        },

        updateNavButtons: function updateNavButtons() {
            var today = new Date();
            this.els.$nextButton.disabled = (
                this.currentYear === today.getFullYear() &&
                this.currentMonth === today.getMonth()
            );
        },

        toggleCalendarVisibility: function toggleCalendarVisibility() {
            var this$1 = this;

            var display = this.els.$wrapper.style.display;
            var newDisplay = (display === 'none' || display === '') ? 'flex' : 'none';
            this.els.$wrapper.style.display = newDisplay;

            if (newDisplay === 'flex') {
                requestAnimationFrame(function () {
                    this$1.els.$wrapper.scrollTop = this$1.els.$wrapper.scrollHeight;
                });
            }
        },

        formatDate: function formatDate(dateObj) {
            var year = dateObj.getFullYear();
            var month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
            var day = dateObj.getDate().toString().padStart(2, '0');
            return (year + "-" + month + "-" + day);
        },

        isSameDate: function isSameDate(date1, date2) {
            return (
                date1.getFullYear() === date2.getFullYear() &&
                date1.getMonth() === date2.getMonth() &&
                date1.getDate() === date2.getDate()
            );
        },

        getUserRegistrationDate: function getUserRegistrationDate() {
            var this$1 = this;

            return fetch(ajaxurl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                },
                body: new URLSearchParams({
                    'action': 'user_registration_date'
                })
            })
                .then(function (response) { return response.json(); })
                .then(function (data) {
                    if (data.success) {
                        this$1.registrationDate = new Date(data.data);
                        return data.data;
                    } else {
                        console.error('Error :', data.data);
                        return null;
                    }
                });
        }
    };

    var DataForm = {
        currentDate: new Date(),
        els: {
            hadVisits: null,
            tableList: null,
            tableCase: null,
            dataActions: null,
            tableFade: null,
            tableItems: null,
            dataDelete: null,
            inputs: null,
            tableInputs: null,
            tableCaseInput: null,
            dataCloseBtn: null,
            dataPopin: null,
            dataPreferences: null,
            dataPreferencesOverlay: null,
            dataPreferencesPolygon: null,
            dataSaveBtn: null,
            dataUpdateBtn: null,
            diseaseInfo: null,
            minusBtns: null,
            plusBtns: null,
            dataContainer: null,
            dataDate: null,
            dataDateContainer: null,
            dataNoEntry: null,
            dataWeek: null,
            indicatorCalendar: null,
        },
        init: function init() {
            if (document.body.classList.contains('page-template-page-login') ||
                document.body.classList.contains('page-template-page-inscription')
            ) {
                return;
            }
            this.els.$wrapper = document.querySelector('.js-data-form');
            if (this.els.$wrapper) {
                this.setupElements();
                this.bindEvents();
                this.setupLateElements();
                this.bindLateEvents();
                this.setupClickOutsideHandler();
            }
        },
        // Setup the elements
        setupElements: function setupElements() {
            this.els.hadVisits = document.querySelector('#had-visits');
            this.els.tableList = document.querySelector('.table__list');
            this.els.tableCase = document.querySelector('.table__case');
            this.els.dataActions = document.querySelector('.data__actions');
            this.els.tableFade = document.querySelector('.table__fade');
            this.els.tableItems = document.querySelector('.table__items');
            this.els.dataDelete = document.querySelector('#data__delete');
            this.els.dataCloseBtn = document.querySelector('.data__close__btn');
            this.els.dataPopin = document.querySelector('.data__popin');
            this.els.dataPreferences = document.querySelector('.data__preferences');
            this.els.dataPreferencesOverlay = document.querySelector('.data__preferences__overlay');
            this.els.dataPreferencesPolygon = document.querySelector('.preferences__polygon');
            this.els.dataSaveBtn = document.querySelector('#data__save');
            this.els.dataUpdate = document.querySelector('.data__update__container');
            this.els.dataContainer = document.querySelector('.data__container');
            this.els.dataDate = document.querySelector('.data__date');
            this.els.dataDateContainer = document.querySelector('.data__data__info');
            this.els.prevArrow = document.querySelector('.table__date img:first-child');
            this.els.nextArrow = document.querySelector('.table__date img:last-child');
            this.els.dataNoEntry = document.querySelector('.data__no__entry');
            this.els.dataWeek = document.querySelector('.data__week');
            this.els.dataUpdateBtn = document.querySelector('#data__update');
            this.els.indicatorCalendar = document.querySelector('.indicator__calendar');
        },
        // Setup the elements that are created after the initial setup
        setupLateElements: function setupLateElements() {
            this.els.inputs = document.querySelectorAll('input[type="number"]');
            this.els.tableInputs = document.querySelectorAll('.table__list input[type="number"]');
            this.els.tableCaseInput = document.querySelector('.table__case input[type="number"]');
            this.els.diseaseInfo = document.querySelectorAll('.disease__info');
            this.els.minusBtns = document.querySelectorAll('.item__case__minus, .item__visit__minus');
            this.els.plusBtns = document.querySelectorAll('.item__case__plus, .item__visit__plus');
        },
        // Bind events to the elements
        bindEvents: function bindEvents() {
            var this$1 = this;

            this.els.hadVisits.addEventListener('change', this.toggleVisits.bind(this));
            this.els.dataDelete.addEventListener('click', this.deleteData.bind(this));
            document.addEventListener('click', function (event) {
                if (event.target.classList.contains('item__case__plus') || event.target.classList.contains('item__visit__plus')) {
                    var input = event.target.previousElementSibling;
                    var currentValue = parseInt(input.value, 10);
                    input.value = isNaN(currentValue) ? 1 : currentValue + 1;
                    input.dispatchEvent(new Event('input'));
                } else if (event.target.classList.contains('item__case__minus') || event.target.classList.contains('item__visit__minus')) {
                    var input$1 = event.target.nextElementSibling;
                    var currentValue$1 = parseInt(input$1.value, 10);
                    input$1.value = isNaN(currentValue$1) || currentValue$1 <= 0 ? 0 : currentValue$1 - 1;
                    input$1.dispatchEvent(new Event('input'));
                }
            });
            this.els.dataCloseBtn.addEventListener('click', this.closeDataPopin.bind(this));
            this.els.dataPreferences.addEventListener('click', this.showPreferencesOverlay.bind(this));
            this.els.dataSaveBtn.addEventListener('click', this.saveData.bind(this));
            this.els.dataUpdateBtn.addEventListener('click', this.updateData.bind(this));
            document.addEventListener('DOMContentLoaded', this.updateDateDisplay.bind(this));

            this.els.prevArrow.addEventListener('click', this.changeDate.bind(this, -1));
            this.els.nextArrow.addEventListener('click', this.changeDate.bind(this, 1));

            this.els.dataDateContainer.addEventListener('click', function () {
                var isCalendarVisible = this$1.els.indicatorCalendar.style.display === 'flex';
                this$1.els.indicatorCalendar.style.display = isCalendarVisible ? 'none' : 'flex';
            });

            ProfileCompletion.init();
        },
        // Bind events to the elements that are created after the initial setup
        bindLateEvents: function bindLateEvents() {
            var this$1 = this;

            this.els.inputs.forEach(function (input) {
                input.addEventListener('input', this$1.limitInput.bind(this$1));
                input.addEventListener('focus', this$1.hideNumberPlaceholder.bind(this$1));
                input.addEventListener('blur', this$1.restorePlaceholder.bind(this$1));
            });
            this.els.tableInputs.forEach(function (input) {
                input.addEventListener('input', this$1.handleInputChange.bind(this$1));
            });

            document.querySelectorAll('.disease__info').forEach(function (icon) {
                icon.addEventListener('mouseenter', function (event) {
                    var tooltipText = event.target.getAttribute('data-tooltip');
                    if (!tooltipText) { return; }
                    var tooltip = document.createElement('div');
                    tooltip.className = 'disease__tooltip';
                    tooltip.innerText = tooltipText;
                    document.body.appendChild(tooltip);
                    var rect = event.target.getBoundingClientRect();
                    tooltip.style.top = (rect.top + window.scrollY - tooltip.offsetHeight - 12) + "px";
                    tooltip.style.left = (rect.left + rect.width / 2) + "px";
                    tooltip.style.transform = 'translateX(-50%)';
                    requestAnimationFrame(function () { return tooltip.classList.add('show'); });
                    event.target.tooltipElement = tooltip;
                });
                icon.addEventListener('mouseleave', function (event) {
                    var tooltip = event.target.tooltipElement;
                    if (tooltip) {
                        tooltip.remove();
                        event.target.tooltipElement = null;
                    }
                });
            });

            this.els.dataDateContainer.addEventListener('click', function () {
                IndicatorCalendar.toggleCalendarVisibility();
            });
        },
        // Show or hide the data list based on the hadVisits checkbox
        toggleVisits: function toggleVisits() {
            var displayStyle = this.els.hadVisits.checked ? 'none' : 'block';
            this.els.inputs.forEach(function (input) {
                input.value = '';
                input.placeholder = '0';
            });
            this.els.tableList.style.display = displayStyle;
            this.els.tableCase.style.display = this.els.hadVisits.checked ? 'none' : 'flex';
            this.els.dataDelete.style.display = displayStyle;
            this.els.tableFade.style.display = displayStyle;
        },
        // Update the diseases list with the data fetched from the database
        updateDiseasesList: function updateDiseasesList() {
            var this$1 = this;

            return new Promise(function (resolve) {
                this$1.request = utils.sendHTTPRequest({
                    url: ajaxurl,
                    method: 'POST',
                    body: {
                        action: 'get_user_indicators',
                    }
                });

                this$1.request.promise.then(function (data) {
                    this$1.els.tableItems.innerHTML = '';
                    if (data.message) {
                        this$1.els.tableItems.insertAdjacentHTML('beforeend', ("<p class=\"empty__indicator\">" + (data.message) + "</p>"));
                        resolve(false);
                        return;
                    }

                    var categories = {};
                    data.data.forEach(function (disease) {
                        if (!categories[disease.category_index]) {
                            categories[disease.category_index] = {
                                name: disease.category,
                                items: []
                            };
                        }
                        categories[disease.category_index].items.push(disease);
                    });

                    var sortedCategories = Object.values(categories).sort(function (a, b) { return a.category_index - b.category_index; });
                    var categoryTitleContainer = document.getElementById('categoryTitleContainer');
                    if (categoryTitleContainer && sortedCategories.length > 0) {
                        var firstCategory = sortedCategories[0];
                        categoryTitleContainer.innerHTML = "" + (firstCategory.name);
                    }

                    sortedCategories.forEach(function (category, index) {
                        if (index !== 0) {
                            var header = "<p class=\"table__header__title\">" + (category.name) + "</p>";
                            this$1.els.tableItems.insertAdjacentHTML('beforeend', header);
                        }
                        category.items.forEach(function (disease) {
                            var itemHTML = this$1.createItem(disease, category.name);
                            this$1.els.tableItems.insertAdjacentHTML('beforeend', itemHTML);
                        });
                    });

                    this$1.setupLateElements();
                    this$1.bindLateEvents();

                    EntryModeModal.loadUserEntryMode(function () {
                        if (!EntryModeModal.entryMode || EntryModeModal.entryMode === 'no_subscription') {
                            var modalTitle = "Mode de saisie";
                            var modalText = "Vous n'avez pas sélectionné de mode de saisie (journalier / hebdomadaire). Veuillez choisir le mode de saisie depuis la page <a href='/my-account'>Mon compte</a>.";
                            var modalConfirmText = "OK";
                            var modalType = "error";
                            modal.showInformationModal(modalTitle, modalText, modalConfirmText, modalType, function () {
                                modal.closeModal();
                            });
                            resolve(false);
                            this$1.updateDateDisplay(EntryModeModal.entryMode);
                        } else {
                            this$1.updateDateDisplay(EntryModeModal.entryMode);
                            this$1.getUserData();
                            resolve(true);
                        }
                    });
                }).catch(function (error) {
                    console.error('Error updating diseases list:', error);
                    var modalTitle = "Aucun indicateur";
                    var modalText = "Vous n'êtes abonné à aucun indicateur. Vous pouvez vous abonner depuis la page <a href='/my-account'>Mon compte</a>.";
                    var modalConfirmText = "OK";
                    var modalType = "error";
                    modal.showInformationModal(modalTitle, modalText, modalConfirmText, modalType, function () {
                        modal.closeModal();
                    });
                    resolve(false);
                });
            });
        },
        createItem: function createItem(disease, categoryName) {
            return ("\n        <div class=\"table__item\">\n            <p>" + (disease.title) + (disease.description ? ("<span class=\"disease__info\" data-tooltip=\"" + (disease.description) + "\">?</span>") : '') + "</p>\n            <div class=\"item__case\">\n                <span class=\"item__case__minus\">-</span>\n                <input name=\"" + (disease.id) + "\" type=\"number\" placeholder=\"0\" min=\"0\" max=\"999\" data-title=\"" + categoryName + "\"/>\n                <span class=\"item__case__plus\">+</span>\n            </div>\n        </div>\n    ");
        },
        // Delete the data when the delete button is clicked
        deleteData: function deleteData() {
            var this$1 = this;

            var message = "Êtes-vous sûr de vouloir supprimer ces données ?";
            var confirmText = "Confirmer";
            var cancelText = "Annuler";
            modal.showModal(message, confirmText, cancelText, function () {
                this$1.els.inputs.forEach(function (input) {
                    input.value = '';
                    input.placeholder = '0';
                });
            }, function () {
                modal.closeModal();
            });
        },
        // Close the data popin
        closeDataPopin: function closeDataPopin() {
            this.els.dataPopin.style.display = 'none';
            document.body.style.overflow = 'auto';
        },
        // Show or hide the data preferences overlay
        showPreferencesOverlay: function showPreferencesOverlay() {
            var isVisible = this.els.dataPreferencesOverlay.style.display === 'flex';
            this.els.dataPreferencesOverlay.style.display = isVisible ? 'none' : 'flex';
            this.els.dataPreferencesPolygon.style.display = isVisible ? 'none' : 'block';
            document.body.style.overflow = isVisible ? 'auto' : 'hidden';
        },
        // Limit the input to 3 characters
        limitInput: function limitInput(event) {
            var input = event.target;
            if (input.value.length > 3) {
                input.value = input.value.slice(0, 3);
            }
        },
        // Hide the placeholder when the input is focused
        hideNumberPlaceholder: function hideNumberPlaceholder(event) {
            event.target.placeholder = '';
        },
        // Restore the placeholder if the input is empty
        restorePlaceholder: function restorePlaceholder(event) {
            if (event.target.value === '') {
                event.target.placeholder = '0';
            }
        },
        // Save the data when the save button is clicked
        saveData: function saveData() {
            var this$1 = this;

            var confirmationMessage = "Êtes-vous sûr de vouloir valider ces données ?";
            var confirmText = "Confirmer";
            var cancelText = "Annuler";
            var countedCategory = '';

            fetch(ajaxurl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                },
                body: new URLSearchParams({
                    'action': 'indicator_category',
                })
            })
                .then(function (response) { return response.json(); })
                .then(function (data) {
                    if (data.success) {
                        countedCategory = data.data;
                        var inputsArray = Array.from(this$1.els.tableInputs);

                        var countedInputs = inputsArray.filter(function (input) { return input.dataset.title === countedCategory; });
                        var otherInputs = inputsArray.filter(function (input) { return input.dataset.title !== countedCategory; });

                        var soinsNonProgrammesInput = otherInputs[0];
                        var soinsNonProgrammesValue = soinsNonProgrammesInput ? (parseInt(soinsNonProgrammesInput.value, 10) || 0) : 0;

                        countedInputs.forEach(function (input) {
                            input.indicatorValue = parseInt(input.value, 10) || 0;
                        });
                        var totalIndicatorPatients = countedInputs.reduce(function (acc, input) { return acc + input.indicatorValue; }, 0);
                        var totalPatients = parseInt(this$1.els.tableCaseInput.value, 10) || 0;

                        var entryDate = this$1.parseFrenchDate(this$1.els.dataDate.innerHTML);
                        var currentDate = new Date();
                        var enteredDate = new Date(entryDate);

                        if (enteredDate > currentDate) {
                            var modalTitle = "Erreur";
                            var modalText = "La date saisie ne peut pas être une date future.";
                            var modalConfirmText = "OK";
                            var modalType = "error";
                            modal.showInformationModal(modalTitle, modalText, modalConfirmText, modalType, function () {
                                modal.closeModal();
                            });
                            return;
                        }

                        if (totalPatients < totalIndicatorPatients) {
                            var modalTitle$1 = "Erreur";
                            var modalText$1 = "Le nombre total de consultations doit être supérieur ou égal au nombre total de cas par indicateur.";
                            var modalConfirmText$1 = "OK";
                            var modalType$1 = "error";
                            modal.showInformationModal(modalTitle$1, modalText$1, modalConfirmText$1, modalType$1, function () {
                                modal.closeModal();
                            });
                            return;
                        }

                        if (soinsNonProgrammesValue > totalPatients) {
                            var modalTitle$2 = "Erreur";
                            var modalText$2 = "Le nombre total de soins non programmés ne peut jamais dépasser le nombre total de consultations.";
                            var modalConfirmText$2 = "OK";
                            var modalType$2 = "error";
                            modal.showInformationModal(modalTitle$2, modalText$2, modalConfirmText$2, modalType$2, function () {
                                modal.closeModal();
                            });
                            return;
                        }

                        modal.showModal(confirmationMessage, confirmText, cancelText, function () {
                            var saveRequests = inputsArray.map(function (input) {
                                var entryDate = this$1.parseFrenchDate(this$1.els.dataDate.innerHTML);

                                return utils.sendHTTPRequest({
                                    url: ajaxurl,
                                    method: 'POST',
                                    body: {
                                        action: 'save_dashboard_data',
                                        params: JSON.stringify({
                                            indicator_id: input.name,
                                            indicator_patients: input.value,
                                            total_patients: totalPatients,
                                            entry_date: entryDate,
                                            entry_mode: EntryModeModal.entryMode,
                                            is_validated: true
                                        }),
                                    },
                                }).promise;
                            });

                            Promise.all(saveRequests).then(function () {
                                this$1.disabledInputs();
                                modal.closeModal();
                                IndicatorCalendar.refreshMonths();
                            }).catch(function (error) {
                                console.error('Erreur lors de la sauvegarde des données:', error);
                                modal.closeModal();
                            });
                        }, function () {
                            modal.closeModal();
                        });
                    } else {
                        var modalTitle$3 = "Erreur de paramétrage back-office";
                        var modalText$3 = "Vous devez définir la catégorie d'indicateurs épidémiologiques.";
                        var modalConfirmText$3 = "OK";
                        var modalType$3 = "error";
                        modal.showInformationModal(modalTitle$3, modalText$3, modalConfirmText$3, modalType$3, function () {
                            modal.closeModal();
                        });
                    }
                })
                .catch(function (error) {
                    console.error('Error during fetch:', error);
                });
        },
        // Parse a French date string to a valid ISO date string
        parseFrenchDate: function parseFrenchDate(frenchDateString) {
            var months = {
                janvier: 0, février: 1, mars: 2, avril: 3, mai: 4, juin: 5,
                juillet: 6, août: 7, septembre: 8, octobre: 9, novembre: 10, décembre: 11
            };

            var parts = frenchDateString.split(' ');
            if (parts.length < 4) {
                console.error("Date format incorrect:", frenchDateString);
                return null;
            }

            var day = parseInt(parts[1], 10);
            var month = months[parts[2].toLowerCase()];
            var year = parseInt(parts[3], 10);

            if (isNaN(day) || isNaN(month) || isNaN(year)) {
                console.error("Erreur de parsing des parties de la date:", parts);
                return null;
            }
            var date = new Date(Date.UTC(year, month, day));

            return date.toISOString().slice(0, 10);
        },
        // Enable all inputs and show the data actions
        updateData: function updateData() {
            this.els.hadVisits.checked = false;
            this.els.dataActions.style.display = 'flex';
            this.els.tableList.style.display = 'block';
            this.els.tableCase.style.display = 'flex';
            this.els.dataDelete.style.display = 'flex';
            this.els.tableFade.style.display = 'flex';
            this.els.dataUpdate.style.display = 'none';
            this.els.inputs.forEach(function (input) {
                input.disabled = false;
            }, this);
            this.els.tableItems.style.filter = 'grayscale(0)';
            this.els.tableCase.style.filter = 'grayscale(0)';
            this.els.diseaseInfo.forEach(function (info) {
                info.style.display = 'unset';
            });
            this.els.plusBtns.forEach(function (button) { return button.style.pointerEvents = 'auto'; });
            this.els.minusBtns.forEach(function (button) { return button.style.pointerEvents = 'auto'; });
        },
        // Save the data when an input is changed
        handleInputChange: function handleInputChange() {
            var input = event.target;
            var totalPatients = parseInt(this.els.tableCaseInput.value, 10) || 0;
            var entryDate = this.parseFrenchDate(this.els.dataDate.innerHTML);

            this.saveRequest = utils.sendHTTPRequest({
                url: ajaxurl,
                method: 'POST',
                body: {
                    action: 'save_dashboard_data',
                    params: JSON.stringify({
                        indicator_id: input.name,
                        indicator_patients: input.value,
                        total_patients: totalPatients,
                        entry_date: entryDate,
                        is_validated: false
                    }),
                },
            });
        },
        // Change the date displayed in the data form
        changeDate: function changeDate(direction) {
            var dayIncrement = EntryModeModal.entryMode === 'weekly' ? 7 : 1;
            var newDate = new Date(this.currentDate);
            newDate.setDate(this.currentDate.getDate() + direction * dayIncrement);
            newDate.setHours(0, 0, 0, 0);

            var today = new Date();
            today.setHours(0, 0, 0, 0);

            if (newDate > today) {
                this.els.nextArrow.style.filter = 'grayscale(1)';
                this.els.nextArrow.style.pointerEvents = 'none';
                return;
            }

            this.els.prevArrow.style.filter = 'grayscale(0)';
            this.els.nextArrow.style.filter = 'grayscale(0)';

            this.currentDate = newDate;

            this.updateDateDisplay(EntryModeModal.entryMode);
            this.getUserData();
        },
        // Update the date display based on the current date and the entry mode
        updateDateDisplay: function updateDateDisplay(entryMode) {
            var today = new Date();
            today.setHours(0, 0, 0, 0);

            if (this.currentDate >= today) {
                this.els.nextArrow.style.filter = 'grayscale(1)';
                this.els.nextArrow.style.pointerEvents = 'none';
            } else {
                this.els.nextArrow.style.filter = 'grayscale(0)';
                this.els.nextArrow.style.pointerEvents = 'auto';
            }

            var dailyOptions = {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'};
            var weeklyOptions = {year: 'numeric', month: 'long', day: 'numeric'};
            var formattedDate = this.currentDate.toLocaleDateString('fr-FR', dailyOptions);

            if (entryMode === 'daily') {
                if (this.els.dataDate) {
                    this.els.dataDate.textContent = formattedDate;
                }
                if (this.els.dataNoEntry) {
                    this.els.dataNoEntry.textContent = "Pas de consultation aujourd’hui";
                }
            } else if (entryMode === 'weekly') {
                var weekStart = new Date(this.currentDate);
                weekStart.setDate(this.currentDate.getDate() - this.currentDate.getDay() + 1);

                var weekEnd = new Date(weekStart);
                weekEnd.setDate(weekStart.getDate() + 6);

                var formattedWeekStart = weekStart.toLocaleDateString('fr-FR', weeklyOptions);
                var formattedWeekEnd = weekEnd.toLocaleDateString('fr-FR', weeklyOptions);
                var weekNumber = this.getWeekNumber(weekStart);

                if (this.els.dataDate) {
                    this.els.dataDate.textContent = "Du " + formattedWeekStart + " au " + formattedWeekEnd;
                    this.els.dataWeek.textContent = "Semaine " + weekNumber;
                    this.els.dataDate.style.fontSize = '12px';
                    this.els.dataDate.style.fontWeight = '400';
                }
                if (this.els.dataNoEntry) {
                    this.els.dataNoEntry.textContent = "Pas de consultation cette semaine";
                }
            }
        },
        // Get the week number for a given date
        getWeekNumber: function getWeekNumber(date) {
            var tempDate = new Date(date);
            tempDate.setHours(0, 0, 0, 0);
            tempDate.setDate(tempDate.getDate() + 3 - (tempDate.getDay() || 7));

            var yearStart = new Date(tempDate.getFullYear(), 0, 1);
            var weekNumber = Math.ceil(((tempDate - yearStart) / 86400000 + 1) / 7);

            return weekNumber;
        },
        // Fetch the data for the current date
        getUserData: function getUserData() {
            var this$1 = this;

            if (!this.currentDate) {
                this.currentDate = new Date();
            }
            var entryMode = EntryModeModal.entryMode;

            this.currentDate.setHours(12, 0, 0, 0);
            var dateString = this.currentDate.toISOString().slice(0, 10);

            fetch(ajaxurl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                },
                body: new URLSearchParams({
                    'action': 'fetch_daily_data',
                    'date': dateString,
                    'entry_mode': entryMode
                })
            })
                .then(function (response) { return response.json(); })
                .then(function (data) {
                    if (data.success) {
                        this$1.updateInputs(data.data);
                    } else {
                        this$1.clearInputs();
                    }
                })
                .catch(function (error) {
                    console.error('Error during fetch:', error);
                });
        },
        // Update the inputs with the data fetched from the database
        updateInputs: function updateInputs(data) {
            var this$1 = this;

            data.forEach(function (item) {
                var input = document.querySelector(("input[name=\"" + (item.indicator_id) + "\"]"));
                if (input) {
                    input.value = item.indicator_patients;
                }

                var totalPatients = document.querySelector('.table__case input[type="number"]');
                if (totalPatients) {
                    totalPatients.value = item.total_patients;
                }

                if (item.is_validated === '1') {
                    this$1.disabledInputs();
                    this$1.els.hadVisits.checked = item.total_patients === '0';
                    var displayStyle = this$1.els.hadVisits.checked ? 'none' : 'block';

                    this$1.els.tableList.style.display = displayStyle;
                    this$1.els.tableCase.style.display = this$1.els.hadVisits.checked ? 'none' : 'flex';
                    this$1.els.dataDelete.style.display = displayStyle;
                    this$1.els.tableFade.style.display = displayStyle;
                }
            });
        },
        // Disable all inputs and hide the data actions
        disabledInputs: function disabledInputs() {
            this.els.dataActions.style.setProperty('display', 'none', 'important');
            this.els.dataUpdate.style.display = 'flex';
            this.els.inputs.forEach(function (input) {
                input.disabled = true;
            }, this);
            this.els.tableItems.style.filter = 'grayscale(1)';
            this.els.tableCase.style.filter = 'grayscale(1)';
            this.els.diseaseInfo.forEach(function (info) {
                info.style.display = 'none';
            });
            this.els.plusBtns.forEach(function (button) { return button.style.pointerEvents = 'none'; });
            this.els.minusBtns.forEach(function (button) { return button.style.pointerEvents = 'none'; });
        },
        // Clear all inputs and set them to 0
        clearInputs: function clearInputs() {
            this.els.hadVisits.checked = false;
            this.toggleVisits();
            this.updateData();
            var inputs = document.querySelectorAll('.table__items input[type="number"]');
            inputs.forEach(function (input) {
                input.value = '';
                input.placeholder = '0';
            });

            var totalPatientsInput = document.querySelector('.table__case input[type="number"]');
            if (totalPatientsInput) {
                totalPatientsInput.value = '';
                totalPatientsInput.placeholder = '0';
            }
        },
        // Set up a click outside handler to hide the indicator
        setupClickOutsideHandler: function setupClickOutsideHandler() {
            var this$1 = this;

            document.addEventListener('click', function (event) {
                var isClickInsideCalendar = IndicatorCalendar.els.$wrapper.contains(event.target);
                var isClickOnOpener = this$1.els.dataDateContainer.contains(event.target);

                if (!isClickInsideCalendar && !isClickOnOpener) {
                    IndicatorCalendar.els.$wrapper.style.display = 'none';
                }
            });
        },
    };

    var Dashboard = {
        els: {
            surveyList: null,
            alertsList: null,
            progressBar: null,
            surveysBtn: null,
            alertsBtn: null,
            openEntries: null,
        },
        init: function init() {
            var this$1 = this;

            this.els.$wrapper = document.querySelector('.js-dashboard');
            if (this.els.$wrapper) {
                ProfileCompletion.init()
                    .then(function () {
                        this$1.setupElements();
                        this$1.updateSurveyList();
                        this$1.updateAlertsList();
                        this$1.updateProgressInModal();

                        if (typeof showDashboardModal !== 'undefined' && showDashboardModal === true) {
                            this$1.showDashboardModal();
                        }
                    })
                    .catch(function (error) {
                        console.error('Erreur lors de l\'initialisation de progressBar:', error);
                    });
            }
        },
        setupElements: function setupElements() {
            this.els.surveyList = document.querySelector('.survey__list');
            this.els.alertsList = document.querySelector('.alerts__list');
            this.els.userPolygon = document.querySelector('.user__polygon');
            this.els.progressBar = document.querySelector('.progress__bar');
            this.els.surveysBtn = document.querySelector('.surveys__btn');
            this.els.alertsBtn = document.querySelector('#alerts__btn');
            this.els.surveysBtn = document.querySelector('.surveys__btn');
            this.els.openEntries = document.querySelectorAll('.open__entries');
        },

        updateSurveyList: function updateSurveyList() {
            var this$1 = this;

            this.request = utils.sendHTTPRequest({
                url: ajaxurl,
                method: 'POST',
                body: {
                    action: 'fetch_surveys',
                }
            });

            this.request.promise.then(function (data) {
                this$1.els.surveyList.innerHTML = '';
                if (data.message) {
                    this$1.els.surveyList.insertAdjacentHTML('beforeend', ("<p>" + (data.message) + "</p>"));
                    return;
                }
                data.surveys.forEach(function (survey, index) {
                    if (index < 3) {
                        this$1.els.surveyList.insertAdjacentHTML('beforeend', this$1.createSurveyItem(survey, index));
                    }
                    this$1.els.surveysBtn.style.display = 'flex';
                });
            }).catch(function (error) {
                console.error("error", error);
            });
        },

        createSurveyItem: function createSurveyItem(survey) {
            var date = new Date(survey.date_published);
            var formattedMonth = ("" + (date.getMonth() + 1)).padStart(2, '0');
            var formattedDay = ("" + (date.getDate())).padStart(2, '0');
            var formattedDate = formattedDay + "." + formattedMonth;

            return ("\n            <a href=\"/survey/" + (survey.slug) + "\" class=\"survey__item\">\n                <p class=\"survey__item__date\">" + formattedDate + "</p>\n                <p class=\"survey__item__title\">" + (survey.title) + "</p>\n            </a>\n        ");
        },

        updateAlertsList: function updateAlertsList() {
            var this$1 = this;

            this.request = utils.sendHTTPRequest({
                url: ajaxurl,
                method: 'POST',
                body: {
                    action: 'fetch_alerts',
                }
            });

            this.request.promise.then(function (data) {
                this$1.els.alertsList.innerHTML = '';
                if (data.message) {
                    this$1.els.alertsList.insertAdjacentHTML('beforeend', ("<p>" + (data.message) + "</p>"));
                    return;
                }
                data.alerts.forEach(function (alert, index) {
                    if (index < 3) {
                        this$1.els.alertsList.insertAdjacentHTML('beforeend', this$1.createAlertItem(alert, index));
                    }
                    this$1.els.alertsBtn.style.display = 'flex';
                });
            }).catch(function (error) {
                console.error("error", error);
            });
        },

        createAlertItem: function createAlertItem(alert) {
            var date = new Date(alert.date_published);
            var formattedMonth = ("" + (date.getMonth() + 1)).padStart(2, '0');
            var formattedDay = ("" + (date.getDate())).padStart(2, '0');
            var formattedDate = formattedDay + "." + formattedMonth;

            var categoryColor = alert.category && alert.category.color ? alert.category.color : '#1267a8';
            var categoryName = alert.category ? alert.category.name : 'General';

            return ("\n        <a href=\"/alert/" + (alert.slug) + "\" class=\"alert__item\">\n            <span class=\"alert__item__category alert__item__category--small\" \n            style=\"background-color: " + categoryColor + "\">" + categoryName + "</span>\n            <div>\n                <p class=\"alert__item__date\">" + formattedDate + "</p>\n                <p class=\"alert__item__title\">" + (alert.title) + "</p>\n            </div>\n        </a>\n    ");
        },

        updateProgressInModal: function () {
            var modalElement = document.querySelector('.dashboard__actions');
            if (modalElement) {
                ProfileCompletion.updateProgressInElement(modalElement);
            }
        },

        showDashboardModal: function showDashboardModal() {
            var this$1 = this;

            indicatorModal.showIndicatorModal();

            indicatorModal.onModalClose = function () {
                EntryModeModal.onModalClose = function () {
                    this$1.updateUserModalMeta();
                    this$1.updateProgressInModal();
                };
                this$1.updateProgressInModal();
            };
        },

        updateUserModalMeta: function updateUserModalMeta() {
            var this$1 = this;

            utils.sendHTTPRequest({
                url: ajaxurl,
                method: 'POST',
                body: {
                    action: 'update_user_modal_meta',
                    _wpnonce: modalNonce,
                },
            }).promise.then(function (response) {
                if (response.success) {
                    this$1.updateProgressInModal();
                } else {
                    console.error('Erreur lors de la mise à jour de la métadonnée.');
                }
            }).catch(function (error) {
                console.error('Erreur AJAX :', error);
            });
        },
    };

    var Alerts = {
        els: {
            alertsTable: null,
            paginationContainer: null,
            currentPage: 1,
            totalPages: 1,
            alertTableHeader: null,
        },
        init: function init() {
            this.els.$wrapper = document.querySelector('.alerts');
            if (this.els.$wrapper) {
                this.setupElements();
                this.updateAlertsList();
            }
        },
        setupElements: function setupElements() {
            this.els.alertsTable = document.querySelector('.alerts__table__items');
            this.els.paginationContainer = document.querySelector('.alerts__pagination');
            this.els.alertTableHeader = document.querySelector('.alerts__table__header');
        },
        updateAlertsList: function updateAlertsList(page, itemsPerPage) {
            var this$1 = this;
            if ( page === void 0 ) page = 1;
            if ( itemsPerPage === void 0 ) itemsPerPage = 6;

            this.els.currentPage = page;

            this.request = utils.sendHTTPRequest({
                url: ajaxurl,
                method: 'POST',
                body: {
                    action: 'fetch_alerts',
                    page: page,
                    items_per_page: itemsPerPage,
                }
            });

            this.request.promise.then(function (response) {
                var data = response;

                this$1.els.alertsTable.innerHTML = '';

                if (data.message) {
                    this$1.els.alertsTable.insertAdjacentHTML('beforeend', ("<p>" + (data.message) + "</p>"));
                    this$1.els.alertTableHeader.style.display = 'none';
                    return;
                }

                data.alerts.forEach(function (alert, index) {
                    this$1.els.alertsTable.insertAdjacentHTML('beforeend', this$1.createAlertItem(alert, index));
                });

                this$1.els.totalPages = data.total_pages;
                this$1.renderPagination();

            }).catch(function (error) {
                console.error("error", error);
            });
        },
        renderPagination: function renderPagination() {
            var this$1 = this;

            this.els.paginationContainer.innerHTML = '';

            if (this.els.totalPages <= 1) {
                return;
            }

            var paginationHTML = '';

            if (this.els.currentPage > 1) {
                paginationHTML +=
                    "<button class=\"pagination-btn pagination-arrow pagination-arrow-l\" data-page=\"" + (this.els.currentPage - 1) + "\">\n                <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"17.12\" height=\"17.948\" viewBox=\"0 0 17.12 17.948\">\n                <g id=\"Icon_feather-arrow-right\" data-name=\"Icon feather-arrow-right\" transform=\"translate(16.12 16.534) rotate(180)\">\n                    <path id=\"Tracé_263\" data-name=\"Tracé 263\" d=\"M0,0H15.12\" transform=\"translate(0 7.56)\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\"/>\n                    <path id=\"Tracé_264\" data-name=\"Tracé 264\" d=\"M0,0,7.56,7.56,0,15.12\" transform=\"translate(7.56 0)\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\"/>\n                </g>\n                </svg>\n            </button>";
            }

            for (var i = 1; i <= this.els.totalPages; i++) {
                if (i === this.els.currentPage) {
                    paginationHTML += "<span class=\"pagination-current\">" + i + "</span>";
                } else {
                    paginationHTML += "<button class=\"pagination-btn\" data-page=\"" + i + "\">" + i + "</button>";
                }
            }

            if (this.els.currentPage < this.els.totalPages) {
                paginationHTML +=
                    "<button class=\"pagination-btn pagination-arrow pagination-arrow-r\" data-page=\"" + (this.els.currentPage + 1) + "\" style=\"transform: rotate(180deg);\">\n                <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"17.12\" height=\"17.948\" viewBox=\"0 0 17.12 17.948\">\n                    <g id=\"Icon_feather-arrow-right\" data-name=\"Icon feather-arrow-right\" transform=\"translate(16.12 16.534) rotate(180)\">\n                        <path id=\"Tracé_263\" data-name=\"Tracé 263\" d=\"M0,0H15.12\" transform=\"translate(0 7.56)\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\"/>\n                        <path id=\"Tracé_264\" data-name=\"Tracé 264\" d=\"M0,0,7.56,7.56,0,15.12\" transform=\"translate(7.56 0)\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\"/>\n                    </g>\n                </svg>\n            </button>";
            }

            this.els.paginationContainer.innerHTML = paginationHTML;

            var paginationButtons = this.els.paginationContainer.querySelectorAll('.pagination-btn');
            paginationButtons.forEach(function (button) {
                button.addEventListener('click', function (event) {
                    var page = parseInt(event.currentTarget.getAttribute('data-page'), 10);
                    if (page !== this$1.els.currentPage) {
                        this$1.updateAlertsList(page);
                    }
                });
            });
        },
        createAlertItem: function createAlertItem(alert) {
            var date = new Date(alert.date_published);
            var formattedMonth = ("" + (date.getMonth() + 1)).padStart(2, '0');
            var formattedDay = ("" + (date.getDate())).padStart(2, '0');
            var formattedYear = "" + (date.getFullYear());
            var formattedDate = formattedDay + "/" + formattedMonth + "/" + formattedYear;

            var formattedcriticality = '';
            if (alert.criticality) {
                formattedcriticality = alert.criticality.slug
                    .toLowerCase()
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '');
            }

            function getImageElement(formattedcriticality) {
                return formattedcriticality ? ("<img src=\"/wp-content/themes/medvigie/assets/img/icon-criti-" + formattedcriticality + ".svg\" alt=\"criticality icon\">") : '';
            }

            var highestTerritory = '';
            var hasMoreLevels = false;

            if (alert.zone.region && alert.zone.region.length > 0) {
                highestTerritory = alert.zone.region[0].post_title;
                hasMoreLevels = alert.zone.region.length > 1 || (alert.zone.department && alert.zone.department.length > 0) || (alert.zone.cpts && alert.zone.cpts.length > 0);
            } else if (alert.zone.department && alert.zone.department.length > 0) {
                highestTerritory = alert.zone.department[0].post_title;
                hasMoreLevels = alert.zone.department.length > 1 || (alert.zone.cpts && alert.zone.cpts.length > 0);
            } else if (alert.zone.cpts && alert.zone.cpts.length > 0) {
                highestTerritory = alert.zone.cpts[0].post_title;
                hasMoreLevels = alert.zone.cpts.length > 1;
            }

            var categoryColor = alert.category && alert.category.color ? alert.category.color : '#1267a8';
            var categoryName = alert.category ? alert.category.name : 'General';

            return ("\n            <a href=\"/alert/" + (alert.slug) + "\" class=\"alert__table__item\">\n                <p class=\"alert__item__title\">" + (alert.title) + "</p>\n                <p class=\"alert__item__date\">" + formattedDate + "</p>\n                <p class=\"alert__item__zone\">" + highestTerritory + (hasMoreLevels ? '...' : '') + "</p>\n                <p class=\"alert__item__criticality\" style=\"color: " + (alert.criticality.color) + "\">\n                    " + (getImageElement(formattedcriticality)) + " \n                    " + (alert.criticality.name) + "\n                </p>\n                <p class=\"alert__item__category alert__item__category--small\" style=\"background-color: " + categoryColor + "\"><span>" + categoryName + "</span></p>\n            </a>\n        ");
        },
    };

    var Surveys = {
        els: {
            surveysTable: null,
            paginationContainer: null,
            currentPage: 1,
            totalPages: 1,
            surveyTableHeader: null,
            singleSurvey: null,
            surveyCompleted: null,
            surveyLink: null,
        },
        init: function init() {
            this.els.$wrapper = document.querySelector('.surveys');
            if (this.els.$wrapper) {
                this.setupElements();
                this.updateSurveysList();
            }
            this.els.$singleWrapper = document.querySelector('.single-survey');
            if (this.els.$singleWrapper) {
                this.checkIfCompleted();
                this.setupSingleElements();
            }
        },
        setupElements: function setupElements() {
            this.els.surveysTable = document.querySelector('.surveys__table__items');
            this.els.paginationContainer = document.querySelector('.surveys__pagination');
            this.els.surveyTableHeader = document.querySelector('.surveys__table__header');
        },
        setupSingleElements: function setupSingleElements() {
            this.els.surveyLink = document.getElementById('surveyLink');
            this.els.surveyCompleted = document.querySelector('.survey-completed');
        },
        updateSurveysList: function updateSurveysList(page, itemsPerPage) {
            var this$1 = this;
            if ( page === void 0 ) page = 1;
            if ( itemsPerPage === void 0 ) itemsPerPage = 6;

            this.els.currentPage = page;

            this.request = utils.sendHTTPRequest({
                url: ajaxurl,
                method: 'POST',
                body: {
                    action: 'fetch_surveys',
                    page: page,
                    items_per_page: itemsPerPage,
                }
            });

            this.request.promise.then(function (response) {
                var data = response;

                this$1.els.surveysTable.innerHTML = '';

                if (data.message) {
                    this$1.els.surveysTable.insertAdjacentHTML('beforeend', ("<p>" + (data.message) + "</p>"));
                    this$1.els.surveyTableHeader.style.display = 'none';
                    return;
                }

                data.surveys.forEach(function (survey, index) {
                    this$1.els.surveysTable.insertAdjacentHTML('beforeend', this$1.createSurveyItem(survey, index));
                });

                this$1.els.totalPages = data.total_pages;
                this$1.renderPagination();

            }).catch(function (error) {
                console.error("error", error);
            });
        },
        renderPagination: function renderPagination() {
            var this$1 = this;

            this.els.paginationContainer.innerHTML = '';

            if (this.els.totalPages <= 1) {
                return;
            }

            var paginationHTML = '';

            // Bouton "Précédent"

            if (this.els.currentPage > 1) {
                paginationHTML +=
                    "<button class=\"pagination-btn pagination-arrow pagination-arrow-l\" data-page=\"" + (this.els.currentPage - 1) + "\">\n                <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"17.12\" height=\"17.948\" viewBox=\"0 0 17.12 17.948\">\n                    <g id=\"Icon_feather-arrow-right\" data-name=\"Icon feather-arrow-right\" transform=\"translate(16.12 16.534) rotate(180)\">\n                        <path id=\"Tracé_263\" data-name=\"Tracé 263\" d=\"M0,0H15.12\" transform=\"translate(0 7.56)\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\"/>\n                        <path id=\"Tracé_264\" data-name=\"Tracé 264\" d=\"M0,0,7.56,7.56,0,15.12\" transform=\"translate(7.56 0)\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\"/>\n                    </g>\n                </svg>\n            </button>";
            }

            for (var i = 1; i <= this.els.totalPages; i++) {
                if (i === this.els.currentPage) {
                    paginationHTML += "<span class=\"pagination-current\">" + i + "</span>";
                } else {
                    paginationHTML += "<button class=\"pagination-btn\" data-page=\"" + i + "\">" + i + "</button>";
                }
            }

            if (this.els.currentPage < this.els.totalPages) {
                paginationHTML +=
                    "<button class=\"pagination-btn pagination-arrow pagination-arrow-r\" data-page=\"" + (this.els.currentPage + 1) + "\" style=\"transform: rotate(180deg);\">\n                <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"17.12\" height=\"17.948\" viewBox=\"0 0 17.12 17.948\">\n                    <g id=\"Icon_feather-arrow-right\" data-name=\"Icon feather-arrow-right\" transform=\"translate(16.12 16.534) rotate(180)\">\n                        <path id=\"Tracé_263\" data-name=\"Tracé 263\" d=\"M0,0H15.12\" transform=\"translate(0 7.56)\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\"/>\n                        <path id=\"Tracé_264\" data-name=\"Tracé 264\" d=\"M0,0,7.56,7.56,0,15.12\" transform=\"translate(7.56 0)\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\"/>\n                    </g>\n                </svg>\n            </button>";
            }

            this.els.paginationContainer.innerHTML = paginationHTML;

            var paginationButtons = this.els.paginationContainer.querySelectorAll('.pagination-btn');
            paginationButtons.forEach(function (button) {
                button.addEventListener('click', function (event) {
                    var page = parseInt(event.currentTarget.getAttribute('data-page'), 10);
                    if (page !== this$1.els.currentPage) {
                        this$1.updateSurveysList(page); // Naviguer vers la page choisie
                    }
                });
            });
        },
        createSurveyItem: function createSurveyItem(survey, index) {
            var date = new Date(survey.date_published);
            var formattedMonth = ("" + (date.getMonth() + 1)).padStart(2, '0');
            var formattedDay = ("" + (date.getDate())).padStart(2, '0');
            var formattedYear = "" + (date.getFullYear());
            var formattedDate = formattedDay + "/" + formattedMonth + "/" + formattedYear;

            var state = '';
            var formattedState = '';

            fetch(ajaxurl, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                    'action': 'gw_check_survey_status',
                    'form_id': survey.form_id,
                })
            })
                .then(function (response) { return response.json(); })
                .then(function (data) {
                    if (data.success) {
                        state = data.data.status;
                        formattedState = state.replace(/\s+/g, '').toLowerCase();
                    } else {
                        console.error('Failed to check completion status', data);
                    }
                    document.querySelector(("#survey-item-" + index + " .survey__item__state")).textContent = state;
                    document.querySelector(("#survey-item-" + index)).classList.add(("survey__item__state--" + formattedState));
                })
                .catch(function (error) {
                    console.error("Error", error);
                });
            return ("\n        <div class=\"survey__table__item\" id=\"survey-item-" + index + "\">\n            <p class=\"survey__item__title\">" + (survey.title) + "</p>\n            <p class=\"survey__item__date\">" + formattedDate + "</p>\n            <div class=\"survey__item__actions\">\n                <a href=\"/survey/" + (survey.slug) + "\">\n                    <div class=\"survey__item__view\" title=\"Visualiser l'enquête\">\n                        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18.363\" height=\"12.52\" viewBox=\"0 0 18.363 12.52\">\n                            <path id=\"Icon_material-remove-red-eye\" data-name=\"Icon material-remove-red-eye\" d=\"M10.681,6.75A9.871,9.871,0,0,0,1.5,13.01a9.863,9.863,0,0,0,18.363,0A9.871,9.871,0,0,0,10.681,6.75Zm0,10.433a4.173,4.173,0,1,1,4.173-4.173A4.175,4.175,0,0,1,10.681,17.183Zm0-6.677a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,10.681,10.506Z\" transform=\"translate(-1.5 -6.75)\" fill=\"#fff\"/>\n                        </svg>\n                    </div>\n                </a>\n                <a class=\"survey__edit\" href=\"/survey-form?form_id=" + (survey.form_id) + "\">\n                    <div class=\"survey__item__edit\" title=\"Répondre à l'enquête\">\n                        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18.531\" height=\"16.469\" viewBox=\"0 0 18.531 16.469\">\n                            <path id=\"Icon-edit\" d=\"M12.953,2.681l2.9,2.9a.315.315,0,0,1,0,.444L8.828,13.053l-2.986.331a.626.626,0,0,1-.692-.692l.331-2.986,7.026-7.026A.315.315,0,0,1,12.953,2.681Zm5.212-.737L16.594.374a1.258,1.258,0,0,0-1.776,0L13.68,1.513a.315.315,0,0,0,0,.444l2.9,2.9a.315.315,0,0,0,.444,0L18.164,3.72a1.258,1.258,0,0,0,0-1.776Zm-5.81,9.2v3.275H2.059V4.122H9.452a.4.4,0,0,0,.273-.113l1.287-1.287a.386.386,0,0,0-.273-.66H1.544A1.545,1.545,0,0,0,0,3.607V14.932a1.545,1.545,0,0,0,1.544,1.544H12.869a1.545,1.545,0,0,0,1.544-1.544V9.855a.387.387,0,0,0-.66-.273l-1.287,1.287A.4.4,0,0,0,12.354,11.142Z\" transform=\"translate(0 -0.007)\" fill=\"#fff\"/>\n                        </svg>\n                    </div>\n                </a>\n            </div>\n            <p class=\"survey__item__state\"></p>\n        </div>\n    ");
        },
        checkIfCompleted: function checkIfCompleted() {
            var this$1 = this;

            var state = '';
            var surveyID = document.querySelector('.dashboard__content').getAttribute('data-survey-id');
            
            fetch(ajaxurl, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                    'action': 'gw_check_survey_status',
                    'form_id': surveyID,
                })
            })
                .then(function (response) {
                    return response.json();
                })
                .then(function (data) {
                    if (data.success) {
                        state = data.data.status;
                        if (state === 'Finalisée') {
                            this$1.els.surveyLink.style.display = 'none';
                            this$1.els.surveyCompleted.style.display = 'block';
                        } else {
                            this$1.els.surveyLink.style.display = 'flex';
                        }
                    } else {
                        this$1.els.surveyLink.style.display = 'flex';
                    }
                })
                .catch(function (error) {
                    this$1.els.surveyLink.style.display = 'flex';
                });
        }
    };

    var Header = {
        els: {
            userActionsBtn: null,
            userActions: null,
            userPolygon: null,
            openEntries: null,
            mobileHeaderBtn: null,
            sidebar: null,
            sidebarCloseBtn: null,
            sidebarBackground: null,
        },

        init: function init() {
            this.els.$wrapper = document.querySelector('.dashboard__actions');
            if (this.els.$wrapper) {
                this.setupElements();
                this.bindEvents();
                this.bindOutsideClicks();
            }
        },

        setupElements: function setupElements() {
            this.els.userActionsBtn = document.querySelector('.user__actions__btn');
            this.els.userActions = document.querySelector('.user__actions');
            this.els.userPolygon = document.querySelector('.user__polygon');
            this.els.openEntries = document.querySelectorAll('.open__entries');
            this.els.mobileHeaderBtn = document.querySelector('.button__sidebar__mobile');
            this.els.sidebar = document.querySelector('.dashboard__sidebar');
            this.els.sidebarCloseBtn = document.querySelector('.sidebar__close__btn');
            this.els.sidebarBackground = document.querySelector('.sidebar__background');
        },

        bindEvents: function bindEvents() {
            var this$1 = this;

            if (this.els.userActionsBtn) {
                this.els.userActionsBtn.addEventListener('click', function (e) {
                    this$1.toggleUserActions(this$1.els.userActions, this$1.els.userPolygon);
                    e.stopPropagation();
                });
            }

            if (this.els.mobileHeaderBtn && window.innerWidth < 1024) {
                this.els.mobileHeaderBtn.addEventListener('click', function (e) {
                    this$1.toggleSidebarMobile();
                    e.stopPropagation();
                });
            }

            if (this.els.sidebarCloseBtn) {
                this.els.sidebarCloseBtn.addEventListener('click', function () {
                    this$1.closeSidebarMobile();
                });
            }

            if (this.els.openEntries) {
                this.els.openEntries.forEach(function (entry) {
                    entry.addEventListener('click', function () { return this$1.showEntriesPopin(entry); });
                });
            }

            document.addEventListener("DOMContentLoaded", function () {
                var urlParams = new URLSearchParams(window.location.search);

                if (urlParams.has('login_success') && urlParams.get('source') === 'email_notification') {
                    Header.showEntriesPopin();
                    window.history.replaceState(null, "", window.location.pathname);
                }
            });
        },

        bindOutsideClicks: function bindOutsideClicks() {
            var this$1 = this;

            document.addEventListener('click', function (e) {
                if (
                    this$1.isSidebarOpen() &&
                    !this$1.els.sidebar.contains(e.target) &&
                    !this$1.els.mobileHeaderBtn.contains(e.target)
                ) {
                    this$1.closeSidebarMobile();
                }

                if (
                    this$1.els.userActions &&
                    !this$1.els.userActions.contains(e.target) &&
                    !this$1.els.userActionsBtn.contains(e.target) &&
                    this$1.els.userActions.style.display === 'flex'
                ) {
                    this$1.toggleUserActions(this$1.els.userActions, this$1.els.userPolygon);
                }
            });

            this.els.sidebar.querySelectorAll('a, button').forEach(function (el) {
                el.addEventListener('click', function () {
                    if (this$1.isSidebarOpen()) {
                        this$1.closeSidebarMobile();
                    }
                });
            });
        },

        isSidebarOpen: function isSidebarOpen() {
            return this.els.sidebar.classList.contains('dashboard__sidebar--mobile');
        },

        toggleUserActions: function toggleUserActions(actionsElement, polygonElement) {
            var isCurrentlyVisible = actionsElement.style.display === 'flex';
            actionsElement.style.display = isCurrentlyVisible ? 'none' : 'flex';
            polygonElement.style.display = isCurrentlyVisible ? 'none' : 'block';
        },

        toggleSidebarMobile: function toggleSidebarMobile() {
            this.els.sidebar.classList.toggle('dashboard__sidebar--mobile');
            this.els.sidebarBackground.style.display = this.isSidebarOpen() ? 'block' : 'none';
        },

        closeSidebarMobile: function closeSidebarMobile() {
            this.els.sidebar.classList.remove('dashboard__sidebar--mobile');
            this.els.sidebarBackground.style.display = 'none';
        },

        showEntriesPopin: function showEntriesPopin() {
            DataForm.updateDiseasesList().then(function (updateSuccess) {
                if (updateSuccess) {
                    document.querySelector('.data__popin').style.display = 'flex';
                    document.querySelector('.data__container').style.animation = 'slideDown 0.2s ease-out forwards';
                    document.body.style.overflow = 'hidden';
                }
            });
        },
    };

    var MyAccount = {
        entryMode: null,
        allEpidemy: null,
        selectedDiseases: [],
        currentEditingIndex: null,
        alreadyAllselected: false,
        allCpts: null,
        els: {
            $wrapper: null,
            $userName: null,
            $userFirstName: null,
            $userLastName: null,
            $userEmail: null,
            $userPhone: null,
            $userAddress: [],
            $userEpidemy: null,
            $userEpidemyJson: null,
            $userEpidemyAfterSave: false,
            $userSpecialty: null,
            $userAlerts: null,
            $userRpps: null,
            $userNameHtml: null,
            $userEmailHtml: null,
            $userPhoneHtml: null,
            $userAddressHtml: null,
            $userRppsHtml: null,
            $userEpidemyHtml: null,
            $userSpecialtyHtml: null,
            $accountFormFrequency: null,
        },
        init: function init() {
            var this$1 = this;

            this.els.$wrapper = document.querySelector(".js-my-account");
            if (!this.els.$wrapper) {
                return;
            }
            if (this.els.$wrapper) {
                window.addEventListener("loadeddata", function () {
                    var page = document.querySelector("#page");
                    page.style.height = "fit-content !important";
                });
                this.els.$userNameHtml =
                    this.els.$wrapper.querySelector("#name .form__data");
                this.els.$userEmailHtml =
                    this.els.$wrapper.querySelector("#mail .form__data");
                this.els.$userPhoneHtml =
                    this.els.$wrapper.querySelector("#phone .form__data");
                this.els.$userAddressHtml = this.els.$wrapper.querySelector(
                    "#address .form__data"
                );
                this.els.$userSpecialtyHtml = this.els.$wrapper.querySelector("#specialty .form__data");
                this.els.$userRppsHtml = this.els.$wrapper.querySelector("#rrps__text");
                this.els.$allInput = this.els.$wrapper.querySelectorAll(
                    ".account__update__data input, .account__update__data select"
                );
                this.els.$userEpidemyHtml = this.els.$wrapper.querySelector(
                    "#epidemy .form__data"
                );
                Promise.all([
                    this.loadData(),
                    this.initEvents() ]).then(function () {
                    setTimeout(function () {
                        this$1.calculatePercentage();
                        if (this$1.els.$userEpidemyHtml.innerHTML === "") {
                            this$1.updateIndicatorButtons();
                        }
                    }, 2400);
                });
            }
        },
        initEvents: function initEvents() {
            var this$1 = this;

            //Check all input content for effect css label
            if (this.els.$allInput) {
                this.els.$allInput.forEach(function (input) {
                    input.addEventListener("input", function () {
                        this$1.checkInputContent(input);
                    });
                });
            }

            //Open name update
            this.els.$wrapper
                .querySelector("#name .update__button")
                .addEventListener("click", function (e) {
                    e.preventDefault();
                    this$1.greyOutSection("name");
                    this$1.els.$wrapper.querySelector("#update_name .firstname").value =
                        this$1.els.$userFirstName;
                    this$1.els.$wrapper.querySelector("#update_name .lastname").value =
                        this$1.els.$userLastName;
                    this$1.els.$wrapper.querySelector(
                        "#name .account__actual__data"
                    ).style.display = "none";
                    this$1.els.$wrapper.querySelector(
                        "#name .account__actual__data"
                    ).style.visibility = "hidden";
                    this$1.els.$wrapper.querySelector("#name .update__button").style.display =
                        "none";
                    this$1.els.$wrapper.querySelector(
                        "#name .update__button"
                    ).style.visibility = "hidden";
                    this$1.els.$wrapper.querySelector(
                        "#name .account__update__data"
                    ).style.display = "flex";
                    this$1.els.$wrapper
                        .querySelector("#update_name .lastname")
                        .classList.add("has-content");
                    this$1.els.$wrapper
                        .querySelector("#update_name .firstname")
                        .classList.add("has-content");
                });
            //Close name update
            this.els.$wrapper
                .querySelector("#name .skip__button")
                .addEventListener("click", function () {
                    this$1.clearSection();
                    this$1.els.$wrapper.querySelector(
                        "#name .account__actual__data"
                    ).style.display = "flex";
                    this$1.els.$wrapper.querySelector(
                        "#name .account__actual__data"
                    ).style.visibility = "visible";
                    this$1.els.$wrapper.querySelector("#name .update__button").style.display =
                        "block";
                    this$1.els.$wrapper.querySelector(
                        "#name .update__button"
                    ).style.visibility = "visible";
                    this$1.els.$wrapper.querySelector(
                        "#name .account__update__data"
                    ).style.display = "none";
                });
            //Open mail update
            this.els.$wrapper
                .querySelector("#mail .update__button")
                .addEventListener("click", function (e) {
                    e.preventDefault();
                    this$1.greyOutSection("mail");
                    this$1.els.$wrapper.querySelector("#mail .input-field ").value =
                        this$1.els.$userEmail;
                    this$1.els.$wrapper.querySelector(
                        "#mail .account__actual__data"
                    ).style.display = "none";
                    this$1.els.$wrapper.querySelector(
                        "#mail .account__actual__data"
                    ).style.visibility = "hidden";
                    this$1.els.$wrapper.querySelector("#mail .update__button").style.display =
                        "none";
                    this$1.els.$wrapper.querySelector(
                        "#mail .update__button"
                    ).style.visibility = "hidden";
                    this$1.els.$wrapper.querySelector(
                        "#mail .account__update__data"
                    ).style.display = "flex";
                    this$1.els.$wrapper
                        .querySelector("#mail .input-field")
                        .classList.add("has-content");
                });
            //Close mail update
            this.els.$wrapper
                .querySelector("#mail .skip__button")
                .addEventListener("click", function () {
                    this$1.clearSection();
                    this$1.els.$wrapper.querySelector(
                        "#mail .account__actual__data"
                    ).style.display = "flex";
                    this$1.els.$wrapper.querySelector(
                        "#mail .account__actual__data"
                    ).style.visibility = "visible";
                    this$1.els.$wrapper.querySelector("#mail .update__button").style.display =
                        "block";
                    this$1.els.$wrapper.querySelector(
                        "#mail .update__button"
                    ).style.visibility = "visible";
                    this$1.els.$wrapper.querySelector(
                        "#mail .account__update__data"
                    ).style.display = "none";
                });
            //open phone update
            this.els.$wrapper
                .querySelector("#phone .update__button")
                .addEventListener("click", function (e) {
                    e.preventDefault();
                    this$1.greyOutSection("phone");
                    this$1.els.$wrapper.querySelector("#phone .input-field ").value =
                        this$1.els.$userPhone;
                    this$1.els.$wrapper.querySelector(
                        "#phone .account__actual__data"
                    ).style.display = "none";
                    this$1.els.$wrapper.querySelector(
                        "#phone .account__actual__data"
                    ).style.visibility = "hidden";
                    this$1.els.$wrapper.querySelector(
                        "#phone .update__button"
                    ).style.display = "none";
                    this$1.els.$wrapper.querySelector(
                        "#phone .update__button"
                    ).style.visibility = "hidden";
                    this$1.els.$wrapper.querySelector(
                        "#phone .account__update__data"
                    ).style.display = "flex";
                    this$1.els.$wrapper
                        .querySelector("#phone .input-field")
                        .classList.add("has-content");
                });
            //Close phone update
            this.els.$wrapper
                .querySelector("#phone .skip__button")
                .addEventListener("click", function () {
                    this$1.clearSection();
                    this$1.els.$wrapper.querySelector(
                        "#phone .account__actual__data"
                    ).style.display = "flex";
                    this$1.els.$wrapper.querySelector(
                        "#phone .account__actual__data"
                    ).style.visibility = "visible";
                    this$1.els.$wrapper.querySelector(
                        "#phone .update__button"
                    ).style.display = "block";
                    this$1.els.$wrapper.querySelector(
                        "#phone .update__button"
                    ).style.visibility = "visible";
                    this$1.els.$wrapper.querySelector(
                        "#phone .account__update__data"
                    ).style.display = "none";
                });
            //Open address update
            this.els.$wrapper
                .querySelector("#address .update__button")
                .addEventListener("click", function (e) {
                    e.preventDefault();
                    this$1.greyOutSection("address");
                    this$1.els.$wrapper.querySelector(
                        "#address .account__actual__data"
                    ).style.display = "none";
                    this$1.els.$wrapper.querySelector(
                        "#address .account__actual__data"
                    ).style.visibility = "hidden";
                    this$1.els.$wrapper.querySelector(
                        "#address .update__button"
                    ).style.display = "none";
                    this$1.els.$wrapper.querySelector(
                        "#address .update__button"
                    ).style.visibility = "hidden";
                    this$1.els.$wrapper.querySelector(
                        "#address .account__update__data"
                    ).style.display = "block";
                    this$1.updateAddressesList();
                    this$1.els.$wrapper
                        .querySelector("#add__address__btn")
                        .addEventListener("click", function () {
                            this$1.currentEditingIndex = null;
                            this$1.showAddAddressForm();
                        });
                    this$1.els.$wrapper
                        .querySelector("#update_address .update__new__data")
                        .addEventListener("click", function (e) {
                            e.preventDefault();
                            this$1.updateAddressInDatabase();
                            this$1.els.$wrapper.querySelector("#address .skip__button").click();
                        });
                });
            //Close address update
            this.els.$wrapper
                .querySelector("#address .skip__button")
                .addEventListener("click", function () {
                    this$1.clearSection();
                    this$1.els.$wrapper.querySelector(
                        "#address .account__actual__data"
                    ).style.display = "flex";
                    this$1.els.$wrapper.querySelector(
                        "#address .account__actual__data"
                    ).style.visibility = "visible";
                    this$1.els.$wrapper.querySelector(
                        "#address .update__button"
                    ).style.display = "block";
                    this$1.els.$wrapper.querySelector(
                        "#address .update__button"
                    ).style.visibility = "visible";
                    this$1.els.$wrapper.querySelector(
                        "#address .account__update__data"
                    ).style.display = "none";
                    this$1.loadUserAddress();
                });

            //open password update
            this.els.$wrapper
                .querySelector("#password .update__button")
                .addEventListener("click", function (e) {
                    e.preventDefault();
                    this$1.greyOutSection("password");
                    this$1.els.$wrapper.querySelector(
                        "#password .account__actual__data"
                    ).style.display = "none";
                    this$1.els.$wrapper.querySelector(
                        "#password .account__actual__data"
                    ).style.visibility = "hidden";
                    this$1.els.$wrapper.querySelector(
                        "#password .update__button"
                    ).style.display = "none";
                    this$1.els.$wrapper.querySelector(
                        "#password .update__button"
                    ).style.visibility = "hidden";
                    this$1.els.$wrapper.querySelector(
                        "#password .account__update__data"
                    ).style.display = "flex";
                });
            //Close password update
            this.els.$wrapper
                .querySelector("#password .skip__button")
                .addEventListener("click", function () {
                    this$1.clearSection();
                    this$1.els.$wrapper.querySelector(
                        "#password .account__actual__data"
                    ).style.display = "flex";
                    this$1.els.$wrapper.querySelector(
                        "#password .account__actual__data"
                    ).style.visibility = "visible";
                    this$1.els.$wrapper.querySelector(
                        "#password .update__button"
                    ).style.display = "block";
                    this$1.els.$wrapper.querySelector(
                        "#password .update__button"
                    ).style.visibility = "visible";
                    this$1.els.$wrapper.querySelector(
                        "#password .account__update__data"
                    ).style.display = "none";
                });

            //open epidemy update
            this.els.$wrapper
                .querySelector("#epidemy .update__button")
                .addEventListener("click", function (e) {
                    e.preventDefault();
                    this$1.fetchAllEpidemy();
                    this$1.greyOutSection("epidemy");
                    this$1.els.$wrapper.querySelector(
                        "#epidemy .account__actual__data"
                    ).style.display = "none";
                    this$1.els.$wrapper.querySelector(
                        "#epidemy .account__actual__data"
                    ).style.visibility = "hidden";
                    this$1.els.$wrapper.querySelector(
                        "#epidemy .update__button"
                    ).style.display = "none";
                    this$1.els.$wrapper.querySelector(
                        "#epidemy .update__button"
                    ).style.visibility = "hidden";
                    this$1.els.$wrapper.querySelector(
                        "#epidemy .account__update__data"
                    ).style.display = "flex";
                    this$1.els.$wrapper
                        .querySelectorAll(" #epidemy.indicator-options input")
                        .forEach(function (input) {
                            input.checked = false;
                        });
                    this$1.toogleEpidemySelection();
                    this$1.els.$wrapper.querySelectorAll(".indicator-btn").forEach(function (button) {
                        button.addEventListener("click", function (event) {
                            var id = parseInt(event.target.getAttribute('data-indicator-id'));
                            var index = this$1.selectedDiseases.indexOf(id);
                            if (index > -1) {
                                this$1.selectedDiseases.splice(index, 1);
                            } else {
                                this$1.selectedDiseases.push(id);
                            }
                            this$1.setupRadioListeners();
                            this$1.updateIndicatorButtons();
                        });
                    });
                });
            //Close epidemy update
            this.els.$wrapper
                .querySelector("#epidemy .skip__button")
                .addEventListener("click", function () {
                    this$1.clearSection();
                    this$1.els.$wrapper.querySelector(
                        "#epidemy .account__actual__data"
                    ).style.display = "flex";
                    this$1.els.$wrapper.querySelector(
                        "#epidemy .account__actual__data"
                    ).style.visibility = "visible";
                    this$1.els.$wrapper.querySelector(
                        "#epidemy .update__button"
                    ).style.display = "block";
                    this$1.els.$wrapper.querySelector(
                        "#epidemy .update__button"
                    ).style.visibility = "visible";
                    this$1.els.$wrapper.querySelector(
                        "#epidemy .account__update__data"
                    ).style.display = "none";
                });
            //Open frequency update
            this.els.$wrapper
                .querySelector("#frequency .update__button")
                .addEventListener("click", function (e) {
                    e.preventDefault();
                    this$1.greyOutSection("frequency");
                    this$1.els.$wrapper.querySelector(
                        "#frequency .account__actual__data"
                    ).style.display = "none";
                    this$1.els.$wrapper.querySelector(
                        "#frequency .account__actual__data"
                    ).style.visibility = "hidden";
                    this$1.els.$wrapper.querySelector(
                        "#frequency .update__button"
                    ).style.display = "none";
                    this$1.els.$wrapper.querySelector(
                        "#frequency .update__button"
                    ).style.visibility = "hidden";
                    this$1.els.$wrapper.querySelector("#update_frequency").style.display =
                        "flex";
                    this$1.els.$wrapper.querySelector(
                        "#frequency .skip__button"
                    ).style.display = "block";
                });
            //Close frequency
            this.els.$wrapper
                .querySelector("#frequency .skip__button")
                .addEventListener("click", function () {
                    this$1.clearSection();
                    this$1.els.$wrapper.querySelector(
                        "#frequency .account__actual__data"
                    ).style.display = "flex";
                    this$1.els.$wrapper.querySelector(
                        "#frequency .account__actual__data"
                    ).style.visibility = "visible";
                    this$1.els.$wrapper.querySelector(
                        "#frequency .update__button"
                    ).style.display = "block";
                    this$1.els.$wrapper.querySelector(
                        "#frequency .update__button"
                    ).style.visibility = "visible";
                    this$1.els.$wrapper.querySelector("#update_frequency").style.display =
                        "none";
                    this$1.els.$wrapper.querySelector(
                        "#frequency .skip__button"
                    ).style.display = "none";
                });
            //Epidemy (indicator manage)
            this.els.$wrapper
                .querySelector(".select-all")
                .addEventListener("click", this.selectAllDiseases.bind(this));
            this.els.$wrapper
                .querySelector(".select-custom")
                .addEventListener("click", this.deselectAllDiseases.bind(this));
            //Epidemy Save button (indicator manage)
            this.els.$wrapper
                .querySelector("#update_epidemy .update__new__data")
                .addEventListener("click", function () {
                    this$1.saveEpidemySelection();
                    this$1.els.$wrapper
                        .querySelector("#update_epidemy .skip__button")
                        .click();
                });
            //Save passeword
            this.els.$wrapper
                .querySelector("#password .update__new__data")
                .addEventListener("click", function () {
                    this$1.updatePassword(
                        this$1.els.$wrapper.querySelector("#password .input-field").value
                    );
                    this$1.els.$wrapper.querySelector("#password .skip__button").click();
                    this$1.els.$wrapper.querySelector("#password .input-field").value = "";
                    this$1.calculatePercentage();
                });
            //Save firstname and lastname
            this.els.$wrapper
                .querySelector("#update_name .update__new__data")
                .addEventListener("click", function () {
                    this$1.updateName(
                        this$1.els.$wrapper.querySelector("#update_name .firstname").value,
                        this$1.els.$wrapper.querySelector("#update_name .lastname").value
                    );

                    this$1.els.$wrapper.querySelector("#update_name .skip__button").click();
                    this$1.els.$wrapper.querySelector("#update_name .firstname").value = "";
                    this$1.els.$wrapper.querySelector("#update_name .lastname").value = "";
                    this$1.calculatePercentage();
                });
            //Save email
            this.els.$wrapper
                .querySelector("#mail .update__new__data")
                .addEventListener("click", function () {
                    this$1.updateEmail(
                        this$1.els.$wrapper.querySelector("#mail .input-field").value
                    );
                    this$1.els.$wrapper.querySelector("#mail .skip__button").click();
                    this$1.els.$wrapper.querySelector("#mail .input-field").value = "";
                    this$1.calculatePercentage();
                });
            //Save phone
            this.els.$wrapper
                .querySelector("#phone .update__new__data")
                .addEventListener("click", function () {
                    this$1.updatePhone(
                        this$1.els.$wrapper.querySelector("#phone .input-field").value
                    );
                    this$1.els.$wrapper.querySelector("#phone .skip__button").click();
                    this$1.els.$wrapper.querySelector("#phone .input-field").value = "";
                    this$1.calculatePercentage();
                });

            //Save frequency
            this.els.$wrapper
                .querySelector("#frequency .update__new__data")
                .addEventListener("click", function () {
                    this$1.saveEntryMode();
                    this$1.els.$wrapper.querySelector("#frequency .skip__button").click();
                });
            this.calculatePercentage();

        },
        loadData: function loadData() {
            var this$1 = this;

            this.loadUserEntryMode();
            this.fetchAllEpidemy();
            this.getAllCpts();
            this.saveRequest = utils.sendHTTPRequest({
                url: ajaxurl,
                method: "POST",
                body: {
                    action: "get_all_user_data",
                },
            });
            this.saveRequest.promise
                .then(function (response) {
                    if (!response.success) ; else {
                        this$1.els.$userAddress = response.data.address;
                        if (!Array.isArray(this$1.els.$userAddress)) {
                            this$1.els.$userAddress = [];
                        }
                        this$1.els.$userEmail = response.data.email;
                        this$1.els.$userPhone = response.data.cellphone;
                        this$1.els.$userName =
                            response.data.firstname + " " + response.data.lastname;
                        this$1.els.$userRpps = response.data.rpps;
                        this$1.els.$userFirstName = response.data.firstname;
                        this$1.els.$userLastName = response.data.lastname;
                        this$1.els.$userSpecialty = response.data.specialty ? response.data.specialty : response.data.specialty.post_title;

                        this$1.dataIntoHtml();
                    }
                    this$1.saveRequest = null;
                })
                .catch(function () {
                    var messageError = "An error has occurred, please try again.";
                    console.error(messageError);
                    this$1.saveRequest = null;
                });
        },
        dataIntoHtml: function dataIntoHtml() {
            this.els.$userNameHtml.innerHTML = this.els.$userName;
            this.els.$userEmailHtml.innerHTML = this.els.$userEmail;
            this.els.$userPhoneHtml.innerHTML = this.els.$userPhone;
            this.els.$userRppsHtml.innerHTML = this.els.$userRpps;
            this.els.$userEpidemyHtml.innerHTML = this.els.$userEpidemy;

            if (this.els.$userSpecialtyHtml) {
                this.els.$userSpecialtyHtml.innerHTML = this.els.$userSpecialty;
            } else {
                this.els.$userSpecialtyHtml.innerHTML = 'Aucune spécialité';
            }
            //foreach the adress to add into html
            var listAdress = "";
            listAdress = "<ul>";

            if (this.els.$userAddress) {
                for (var i = 0; i < this.els.$userAddress.length; i++) {
                    listAdress +=
                        "<li>" +
                        this.els.$userAddress[i].street +
                        ", " +
                        this.els.$userAddress[i].postal_code +
                        " " +
                        this.els.$userAddress[i].city;
                    listAdress += this.els.$userAddress[i].cpts ? " - " + this.els.$userAddress[i].cpts[0].post_title : "";
                    listAdress += this.els.$userAddress[i].main_address
                        ? " (principale)</li>"
                        : "" + "</li>";
                }
                this.els.$userAddressHtml.innerHTML = listAdress + "</ul>";
            }
        },
        checkInputContent: function checkInputContent(input) {
            if (input.value.trim() !== "") {
                input.classList.add("has-content");
            } else if (!input.classList.contains("cpts__field")) {
                input.classList.remove("has-content");
            }
        },
        getUserEpidemy: function getUserEpidemy() {
            var this$1 = this;

            this.request = utils.sendHTTPRequest({
                url: ajaxurl,
                method: "POST",
                body: {
                    action: "get_user_indicators",
                },
            });

            this.request.promise
                .then(function (data) {
                    this$1.els.$userEpidemyJson = Array.isArray(data.data) ? data.data : [];
                    this$1.selectedDiseases = this$1.els.$userEpidemyJson.map(function (indicator) { return indicator.id; });

                    var indicatorText = this$1.els.$userEpidemyJson.length > 0
                        ? this$1.els.$userEpidemyJson.map(function (e) { return e.title; }).join(", ")
                        : "Aucun abonnement aux indicateurs";

                    this$1.els.$userEpidemyHtml.innerHTML = "<p>" + indicatorText + "</p>";
                    this$1.els.$accountFormFrequency = this$1.els.$wrapper.querySelector(".account__form__frequency");
                    if (this$1.selectedDiseases.length === 0) {
                        this$1.els.$accountFormFrequency.style.display = "none";
                    } else {
                        this$1.els.$accountFormFrequency.style.display = "block";
                    }

                    this$1.updateIndicatorButtons();

                })
                .catch(function (error) {
                    console.error("Erreur lors de la récupération des indicateurs :", error);
                    this$1.els.$userEpidemyHtml.innerHTML = "<p>Erreur lors du chargement des épidémies.</p>";
                });
        },
        selectAllDiseases: function selectAllDiseases() {
            if (this.selectedDiseases.length === this.allEpidemy.length) {
                this.selectedDiseases = [];
                this.els.$wrapper.querySelector(".select-all").checked = false;
            } else {
                this.selectedDiseases = this.allEpidemy.map(function (indicator) { return indicator.id; });
                this.els.$wrapper.querySelector(".select-all").checked = true;
            }
            this.updateIndicatorButtons();
        },
        deselectAllDiseases: function deselectAllDiseases() {
            this.selectedDiseases = [];
            this.els.$wrapper.querySelector(".select-custom").checked = true;
            this.updateIndicatorButtons();
        },
        updateIndicatorButtons: function updateIndicatorButtons() {
            var this$1 = this;

            var indicatorListDiv = this.els.$wrapper.querySelector(".indicator-list");

            indicatorListDiv.innerHTML = "";

            if (this.allEpidemy.length === 0) {
                this.updateSelectionState();
            }

            this.allEpidemy.forEach(function (indicator) {
                var isSelected = this$1.selectedDiseases.includes(indicator.id);
                var button = document.createElement("button");
                button.className = "indicator-btn " + (isSelected ? "selected" : "");
                button.textContent = indicator.title;
                button.dataset.indicatorId = indicator.id;

                button.addEventListener("click", function (e) {
                    var id = parseInt(e.target.dataset.indicatorId);
                    var index = this$1.selectedDiseases.indexOf(id);
                    if (index > -1) {
                        this$1.selectedDiseases.splice(index, 1);
                        e.target.classList.remove("selected");
                    } else {
                        this$1.selectedDiseases.push(id);
                        e.target.classList.add("selected");
                    }
                    this$1.updateSelectionState();
                });

                indicatorListDiv.appendChild(button);
            });
            this.updateSelectionState();
        },
        updateSelectionState: function updateSelectionState() {
            var allSelectedRadio = this.els.$wrapper.querySelector(".select-all");
            var allSelectedBtn = this.els.$wrapper.querySelector(".all-selected");
            var customSelectedBtn = this.els.$wrapper.querySelector(".custom-selected");
            var customSelectedRadio = this.els.$wrapper.querySelector(".select-custom");

            if (this.selectedDiseases.length === this.allEpidemy.length) {
                allSelectedRadio.checked = true;
                allSelectedBtn.classList.add("selected");
                customSelectedBtn.classList.remove("selected");
            } else {
                allSelectedRadio.checked = false;
                allSelectedBtn.classList.remove("selected");
                customSelectedBtn.classList.add("selected");
                customSelectedRadio.checked = true;
            }
        },
        saveEpidemySelection: function saveEpidemySelection() {
            var this$1 = this;

            var formData = new FormData();
            formData.append("action", "save_user_indicator_selection");
            var tabOfIndicators = [];
            this.selectedDiseases.forEach(function (indicatorId) {
                formData.append("indicator_subscription_0_indicator[]", indicatorId);
                tabOfIndicators.push(indicatorId);
            });

            if (this.selectedDiseases.length === 0) {
                var confirmationMessage = "Vous n’avez sélectionné aucun indicateur, êtes-vous sûr de ne pas vouloir contribuer ?";
                var confirmText = "Oui";
                var cancelText = "Non";
                modal.showModal(confirmationMessage, confirmText, cancelText, function () {
                    fetch(ajaxurl, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        body: 'action=set_user_indicator_empty',
                        credentials: 'same-origin',
                    })
                        .then(function (response) { return response.json(); })
                        .catch(function (error) {
                            console.error('Erreur réseau ou de serveur :', error);
                        });

                    location.reload();
                }, function () {
                    modal.closeModal();
                });
            }

            fetch(ajaxurl, {
                method: "POST",
                body: formData,
            })
                .then(function (response) { return response.json(); })
                .then(function (data) {
                    if (data.success) {
                        this$1.getUserEpidemy();
                        //find id into allEpidemy and add selected
                        this$1.els.$userEpidemy = "";
                        this$1.allEpidemy.forEach(function (indicator) {
                            tabOfIndicators.forEach(function (userIndicator) {
                                if (indicator.id === userIndicator) {
                                    if (this$1.els.$userEpidemy.length > 0) {
                                        this$1.els.$userEpidemy += ", ";
                                    }
                                    this$1.els.$userEpidemy += indicator.title;
                                }
                            });
                        });
                        //For no reload with ajax request
                        this$1.els.$userEpidemyAfterSave = true;
                        this$1.els.$userEpidemyHtml.innerHTML = this$1.els.$userEpidemy;
                        if (this$1.els.$userEpidemyHtml.innerHTML === "") {
                            this$1.els.$userEpidemyHtml.innerHTML =
                                "Aucun abonnement aux indicateurs";
                        }

                        this$1.calculatePercentage();
                    } else {
                        console.error(
                            "Erreur lors de la sauvegarde des indicateurs:",
                            data.data
                        );
                    }
                })
                .catch(function (error) {
                    console.error("Erreur AJAX lors de la sauvegarde:", error);
                });

            //Close part
            this.els.$wrapper.querySelector("#update_epidemy .skip__button").click();
            this.loadData();
        },
        updatePassword: function updatePassword(newPassword) {
            if (newPassword) {
                this.saveRequest = utils.sendHTTPRequest({
                    url: ajaxurl,
                    method: "POST",
                    body: {
                        action: "update_password",
                        params: JSON.stringify({
                            newPassword: newPassword,
                        }),
                    },
                });
            }
        },
        updateName: function updateName(newFirstname, newLastName) {
            var this$1 = this;

            if (newFirstname && newLastName) {
                this.saveRequest = utils.sendHTTPRequest({
                    url: ajaxurl,
                    method: "POST",
                    body: {
                        action: "update_name",
                        params: JSON.stringify({
                            newFirstname: newFirstname,
                            newLastname: newLastName,
                        }),
                    },
                });

                this.saveRequest.promise.then(function (response) {
                    if (response.success) {
                        this$1.els.$userNameHtml.innerHTML = newFirstname + " " + newLastName;
                        this$1.els.$userFirstName = newFirstname;
                        this$1.els.$userLastName = newLastName;
                    } else {
                        console.error("error", response.data);
                    }
                });
            }
        },
        updateEmail: function updateEmail(newEmail) {
            var this$1 = this;

            if (newEmail) {
                this.saveRequest = utils.sendHTTPRequest({
                    url: ajaxurl,
                    method: "POST",
                    body: {
                        action: "update_email",
                        params: JSON.stringify({
                            newEmail: newEmail,
                        }),
                    },
                });
                this.saveRequest.promise.then(function (response) {
                    if (response.success) {
                        this$1.els.$userEmailHtml.innerHTML = newEmail;
                        this$1.els.$userEmail = newEmail;
                    } else {
                        console.error("error when update mail");
                    }
                });
            }
        },
        updatePhone: function updatePhone(newPhone) {
            var this$1 = this;

            if (newPhone) {
                this.saveRequest = utils.sendHTTPRequest({
                    url: ajaxurl,
                    method: "POST",
                    body: {
                        action: "update_cellphone",
                        params: JSON.stringify({
                            newCellphone: newPhone,
                        }),
                    },
                });
                this.saveRequest.promise.then(function (response) {
                    if (response.success) {
                        this$1.els.$userPhoneHtml.innerHTML = newPhone;
                        this$1.els.$userPhone = newPhone;
                    } else {
                        console.error("error when update phone");
                    }
                });
            }
        },
        loadUserEntryMode: function loadUserEntryMode() {
            var this$1 = this;

            fetch(ajaxurl, {
                method: "POST",
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                body: new URLSearchParams({
                    action: "get_entry_mode",
                }),
            })
                .then(function (response) { return response.json(); })
                .then(function (data) {
                    this$1.entryMode = data.data.entryMode;

                    if (this$1.entryMode) {
                        if (this$1.entryMode.toLowerCase() === "weekly") {
                            this$1.els.$wrapper.querySelector("#frequency .form__data").innerHTML = "Une fois par semaine";
                        } else if (this$1.entryMode.toLowerCase() === "daily") {
                            this$1.els.$wrapper.querySelector("#frequency .form__data").innerHTML = "Une fois par jour";
                        } else {
                            this$1.els.$wrapper.querySelector("#frequency .form__data").innerHTML = "Aucun mode de saisie défini";
                        }
                    }

                    if (this$1.els.$wrapper.querySelector("#frequency .indicator-options")) {
                        this$1.els.$wrapper.querySelector("#frequency .indicator-options").remove();
                    }
                    if (this$1.els.$wrapper.querySelector("#update_frequency .title__data")) {
                        this$1.els.$wrapper.querySelector("#update_frequency .title__data").remove();
                    }

                    var frequencyHtml = "\n            <div>\n                <p class=\"title__data\">Fréquence de saisie des indicateurs</p>\n            </div>\n            <div class=\"indicator-options\">\n                <label class=\"selection-btn " + (this$1.entryMode === "daily" ? "selected" : "") + "\">\n                    <input type=\"radio\" name=\"frequency\" value=\"daily\" " + (this$1.entryMode === "daily" ? "checked" : "") + ">\n                    <span>Une fois par jour</span>\n                </label>\n                <label class=\"selection-btn " + (this$1.entryMode === "weekly" ? "selected" : "") + "\">\n                    <input type=\"radio\" name=\"frequency\" value=\"weekly\" " + (this$1.entryMode === "weekly" ? "checked" : "") + ">\n                    <span>Une fois par semaine</span>\n                </label>\n            </div>\n        ";
                    this$1.els.$wrapper.querySelector("#update_frequency .update__zone ").insertAdjacentHTML("afterbegin", frequencyHtml);

                    this$1.attachFrequencyEventListeners();
                })
                .catch(function (error) {
                    console.error("Erreur", error);
                });
        },
        attachFrequencyEventListeners: function attachFrequencyEventListeners() {
            var this$1 = this;

            var frequencyOptions = this.els.$wrapper.querySelectorAll('input[name="frequency"]');

            frequencyOptions.forEach(function (radio) {
                radio.addEventListener('change', function (event) {
                    this$1.updateFrequencySelection(event.target);
                });

                if (radio.checked) {
                    this$1.updateFrequencySelection(radio);
                }
            });
        },
        updateFrequencySelection: function updateFrequencySelection(selectedRadio) {
            var frequencyOptions = this.els.$wrapper.querySelectorAll('input[name="frequency"]');

            frequencyOptions.forEach(function (radio) {
                var label = radio.closest('.selection-btn');
                if (radio === selectedRadio) {
                    label.classList.add('selected');
                } else {
                    label.classList.remove('selected');
                }
            });
        },
        saveEntryMode: function saveEntryMode() {
            var this$1 = this;

            var frequencyInputs = this.els.$wrapper.querySelectorAll('input[name="frequency"]');

            frequencyInputs.forEach(function (input) {
                if (input.checked) {
                    this$1.entryMode = input.value;
                }
            });

            this.saveRequest = utils.sendHTTPRequest({
                url: ajaxurl,
                method: "POST",
                body: {
                    action: "save_entry_mode",
                    params: JSON.stringify({
                        entryMode: this.entryMode,
                    }),
                },
            });

            this.saveRequest.promise.then(function (response) {
                if (response.success) {
                    if (this$1.entryMode.toLowerCase() === "weekly") {
                        this$1.els.$wrapper.querySelector("#frequency .form__data").innerHTML = "Une fois par semaine";
                    } else {
                        this$1.els.$wrapper.querySelector("#frequency .form__data").innerHTML = "Une fois par jour";
                    }

                    this$1.attachFrequencyEventListeners();

                    this$1.calculatePercentage();
                } else {
                    console.error("Erreur lors de la sauvegarde du mode de saisie :", response.data);
                }
            }).catch(function (error) {
                console.error("Erreur AJAX lors de la sauvegarde du mode de saisie :", error);
            });
        },
        setupRadioListeners: function setupRadioListeners() {
            var allSelectedRadio = this.els.$wrapper.querySelector(".select-all");
            var customSelectedRadio = this.els.$wrapper.querySelector(".select-custom");

            allSelectedRadio.removeEventListener("change", this.handleAllSelectedBound);
            customSelectedRadio.removeEventListener("change", this.handleCustomSelectedBound);

            this.handleAllSelectedBound = this.handleAllSelected.bind(this);
            this.handleCustomSelectedBound = this.handleCustomSelected.bind(this);

            allSelectedRadio.addEventListener("change", this.handleAllSelectedBound);
            customSelectedRadio.addEventListener("change", this.handleCustomSelectedBound);
        },

        handleAllSelected: function handleAllSelected(event) {
            if (event.target.checked) {
                this.selectedDiseases = this.allEpidemy.map(function (indicator) { return indicator.id; });
                this.updateIndicatorButtons();
            }
        },

        handleCustomSelected: function handleCustomSelected(event) {
            if (event.target.checked) {
                this.selectedDiseases = [];
                this.updateIndicatorButtons();
            }
        },
        fetchAllEpidemy: function fetchAllEpidemy() {
            var this$1 = this;

            utils.sendHTTPRequest({
                url: ajaxurl,
                method: "POST",
                body: {
                    action: "get_all_indicator",
                },
            }).promise.then(function (response) {
                if (response.success) {
                    this$1.allEpidemy = response.data;
                    this$1.getUserEpidemy();
                } else {
                    console.error("Erreur lors de la récupération des indicateurs :", response.data);
                }
            }).catch(function (error) {
                console.error("Erreur AJAX lors de la récupération des indicateurs :", error);
            });
        },
        toogleEpidemySelection: function toogleEpidemySelection() {
            var wrapper = this.els.$wrapper;
            var isAllSelected = this.allEpidemy.length === this.els.$userEpidemyJson.length;
            var hasSelected = this.els.$userEpidemyJson.length > 0;

            var handleRadioClick = function (event) {
                wrapper.querySelectorAll("#update_epidemy .selection-btn").forEach(function (btn) { return btn.classList.remove("selected"); });
                var target = event.currentTarget;
                if (target.checked) {
                    target.closest("#update_epidemy .selection-btn").classList.add("selected");
                }
            };

            wrapper.querySelectorAll('#update_epidemy input[type="radio"][name="selection"]').forEach(function (radio) {
                radio.removeEventListener("click", handleRadioClick);
                radio.addEventListener("click", handleRadioClick);
            });

            if (isAllSelected) {
                this.els.$wrapper.querySelector("#update_epidemy .all-selected input").checked = true;
                this.els.$wrapper.querySelector("#update_epidemy .all-selected .select-all").click();
                this.els.$wrapper.querySelector("#update_epidemy .all-selected").classList.add("selected");
                this.els.$wrapper.querySelector("#update_epidemy .custom-selected").classList.remove("selected");
            }
            if (hasSelected && !isAllSelected) {
                this.els.$wrapper.querySelector("#update_epidemy .custom-selected .select-custom").click();
                this.els.$wrapper.querySelector("#update_epidemy .custom-selected").classList.add("selected");
                this.els.$wrapper.querySelector("#update_epidemy .all-selected").classList.remove("selected");
            }
            var allSelectedEl = wrapper.querySelector("#update_epidemy .all-selected");
            var customSelectedEl = wrapper.querySelector("#update_epidemy .custom-selected");

            if (isAllSelected) {
                allSelectedEl.classList.add("selected");
                customSelectedEl.classList.remove("selected");
            } else if (hasSelected) {
                allSelectedEl.classList.remove("selected");
                customSelectedEl.classList.add("selected");
            } else {
                allSelectedEl.classList.remove("selected");
                customSelectedEl.classList.remove("selected");
            }
        },
        //Address part
        showAddAddressForm: function showAddAddressForm() {
            var this$1 = this;

            var $updateAddress = this.els.$wrapper.querySelector("#update_address");
            this.els.$wrapper.querySelector("#addressInput").value = "";
            this.els.$wrapper.querySelector("#postalCodeInput").value = "";
            this.els.$wrapper.querySelector("#cityInput").value = "";
            this.els.$wrapper.querySelector("#cptsInput");
            $updateAddress.querySelector("#cptsInput").classList.add("has-content");

            this.els.$wrapper.querySelector(
                " #update_address .save_address__container"
            ).style.display = "none";
            $updateAddress.querySelector(".add__address__form").style.display = "block";
            $updateAddress.querySelector("#add__address__btn").style.display = "none";
            $updateAddress.querySelector("#addresses-list").style.display = "none";

            this.checkInputContent(this.els.$wrapper.querySelector("#addressInput"));
            this.checkInputContent(this.els.$wrapper.querySelector("#postalCodeInput"));
            this.checkInputContent(this.els.$wrapper.querySelector("#cityInput"));

            this.els.$wrapper
                .querySelector("#update_address .button-cancel")
                .addEventListener("click", function () {
                    this$1.hideAddAddressForm();
                });
            //add address button
            this.els.$wrapper
                .querySelector("#update_address .confirm-address")
                .addEventListener("click", function () {
                    this$1.addAddress();
                });
        },

        hideAddAddressForm: function hideAddAddressForm() {
            var $updateAddress = this.els.$wrapper.querySelector("#update_address");
            $updateAddress.querySelector(".add__address__form").style.display = "none";
            $updateAddress.querySelector("#add__address__btn").style.display = "flex";
            $updateAddress.querySelector("#addresses-list").style.display = "flex";
            this.els.$wrapper.querySelector(
                " #update_address .save_address__container"
            ).style.display = "block";
            $updateAddress.querySelector("#cptsInput").value = '';
        },

        addAddress: function addAddress() {
            var $updateAddress = this.els.$wrapper.querySelector("#update_address");
            var addressInput = $updateAddress.querySelector("#addressInput").value;
            var postalCodeInput = $updateAddress.querySelector("#postalCodeInput").value;
            var cityInput = $updateAddress.querySelector("#cityInput").value;
            var cpts = $updateAddress.querySelector("#cptsInput").value;

            if (addressInput && postalCodeInput && cityInput) {
                if (!Array.isArray(this.els.$userAddress)) {
                    this.els.$userAddress = [];
                }

                var addressAlreadyExist = false;
                this.els.$userAddress.forEach(function (address) {
                    if (
                        address.street === addressInput &&
                        address.postal_code === postalCodeInput &&
                        address.city === cityInput
                    ) {
                        addressAlreadyExist = true;
                    }
                });
                if (!addressAlreadyExist) {
                    var isFirstAddress = this.els.$userAddress.length === 0;
                    this.els.$userAddress.push({
                        street: addressInput,
                        postal_code: postalCodeInput,
                        city: cityInput,
                        main_address: isFirstAddress,
                        cpts: cpts,
                    });
                    this.updateAddressesList();
                    this.hideAddAddressForm();
                } else {
                    var buttonEffect = this.els.$wrapper.querySelector(".confirm-address");
                    buttonEffect.classList.add("vibrate");
                    setTimeout(function () {
                        buttonEffect.classList.remove("vibrate");
                    }, 500);
                }
            }
        },
        updateAddressesList: function updateAddressesList() {
            var this$1 = this;

            var $updateAddress = this.els.$wrapper.querySelector("#update_address");
            var addressesList = $updateAddress.querySelector("#addresses-list");
            addressesList.innerHTML = "";

            if (this.els.$userAddress) {
                this.els.$userAddress.forEach(function (address, index) {
                    var cptsName = '';

                    if (address.cpts && address.cpts[0] && address.cpts[0].post_title) {
                        cptsName = address.cpts[0].post_title;
                    } else if (address.cpts) {
                        var cpt = this$1.allCpts.find(function (cpt) { return cpt.id === address.cpts; });
                        if (cpt) {
                            cptsName = cpt.title;
                        } else {
                            cptsName = '';
                        }
                    }

                    var listItem = document.createElement("div");
                    listItem.innerHTML = "\n                <div class=\"address-item " + (address.main_address ? 'address-item--selected' : '') + "\" data-index=\"" + index + "\">\n                    <div>\n                        <label for=\"addressRadio-" + index + "\" class=\"address-label\">\n                            <div class=\"d-flex\">\n                                <input type=\"radio\" id=\"addressRadio-" + index + "\" data-index=\"" + index + "\" name=\"primaryAddress\" class=\"primary-address-button\" " + (address.main_address ? "checked" : "") + ">\n                                <div class=\"address-text\">\n                                    <p>" + (address.city) + " (" + (address.postal_code) + ")</p>\n                                    <span class=\"address-detail\">" + (address.street) + "</span>\n                                    <span class=\"address-cpts-name\">" + cptsName + "</span>\n                                </div>\n                            </div>\n                            <div class=\"btn__container\">\n                                <button type=\"button\" class=\"delete-button\" data-index=\"" + index + "\">\n                                    <svg " + (this$1.els.$userAddress.length === 1 ? 'style="display:none"' : '') + " xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"16\" viewBox=\"0 0 14 16\">\n                                        <path id=\"Icon_awesome-trash-alt\" data-name=\"Icon awesome-trash-alt\" d=\"M1,14.5A1.5,1.5,0,0,0,2.5,16h9A1.5,1.5,0,0,0,13,14.5V4H1Zm8.5-8a.5.5,0,1,1,1,0v7a.5.5,0,1,1-1,0Zm-3,0a.5.5,0,0,1,1,0v7a.5.5,0,0,1-1,0Zm-3,0a.5.5,0,0,1,1,0v7a.5.5,0,0,1-1,0ZM13.5,1H9.75L9.456.416A.75.75,0,0,0,8.784,0H5.213a.741.741,0,0,0-.669.416L4.25,1H.5a.5.5,0,0,0-.5.5v1A.5.5,0,0,0,.5,3h13a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,13.5,1Z\" transform=\"translate(0 0)\" fill=\"#1267a8\"/>\n                                    </svg>\n                                </button>\n                                <button type=\"button\" class=\"edit-button\" data-index=\"" + index + "\">Modifier l'adresse</button>\n                            </div>\n                        </label>\n                    </div>\n                </div>\n          ";
                    addressesList.appendChild(listItem);
                });
            }

            this.els.$wrapper
                .querySelectorAll("#update_address .edit-button")
                .forEach(function (button) {
                    button.addEventListener("click", function (event) {
                        var index = event.target.getAttribute("data-index");
                        this$1.editAddress(index);
                    });
                });

            this.els.$wrapper
                .querySelectorAll("#update_address .delete-button")
                .forEach(function (button) {
                    button.addEventListener("click", function () {
                        var index = button.getAttribute("data-index");

                        this$1.showConfirmationModal(index);
                    });
                });

            this.els.$wrapper
                .querySelectorAll("#update_address .primary-address-button")
                .forEach(function (button) {
                    button.addEventListener("click", function (event) {
                        var index = button.getAttribute("data-index");

                        this$1.updateMainAddress(index);
                        this$1.updateAddressItemSelectedClass();
                    });
                });
        },
        updateAddressItemSelectedClass: function updateAddressItemSelectedClass() {
            var this$1 = this;

            var addressItems = this.els.$wrapper.querySelectorAll("#update_address .address-item");
            addressItems.forEach(function (item) {
                var index = item.getAttribute("data-index");
                var address = this$1.els.$userAddress[index];
                if (address.main_address) {
                    item.classList.add("address-item--selected");
                } else {
                    item.classList.remove("address-item--selected");
                }
            });
        },
        deleteAddress: function deleteAddress(index) {
            var wasMain = this.els.$userAddress[index].main_address;
            this.els.$userAddress.splice(index, 1);

            if (wasMain && this.els.$userAddress.length > 0) {
                this.els.$userAddress[0].main_address = true;
            }

            this.updateAddressesList();
        },
        loadUserAddresses: function loadUserAddresses() {
            if (this.els.$userAddress && this.els.$userAddress.length > 0) {
                this.updateAddressesList();
            }
        },
        editAddress: function editAddress(index) {
            var this$1 = this;

            var $updateAddress = this.els.$wrapper.querySelector("#update_address");
            var address = this.els.$userAddress[index];

            $updateAddress.querySelector("#addressInput").value = address.street;
            $updateAddress.querySelector("#addressInput").classList.add("has-content");
            $updateAddress.querySelector("#postalCodeInput").value =
                address.postal_code;
            $updateAddress
                .querySelector("#postalCodeInput")
                .classList.add("has-content");
            $updateAddress.querySelector("#cptsInput").classList.add("has-content");

            if (address.cpts) {
                $updateAddress.querySelector("#cptsInput").value = address.cpts[0].ID;
            } else {
                $updateAddress.querySelector("#cptsInput").value = '';
            }

            $updateAddress.querySelector("#cityInput").value = address.city;
            $updateAddress.querySelector("#cityInput").classList.add("has-content");
            this.els.$wrapper.querySelector(
                " #update_address .save_address__container"
            ).style.display = "none";
            $updateAddress.querySelector(".add__address__form").style.display = "block";
            $updateAddress.querySelector("#add__address__btn").style.display = "none";
            $updateAddress.querySelector("#addresses-list").style.display = "none";

            this.currentEditingIndex = index;

            this.els.$wrapper
                .querySelector("#update_address .button-cancel")
                .addEventListener("click", function () {
                    this$1.hideAddAddressForm();
                });

            this.els.$wrapper
                .querySelector("#update_address .confirm-address")
                .addEventListener("click", function () {
                    this$1.saveEditedAddress();
                    this$1.currentEditingIndex = null;
                });
        },

        saveEditedAddress: function saveEditedAddress() {
            var $updateAddress = this.els.$wrapper.querySelector("#update_address");
            var addressInput = $updateAddress.querySelector("#addressInput").value;
            var postalCodeInput =
                $updateAddress.querySelector("#postalCodeInput").value;
            var cityInput = $updateAddress.querySelector("#cityInput").value;
            var cpts = $updateAddress.querySelector("#cptsInput").value;
            if (
                addressInput &&
                postalCodeInput &&
                cityInput &&
                this.currentEditingIndex !== null
            ) {
                this.els.$userAddress[this.currentEditingIndex].street = addressInput;
                this.els.$userAddress[this.currentEditingIndex].postal_code =
                    postalCodeInput;
                this.els.$userAddress[this.currentEditingIndex].city = cityInput;
                this.els.$userAddress[this.currentEditingIndex].cpts = cpts;

                this.updateAddressesList();
                this.hideAddAddressForm();
            } else {
                var buttonEffect = this.els.$wrapper.querySelector(".confirm-address");
                buttonEffect.classList.add("vibrate");
                setTimeout(function () {
                    buttonEffect.classList.remove("vibrate");
                }, 500);
            }
        },
        updateAddressInDatabase: function updateAddressInDatabase() {
            var this$1 = this;

            if (!Array.isArray(this.els.$userAddress)) {
                this.els.$userAddress = [];
            }

            this.saveRequest = utils.sendHTTPRequest({
                url: ajaxurl,
                method: "POST",
                body: {
                    action: "update_address",
                    params: JSON.stringify({
                        newAddress: this.els.$userAddress,
                    }),
                },
            });
            this.saveRequest.promise
                .then(function (response) {
                    if (response.success) {
                        this$1.updateAddressesList();
                    } else {
                        console.error("Error updating address:", response.data || response);
                    }
                    this$1.saveRequest = null;
                })
                .catch(function (error) {
                    console.error("AJAX error updating address:", error);
                    this$1.saveRequest = null;
                });

            // Attendez 300ms pour que les données soient mises à jour
            setTimeout(function () {
                this$1.loadData();
                this$1.dataIntoHtml();
            }, 300);
        },
        updateMainAddress: function updateMainAddress(index) {
            index = parseInt(index, 10);
            this.els.$userAddress.forEach(function (address, i) {
                address.main_address = i === index;
            });
            this.updateAddressesList();
        },
        greyOutSection: function greyOutSection(name) {
            var section = this.els.$wrapper.querySelectorAll(".account__form__field");
            var fixedSection = this.els.$wrapper.querySelector(".account__form__field__specialty");
            section.forEach(function (section) {
                section.classList.add("greyOut");
                section.querySelector(".update__button").disabled = true;
            });
            fixedSection.classList.add("greyOut");
            this.els.$wrapper.querySelector(("#" + name + " ")).classList.remove("greyOut");

            if (name === "address") {
                this.els.$wrapper
                    .querySelector(("#" + name + " .account__form__field"))
                    .classList.remove("greyOut");
            }
        },
        clearSection: function clearSection() {
            var section = this.els.$wrapper.querySelectorAll(".account__form__field");
            var fixedSection = this.els.$wrapper.querySelector(".account__form__field__specialty");
            section.forEach(function (section) {
                section.classList.remove("greyOut");
                section.querySelector(".update__button").disabled = false;
            });
            fixedSection.classList.remove("greyOut");
        },
        calculatePercentage: function calculatePercentage() {
            fetch(ajaxurl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: 'action=get_profile_completion_percentage',
                credentials: 'same-origin',
            })
                .then(function (response) { return response.json(); })
                .then(function (data) {
                    if (data.success) {
                        var total = data.data.percentage;

                        document.querySelector(".progress__bar__container .progress__bar").style.width = total + "%";
                        document.querySelector(".progress__text").innerText = total + "%";
                        if (total !== 100) {
                            localStorage.removeItem('profileComplete');
                            localStorage.removeItem('profileFireworks');
                        } else {
                            localStorage.setItem('profileComplete', true);
                            if (!localStorage.getItem('profileFireworks')) {
                                var page = document.querySelector('#page');
                                page.classList.add('fireworks');
                                var interval = setInterval(ProfileCompletion.createFirework, 200);
                                setTimeout(function () {
                                    clearInterval(interval);
                                    document.querySelectorAll('.particle').forEach(function (particle) { return particle.remove(); });
                                    page.classList.remove('fireworks');
                                }, 5000);

                            }
                            localStorage.setItem('profileFireworks', true);

                        }
                    } else {
                        console.error('Erreur lors de la récupération du pourcentage :', data.data);
                    }
                })
                .catch(function (error) {
                    console.error('Erreur réseau ou de serveur :', error);
                });
        },
        getAllCpts: function getAllCpts() {
            var this$1 = this;

            this.saveRequest = utils.sendHTTPRequest({
                url: ajaxurl,
                method: "POST",
                body: {
                    action: "get_all_cpts",
                },
            });
            return this.saveRequest.promise
                .then(function (response) {
                    if (response.success) {
                        var cptsInput = this$1.els.$wrapper.querySelector("#cptsInput");
                        var defaultOption = document.createElement("option");
                        defaultOption.value = "";
                        defaultOption.text = "Sélectionner une CPTS";
                        defaultOption.selected = true;
                        defaultOption.disabled = false;
                        cptsInput.appendChild(defaultOption);

                        this$1.allCpts = response.data;

                        this$1.allCpts.forEach(function (cpt) {
                            var option = document.createElement("option");
                            option.value = cpt.id;
                            option.text = cpt.title;
                            cptsInput.appendChild(option);
                        });
                    } else {
                        console.error("Erreur lors de la récupération des CPTs :", response.data);
                    }
                })
                .catch(function (error) {
                    console.error("Erreur lors de la récupération des CPTs :", error);
                });
        },
        showConfirmationModal: function showConfirmationModal(index) {
            var this$1 = this;

            var message = "Êtes-vous sûr de vouloir supprimer cette adresse ?";
            var confirmText = "Confirmer";
            var cancelText = "Annuler";
            modal.showModal(
                message,
                confirmText,
                cancelText,
                function () {
                    this$1.deleteAddress(index);
                    modal.closeModal();
                },
                function () {
                    modal.closeModal();
                }
            );
        },
        loadUserAddress: function loadUserAddress() {
            var this$1 = this;

            fetch(ajaxurl, {
                method: "POST",
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                body: new URLSearchParams({
                    action: "get_user_address",
                }),
            })
                .then(function (response) { return response.json(); })
                .then(function (data) {
                    this$1.els.$userAddress = data.data.address;
                })
                .catch(function (error) {
                    console.error("Erreur", error);
                });
        }
    };

    var SuportForm = {
        els: {
            assistanceBtn: null,
            modalCloseBtn: null,
            cancelBtn: null,
            sendBtn: null,
            objectInput: null,
            requestInput: null,
            inputFields: null,
            formContainer: null,
            supportFormSuccess: null,
            supportFormError: null,
            closeSupportForm: null,
            retryForm: null,
        },
        init: function init() {
            this.els.$wrapper = document.getElementById('support-form');
            if (this.els.$wrapper) {
                this.setupElements();
                this.bindEvents();
            }
        },
        setupElements: function setupElements() {
            this.els.assistanceBtn = document.getElementById('assistance');
            this.els.modalCloseBtn = document.getElementById('support-close');
            this.els.cancelBtn = document.getElementById('cancelBtn');
            this.els.sendBtn = document.getElementById('sendBtn');
            this.els.objectInput = document.getElementById('objectInput');
            this.els.requestInput = document.getElementById('requestInput');
            this.els.inputFields = document.querySelectorAll(".label__container input, .label__container textarea");
            this.els.formContainer = document.querySelector('.form__container');
            this.els.supportFormSuccess = document.getElementById('support-form-success');
            this.els.supportFormError = document.getElementById('support-form-error');
            this.els.closeSupportForm = document.getElementById('closeSupportForm');
            this.els.retryForm = document.getElementById('retryForm');
        },
        bindEvents: function bindEvents() {
            var this$1 = this;

            this.els.assistanceBtn.addEventListener('click', this.toggleForm.bind(this));
            this.els.modalCloseBtn.addEventListener('click', this.hideForm.bind(this));
            this.els.cancelBtn.addEventListener('click', this.hideForm.bind(this));
            this.els.sendBtn.addEventListener('click', this.sendForm.bind(this));
            this.els.closeSupportForm.addEventListener('click', this.hideForm.bind(this));
            this.els.retryForm.addEventListener('click', this.retrySupportForm.bind(this));

            this.els.inputFields.forEach(function (input) {
                input.addEventListener("input", function () { return this$1.checkInputContent(input); });
                input.addEventListener("focus", function () { return this$1.checkInputContent(input); });
                input.addEventListener("blur", function () { return this$1.checkInputContent(input); });
            });
        },
        toggleForm: function toggleForm() {
            this.els.$wrapper.classList.toggle('active');
            this.els.formContainer.style.display = "flex";
        },
        hideForm: function hideForm(event) {
            var this$1 = this;

            event.stopImmediatePropagation();
            this.els.$wrapper.classList.remove('active');

            setTimeout(function () {
                this$1.resetForm();
            }, 300);

            this.els.supportFormSuccess.style.display = "none";
            this.els.supportFormError.style.display = "none";
        },
        sendForm: function sendForm() {
            var this$1 = this;

            if (!this.els.formContainer.checkValidity()) {
                return;
            }

            event.preventDefault();

            this.saveRequest = utils.sendHTTPRequest({
                url: ajaxurl,
                method: 'POST',
                body: {
                    action: 'support_form_email',
                    params: JSON.stringify({
                        object: this.els.objectInput.value,
                        request: this.els.requestInput.value,
                    })
                },
            });

            this.saveRequest.promise.then(function (response) {
                if (response.success) {
                    this$1.displaySuccessMessage();
                } else {
                    this$1.displayErrorMessage(response.data);
                    this$1.resetForm();
                }
            }).catch(function (error) {
                this$1.displayErrorMessage();
                this$1.resetForm();
                console.error(error);
            });
        },
        checkInputContent: function checkInputContent(input) {
            if (input.value.trim() !== "") {
                input.classList.add("has-content");
            } else {
                input.classList.remove("has-content");
            }
        },
        displaySuccessMessage: function displaySuccessMessage() {
            this.els.formContainer.style.display = "none";
            this.els.supportFormSuccess.style.display = "block";
        },
        displayErrorMessage: function displayErrorMessage() {
            this.els.formContainer.style.display = "none";
            this.els.supportFormError.style.display = "block";
        },
        retrySupportForm: function retrySupportForm() {
            this.els.formContainer.style.display = "flex";
            this.els.supportFormError.style.display = "none";
        },
        resetForm: function resetForm() {
            this.els.objectInput.value = "";
            this.els.requestInput.value = "";
            this.els.inputFields.forEach(function (input) {
                input.classList.remove("has-content");
            }, this);
        }
    };

    (function () {
        Registration.init();
        Settings.init();
        MissingData.init();
        Charts.init();
        MissingPassword.init();
        Register.init();
        Dashboard.init();
        Login.init();
        DataForm.init();
        Alerts.init();
        Surveys.init();
        Header.init();
        SuportForm.init();
        MyAccount.init();
        IndicatorCalendar.init();
    })();

})));
//# sourceMappingURL=medvigie.min.js.map
